<template>
  <div> 
    <div class="whatmore-base" v-if="showWhatmoreBaner">
      <div id="whatmoreShopId" :data="contentKey"></div>
      <div id="whatmoreProductId" data=""></div>
      <div id="whatmoreExtensionType" data="product"></div>
      <div id="whatmoreVariantId" data=""></div>
      <div id="whatmoreEmbedAppPositionPortrait" data="right"></div>
      <div id="whatmoreEmbedAppHorizontalPaddingPortrait" data="5"></div>
      <div id="whatmoreEmbedAppVerticalPaddingPortrait" data="140"></div>
      <div id="whatmoreEmbedAppVideoPlayerSizePortrait" data="60"></div>
      <div id="whatmoreEmbedAppPositionLandscape" data="right"></div>
      <div id="whatmoreEmbedAppHorizontalPaddingLandscape" data="5"></div>
      <div id="whatmoreEmbedAppVerticalPaddingLandscape" data="129"></div>
      <div id="whatmoreEmbedAppVideoPlayerSizeLandscape" data="76"></div>
      <div id="whatmoreEmbedAppUseVariant" data="false"></div>
      <div id="whatmoreEmbedAppVideoTitle" data=""></div>
      <div id="whatmoreIsInDesignMode" data="false"></div>
	    <div class="whatmore-template-type" data="template-embed"> </div>
	    <div class="whatmore-widget" data="embed"></div>
      <div class="whatmore-render-root"></div>
    </div>
    <div v-if="newDesignMweb && !$parent.isDesktop">
      <ProductDetailMweb :colorWebHeader="colorWebHeader" :isColorWebEnable="isColorWebEnable" :prodRedirection="prodRedirection" />
    </div>
    <div v-else>
      <div ref="bannerSection" class="new-design-banner text-center" v-if="isNewDesign">
        <div v-if="$parent.isDesktop">
          <div class="round-back-icon round-share-icon" @click="goToPreviousPage">
            <img src="https://tss-static-images.gumlet.io/back-icon.png" alt="" />
          </div>
          <div class="round-share-icon" @click="newDesignShare = !newDesignShare">
            <img src="https://tss-static-images.gumlet.io/share-icon.png" alt="" />
          </div>
        </div>
        <transition name="slide">
        <div v-if="newDesignShare" class="sharebtns f22 new-design-share" @click="open">
          <social-sharing :url="tss + $route.path" inline-template :title="product.product">
            <div>
              <network network="whatsapp" class="showmobile disinline f24" v-if="!$parent.isDesktop" id="whatsapp">
                <i class="fa fa-fw fa-whatsapp"></i>
              </network>
              <a :href="'https://web.whatsapp.com/send?text=https://www.thesouledstore.com'+this.$route.fullPath" class="nonecolor showdesktoplinine" target="_blank" rel="noopener noreferrer" id="whatsapp"><span
                class="fa fa-whatsapp"></span></a>
              <network network="facebook" id="facebook">
                <i class="fa fa-fw fa-facebook-square"></i>
              </network>
              <network network="twitter" id="twitter">
                <i class="fa fa-fw fa-twitter"></i>
              </network>
              <a href="https://www.instagram.com/TheSouledStore/" class="nonecolor" target="_blank" rel="noopener noreferrer" id="instagram"><span
                class="fa fa-instagram"></span></a>
            </div>
          </social-sharing>
        </div>
        </transition>
        <div v-if="!$parent.isDesktop" class="round-share-icon" @click="shareNavigatorHandler">
          <img src="https://tss-static-images.gumlet.io/share-icon.png" alt="" />
        </div>
        <NewDesignBanner :product="product" :isDesktop="$parent.isDesktop" :categoryWiseImages="product.images" />
      </div>
      <link v-if="canonicalUrl0" rel="canonical" :href="canonicalUrl0" />
      <link v-if="canonicalUrl" rel="canonical" :href="canonicalUrl" />
      <SizeChartModal
        v-if="isSizeChartVisible"
        :selectedVariantSize="selectedProductVariant && selectedProductVariant.size"
        :sizeChartDetailData="productWiseSizeChartData"
        :stock="product.prod_type === 6 ? commonComboVariantsProd ? [...commonComboVariantsProd.variant] : (selectedComboSizeChart && selectedComboSizeChart.option && selectedComboSizeChart.option.variants && [...selectedComboSizeChart.option.variants]) || [] : [...product.variant]"
        :productImage="product.prod_type === 6 ? commonComboVariantsProd ? [...this.getComboVarientImages(commonComboVariantsProd.images_new)] : (selectedComboSizeChart && selectedComboSizeChart.variant && this.getComboVarientImages(selectedComboSizeChart.variant.images_new)) || [] : [...product.images]"
        :sizeChartTitle="product.prod_type === 6 ? commonComboVariantsProd ? commonComboVariantsProd.category : selectedComboSizeChart && selectedComboSizeChart.variant && selectedComboSizeChart.variant.category : product.category"
        v-on:updateVariant="updateSizeVariant($event)"
        :prodType="product.prod_type"
        :sizeChartVisibility="sizeChartVisibilityHandler"
        :productDetails="product"
        :isCommonComboVariantProd="commonComboVariantsProd"
      >
      </SizeChartModal>
      <ProductZoomModal
        v-if="productZoomMobile"
        :imgArray="product.images"
        :activeImg="magActiveimg"
        :videoUrl="product.video_url"
        :isVideoActive="product.show_video_url"
        :videoIndex="product.video_url_index"
        v-on:closeProdZoomModal="closeProductZoomModal($event)"
      >
      </ProductZoomModal>
      <div v-show="!sizevalid" class="pAdded"></div>
      <div v-if="isLoading">
        <Loader />
      </div>
      <div v-else-if="notFound && !isLoading && noProductAllowed">
        <NoProductFoundListing 
        :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist"
        />
      </div>
      <div class="productdetails conbottom" v-else>
        <div class="pagebanner doodleban pbg" v-if="productSlug === 'bevarsi-kudka-tshirt'">
          <img :data-src="staticImg+'banners/bevarsi-banner-desktop.jpg'" v-if="this.$parent.isDesktop" alt="bevarsi-kudka-tshirt"/>
          <img :data-src="staticImg+'banners/bevarsi-banner-mobile.jpg'" v-else alt="bevarsi-kudka-tshirt"/>
        </div>
        <div class="pagebanner doodleban pbg" v-if="bannerName && productSlug !== 'batman-active-wear-tshirt'">
          <img :data-src="staticImg+'banners/' + bannerName + '-desktop.jpg'" v-if="this.$parent.isDesktop" :alt="bannerName"/>
          <img :data-src="staticImg+'banners/' + bannerName + '-mobile.jpg'" v-else :alt="bannerName"/>
        </div>
        <!--  -->
        <div class="pagebanner doodleban pbg" v-else-if="productSlug === 'batman-active-wear-tshirt' && now >= endDate">
          <img :data-src="staticImg+'banners/' + bannerName + '-desktop.jpg'" v-if="this.$parent.isDesktop" alt="batman-active-wear-tshirt"/>
          <img :data-src="staticImg+'banners/' + bannerName + '-mobile.jpg'" v-else alt="batman-active-wear-tshirt"/>
        </div>
        <div class="pagebanner doodleban pbg" v-else-if="productSlug === 'hourly-deals' && now >= endDate">
          <img :data-src="staticImg+'banners/' + bannerName + '-desktop.jpg'" v-if="this.$parent.isDesktop" alt="hourly-deals"/>
          <img :data-src="staticImg+'banners/' + bannerName + '-mobile.jpg'" v-else alt="hourly-deals"/>
        </div>
        <div class="pagebanner doodleban pbg" v-if="gifName">
          <img :data-src="staticImg+'banners/' + gifName + '-desktop.jpg'" v-if="this.$parent.isDesktop" :alt="gifName"/>
          <img :data-src="staticImg+'banners/' + gifName + '-mobile.jpg'" v-else :alt="gifName"/>
        </div>
        <Countdown
          :starttime="startDate"
          :endtime="endDate"
          :color="timerColor"
          v-if="showCountDown && $parent.isDesktop"
          :showTimer="showTimer"
          :pretext="liveSaleText"
          v-on:getLiveSaleText="getSaleTextToShow"
          :showEarlyText="showEarlyText"
        />
        <ExcBand v-if="!isExclusive && showExcBar"
          v-on:addExc="addExclusiveToCartFromBand"
          :checkedExcBox="isNotifyVisible"
          :showExcStyle="excBand.showExcStyle"
          :excBannerMsg="excBand.excText"
        >
        </ExcBand>
        <BannerPlaceHolderMsg
          v-if="bannerPlaceHolderPDP && bannerPlaceHolderPDP.status"
          :bannerStyle="bannerPlaceHolderPDP && bannerPlaceHolderPDP.styles"
          :bannerMsg="bannerPlaceHolderPDP && bannerPlaceHolderPDP.text"
        >
        </BannerPlaceHolderMsg>
        <BannerPlaceHolderMsg
          v-if="bannerPlaceHolderPDPWithCat && bannerPlaceHolderPDPWithCat.status"
          :bannerStyle="bannerPlaceHolderPDPWithCat && bannerPlaceHolderPDPWithCat.styles"
          :bannerMsg="bannerPlaceHolderPDPWithCat && bannerPlaceHolderPDPWithCat.text"
        >
        </BannerPlaceHolderMsg>
        <div class="text-center exclusive-bar" v-else-if="productSlug === 'black-panther-proutility-backpack' && !isExclusive && !isSouledOut && now < endDate">
          <span style="font-size: 18px;">
            <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
              <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusiveToCart(EXCLUSIVE_PRODUCTS[2].prod_id)">
              <label for="" class="mb0 pl-4">{{earlyAccessText}}</label>
            </div>
          </span>
        </div>
        <div class="text-center exclusive-bar" v-if="productSlug === 'batman-3d-logo-tshirt' && now > startDate && now < endDate && !isExclusive">
          <span style="font-size: 18px;">
            <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
              <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusive(EXCLUSIVE_PRODUCTS[2].prod_id)">
              <label for="" class="mb0 pl-4">{{earlyAccessText}}</label>
            </div>
          </span>
        </div>
        <div class="text-center" style=" background-color: #3498db; color: #fff; padding: 10px;" v-if="productSlug === 'batman-active-wear-tshirt' && now < endDate && now >= startDate">
          <span style="font-size: 18px;" v-if="now >= startDate && now <= exclusiveDate">Early Access for Exclusive members opens at 10 AM on {{formatDate(exclusiveDate)}}</span>
          <span style="font-size: 25px;" v-else-if="now >= exclusiveDate && isExclusive">Early Access is open for you</span>
          <span style="font-size: 18px;" v-else-if="now >= exclusiveDate && !isExclusive">
            <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
              <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusive(EXCLUSIVE_PRODUCTS[2].prod_id)">
              <label for="" class="mb0">Become an member ({{ currencySymbol }} 199 / year) to Pre-Order this product right now at a {{ currencySymbol }} 100 discount</label>
            </div>
          </span>
        </div>
        <div class="text-center" style="padding: 10px; background-color: rgb(217, 155, 0);" v-if="productSlug === 'batman-3d-logo-tshirt' && now >= exclusiveDate && now < endDate && isExclusive">
          <span style="font-size: 25px; color: #fff">
            Early Access is Now Live
          </span>
        </div>
        <div class="container detailpage fullWidth">
          <div class="newbread" v-if="$parent.isDesktop">
            <router-link to="/">Home</router-link>
            /
            <span v-if="product.cat_breadcrum_name"><router-link
              :to="'/explore/' + product.category_slug">{{product.cat_breadcrum_name}} </router-link>/ </span>
            <span v-if="product.firstname"><router-link
              :to="'/artists/' + product.artist_slug">{{product && product.firstname && product.firstname.replace('\u0099', '&trade;')}} </router-link>/ </span>
            <span class="selected">  {{product.product}}</span>
          </div>
        </div>
        <div class="container detailpage fullWidth">

          <div :class="!isNewDesign ? 'row' : ''">
            <div class="col-md-7" v-if="!isNewDesign">
              <!-- for desktop view -->
              <div class="row mdproduct forDesktop" :class="productSlug === 'justice-league-reversible-hoodie' && 'prelative'">
                    <div v-for="(pr, index) in product.images" class="mb-2 pimg image-wrapper" id='pview' :key="index"  :class="{'col-md-6': product.images.length>1}">
                  <div style="height: 100%;width: 100%;" v-if="$parent.isDesktop && product.video_url && product.show_video_url === 1 && (index === product.video_url_index)">
                    <VideoPlayer
                            :src="product.video_url"
                            :poster="pr"
                            :playVideo="bannerPlaceHolderForVideoAutoplay"
                          />
                          <button class="expand" @click="magnify(product.video_url+'%video%'+pr, 0)"> <img width="18px" src="https://tss-static-images.gumlet.io/expand.png" alt="open fullscreen"/></button>
                  </div>
                  <div v-else >
                  <div
                    :style="showBlur ? 'filter: blur(2px); width:100%;' : 'width:100%;'"
                    :class="showBlur ? 'imgLink customFade' : productSlug === 'justice-league-reversible-hoodie' && 'show-views'"
                    v-lazyloadImage
                  >
                    <img
                        ref="imageRef"
                        rel="preload"
                        style="width:100%; height: 100%; max-width: 410px;"
                        :data-url="prdImg+pr"
                        class="pointer minProd"
                        :class="[{ 'customFade': !showBlur }, { 'show-blur': product.is_blur }]"
                        v-imageBackground="isProdMounted ? '1080:1440' : ''"
                        :alt="altTagDisplay(index, product.product, product.category)"
                        :title="product.meta_title"
                        @click="magnify(prdImg+pr, index)"
                        width="410" height="546"
                      >
                      <div class="pdp-ticker" v-if="bannerPlaceHolderForPdpTicker && product.tickers && product.tickers.length > 0 && currentTickerText && index === 0">
                        <span>{{ currentTickerText }}</span>
                      </div>
                      <div class="souled-out" v-if="isOutOfStock">
                        <span class="text">Souled Out</span>
                      </div>
                      <div class="coming-soon" v-else-if="isSouledOut && ['harry-potter-hufflepuff-sigil-scarf'].includes(productSlug)">coming soon</div>
                      <div class="souledout" v-else-if="isSouledOut"></div>
                      <div class="mockup-tag" :class="getMockUpTagPositionClass(mockUpTag.tag_position)" v-if="index === 0 && mockUpTag && Object.keys(mockUpTag).length">
                        <span
                          v-bind:style="{backgroundColor: mockUpTag.background_color, color: mockUpTag.text_color}"
                        >
                          {{mockUpTag.tag_name}}
                        </span>
                      </div>
                    </div>
                    <div v-if="new Date(endDate) > new Date(now) && checkDailyDropObjectExist" class="image-wrapper__product-status">
                      <p>{{liveSaleText}}</p>
                      <hr style="background-color: #fff; margin: 7px 0" />
                      <p>{{productLiveDate.date}}<sup>{{productLiveDate.dateSup}}</sup> {{productLiveDate.month && productLiveDate.month.toUpperCase()}} {{productLiveDate.time && productLiveDate.time.toUpperCase()}}</p>
                    </div>
                    </div>
                    <div v-if="showShopTheLook && product.image_coordinates && product.image_coordinates[modifyName(pr)] && product.image_coordinates[modifyName(pr)].length">
                      <div v-for="(cordinate, cordinateIndex) in product.image_coordinates[modifyName(pr)]" :key="cordinateIndex" @click="naviagteToShopTheLookPrd(cordinate.url)" class="green-dot"
                        :style="{ left: calculatePercentage(cordinate.x, 'x', index), top: calculatePercentage(cordinate.y, 'y', index) }">
                        <a :href="`${cordinate.url}?gte=${product.gender_type || 0}`" target="_blank" rel="noopener noreferrer" class="green-dot-link"></a>
                      </div>
                    </div>
                  </div>
              </div>

                <!-- for mobile and tab view  -->
              <div style="padding:0px; border: none;" class="line2title mdproduct forTabAndMobile" :class="productSlug === 'justice-league-reversible-hoodie' && 'prelative'">
                    <Countdown
                      :starttime="startDate"
                      :mobileUI="$parent.isDesktop ? false : true"
                      :isMobilePdp="$parent.isDesktop ? false : true"
                      :endtime="endDate"
                      :color="timerColor"
                      v-if="showCountDown"
                      :showTimer="showTimer"
                      :pretext="liveSaleText"
                      v-on:getLiveSaleText="getSaleTextToShow"
                      :showEarlyText="showEarlyText"
                    />
                    <carousel :perPage='1' :navigationEnabled="true"
                      :paginationEnabled="true" navigationNextLabel=""
                      :paginationPadding="2" :paginationSize="7" :paginationPosition="'bottom'"
                      navigationPrevLabel="" :autoplay="false"
                      :minSwipeDistance="1" :speed="200"
                      ref="my-carousel" class="pview" id="pview"
                    >
                      <slide class="slider-1" v-for="(pr, index) in product.images" :key="index">
                        <div style="height: 100%;width: 100%;" v-if="!$parent.isDesktop &&  product.video_url && product.show_video_url === 1 && (index === product.video_url_index)">
                          <VideoPlayer
                                :src="product.video_url"
                                :poster="pr"
                                :playVideo="bannerPlaceHolderForVideoAutoplay"
                              />
                              <div class="pdp-ticker" v-if="bannerPlaceHolderForPdpTicker && product.tickers && product.tickers.length > 0 && currentTickerText">
                            <span>{{ currentTickerText }}</span>
                          </div>
                        </div>
                        <div v-else >
                        <div
                          style="height: auto; min-height: 450px; max-height: 580px; background: rgb(255, 235, 231);"
                          :style="showBlur ? 'filter: blur(3px)' : null"
                          :class="showBlur ? 'imgLink customFade' : productSlug === 'justice-league-reversible-hoodie' && 'show-views'"
                          v-lazyloadImage
                        >
                          <img :data-url="prdImg+pr"
                            class="pointer pimg img-auto"
                            :class="[{ 'customFade': !showBlur }, { 'show-blur': product.is_blur }]"
                            :alt="altTagDisplay(index, product.product, product.category)"
                            :title="`${altPrefix[index]}${product.product} ${product.category} Online at The Souled Store`"
                            v-imageBackground="'1080:1440'"
                            @click="magnify(prdImg+pr, index)"
                            ref="image"
                            width="295" height="393"
                            @load="updateDotPosition(index)"
                          >
                          <div v-if="showShopTheLook && product.image_coordinates && product.image_coordinates[modifyName(pr)] && product.image_coordinates[modifyName(pr)].length && isActiveSlide(index)">
                            <div 
                              v-for="(cordinate, cordinateIndex) in product.image_coordinates[modifyName(pr)]" :key="cordinateIndex"
                              class="green-dot" 
                              :style="getDotPosition(index, cordinate.x, cordinate.y)"
                              @click="naviagteToShopTheLookPrd(cordinate.url)"
                              >
                              <a :href="`${cordinate.url}?gte=${product.gender_type || 0}`" target="_blank" rel="noopener noreferrer" class="green-dot-link"></a>
                            </div>
                          </div>
                          <div class="souled-out" v-if="isOutOfStock">
                            <span class="text">Souled Out</span>
                          </div>
                          <div class="coming-soon" v-else-if="isSouledOut && ['harry-potter-hufflepuff-sigil-scarf'].includes(productSlug)">coming soon</div>
                          <div class="souledout" v-else-if="isSouledOut"></div>
                          <div class="mockup-tag" :class="getMockUpTagPositionClass(mockUpTag.tag_position)" v-if="index === 0 && mockUpTag && Object.keys(mockUpTag).length">
                            <span
                              v-bind:style="{backgroundColor: mockUpTag.background_color, color: mockUpTag.text_color}"
                            >
                              {{mockUpTag.tag_name}}
                            </span>
                          </div>
                          <div class="pdp-ticker" v-if="bannerPlaceHolderForPdpTicker && product.tickers && product.tickers.length > 0 && currentTickerText">
                            <span>{{ currentTickerText }}</span>
                          </div>
                          <div v-if="mockUpLabel && Object.keys(mockUpLabel).length && isLabelLieInTime" class='d-flex align-items-center label-container prelative'>
                            <i class="fa fa-bolt pabsolute" :style="{borderColor: mockUpLabel.label.label_background_color}"></i>
                            <span class="fbold ecltext" :style="{backgroundColor: mockUpLabel.label.label_background_color, color: mockUpLabel.label.label_text_color}">{{mockUpLabel.label.label_name}}</span>
                          </div>
                        </div>
                        <div v-if="new Date(endDate) > new Date(now) && checkDailyDropObjectExist" class="image-wrapper__product-status">
                          <p>{{liveSaleText}}</p>
                          <hr style="background-color: #fff; margin: 7px 0" />
                          <p>{{productLiveDate.date}}<sup>{{productLiveDate.dateSup}}</sup> {{productLiveDate.month && productLiveDate.month.toUpperCase()}} {{productLiveDate.time && productLiveDate.time.toUpperCase()}}</p>
                        </div>
                        </div>
                      </slide>
                    </carousel>
                  </div>
            </div>
            <div v-if="isNewDesign" id="scroll-till-that"></div>
            <div :class="!isNewDesign ? 'col-md-5 pr0' : ''">
              <div :class="!isNewDesign ? 'productinfo px-3' : ''">
                <div class="price-box-container" :class="{ 'newdesign-pricebox-fixed': isNewDesign && hasScrolledClass, 'newdesign-pricebox': isNewDesign && isPriceSectionFixed }">
                <div class="bx1">
                  <div class="row mr0">
                    <div :class="$parent.isDesktop ? 'col-12' : 'col-10'">
                      <h1 class="fbold mb-0 title-size" :class="isNewDesign ? 'new-design-title' : ''">{{ product.product }}</h1>
                    </div>
                    <div v-if="!$parent.isDesktop && !isNewDesign" class="col-2 shareIcon" @click="shareNavigatorHandler">
                      <i style="text-decoration: underline;" class="fa fa-share-alt" aria-hidden="true"></i>
                      SHARE
                    </div>
                  </div>
                  <p class="mb0">
                    <router-link :to="'/explore/' +  product.category_slug" class="op_5">
                    <h1 class="prod-cat">{{product.category}}</h1>
                    </router-link>
                    <span v-for="phoneCat in product.cat" :key="phoneCat">
                      <u><router-link v-if="phoneCat === 153" to="/mobile-covers">(Change phone model)</router-link></u>
                    </span>
                  </p>
                  <div class="ratingPDP" v-if="bannerPDPRating && (this.product.avg_rating >= 1 )">
                    <div>{{ this.product.avg_rating }}</div>
                    <img src="https://w7.pngwing.com/pngs/566/674/png-transparent-green-star-blue-angle-leaf-thumbnail.png" class="starRating" alt="starImage"/>
                    <div class="pipPDP">|</div>
                    <div class="pdpr">{{ getDataValue(this.product.rating_count) }}</div>
                  </div>
                  <div class="prelative" v-if="bannerPlaceHolderForArtistNameDisplay">
                    <a href="https://www.thesouledstore.com" target="_blank" rel="noopener noreferrer"
                      v-if="product.added_by == 75692">By <span v-html="formattedArtist"></span> </a>
                    <router-link
                    :to="'/artists/' + product.artist_slug" v-else-if="product.firstname !== ''"
                    >
                      <span v-if="formattedArtist" @click="artistEventHandler(formattedArtist, product)" v-html="`By ${formattedArtist}`"></span>
                    </router-link>
                  </div>
                </div>
                <div v-if="product.variant">
                  <div v-if="product.stock <= 0">
                    <size-hover :parentid="product.id" :proType="product.prod_type" :isOptions="false" :platform="product.platform || ''"></size-hover>
                  </div>
                </div>
                <hr v-if="$parent.isDesktop">
              <div
                class="price-box-wrapper"
                :class="!bannerPlaceHolderForGstInclusiveLabel ? 'mb20' : ''"
              >
                      <span class="leftPrice pull-right" v-if="product.price">
                        
                        <span v-if="Math.round(product.spl_price) || (isExclusive && Math.round(product.exclusive_price))">
                          <span v-if="isExclusive && showMemberExclusivePrice" class="membership-product-price" style="font-size: 1.2em; color: #121212">
                            <span  >Membership Price</span>
                            <span class="fsemibold" style="color:#121212;">{{ currencySymbol }} {{(product.exclusive_price && parseInt(product.exclusive_price) || 0)}}</span>
                          </span>
                          <span v-else style="font-size: 1.6em;-webkit-text-stroke: 0.35px #ffffff;" class="offer">
                            <span class="irupee">{{ currencySymbol }}</span> {{product.spl_price && parseInt(product.spl_price)}}
                          </span>
                          <span v-if="(isExclusive ? (product && parseInt(product.exclusive_price)) : (product && parseInt(product.spl_price))) !== parseInt(product.price)" style="font-size: 1.1em; text-decoration: line-through; color: #CCCCCC">{{ currencySymbol }} {{ parseInt(product.price) }}</span>
                        </span>
                        
                        <span class="fbold" style="font-size: 1.5em" v-else-if="['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(productSlug)"><span class="irupee">{{ currencySymbol }}</span> {{ $parent.currencyFormate(parseInt(product.price))}}</span>

                        <span class="fbold" style="font-size: 1.5em" v-else>
                          <span class="irupee">{{ currencySymbol }}</span> {{ parseInt(product.price)}}
                        </span>
                        

                        <span style="color: #E66A51; font-size: 1.1em;" v-if="product && product.spl_price && !isExclusive">
                          <span v-if="isNonExclusiveSavingsInPercent">{{parseInt(((product && product.price) - (isExclusive ? (product && product.exclusive_price) : (product && product.spl_price))) / (product && product.price) * 100)}}% {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}
                          </span>
                          <span v-else-if="parseInt(product.price) - parseInt((isExclusive ? (product && product.exclusive_price) : (product && product.spl_price)))">{{ currencySymbol }} {{parseInt(product.price) - parseInt((isExclusive ? (product && product.exclusive_price) : (product && product.spl_price)))}} {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}</span>
                        </span>
                         
                        <span style="color: #E66A51; font-size: 1.1em; margin-left: 2px" v-if="product && product.price && product.exclusive_price && isExclusive && !showMemberExclusivePrice">
                          <span v-if="isExclusiveSavingsInPercent">{{parseInt(((product && product.price) - (product && product.exclusive_price)) / (product && product.price) * 100)}}% {{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}}</span>
                          <span class="no-wrap" v-else>{{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}} {{ currencySymbol }} {{parseInt(product.price)- parseInt(product.exclusive_price)}}</span>
                        </span>

                      </span>
                      <span>
                        <span v-if="product && product.mrp && parseInt(product.mrp) > 0 && showMrpOnPdp && isSelectedCountryIndia" class="mrp-slogan">MRP Rs. {{parseInt(product.mrp)}} {{ showMrpOnPdp.tag_text }}</span>
                        <span v-else-if="showPriceInclusiveOnPdp && !showMrpOnPdp && isSelectedCountryIndia" class="mrp-slogan">{{ showPriceInclusiveOnPdp.tag_text }}</span>
                        <span v-else-if="showMrpOnPdpGlobal && !showMrpOnPdp && !isSelectedCountryIndia" class="mrp-slogan">{{ showMrpOnPdpGlobal.tag_text }}</span>
                      </span>
                      <span class="membership-product-price" style="font-size: 1.2em; color: #121212" @click="openMembershipPopup" v-if="product && product.price && product.exclusive_price && !isExclusive && !$parent.isDesktop && bannerPlaceHolderForMemberShipBanner && isSelectedCountryIndia">
                            <span class="membership-nonmember-info" >Get for</span>
                            <span class="membership-product-price-nonmember" style="color:#121212;">{{ currencySymbol }}{{(product.exclusive_price && parseInt(product.exclusive_price) || 0)}}</span>
                            <span>
                              <img class="info-icon" src="https://tss-static-images.gumlet.io/Vector.png" alt="vector.png"/> 
                            </span>
                      </span>
                </div>
                
                <span v-if="product && product.price && product.exclusive_price && !isExclusive && showNonMemberExclusivePrice" class="non-membership-product-price" style="font-size: 1.2em; color: #121212">
                    <span>Get for</span>
                    <span class="fsemibold" style="color:#121212;">{{ currencySymbol }} {{(product.exclusive_price && parseInt(product.exclusive_price) || 0)}}</span>
                    <span >with membership</span>
                </span>
               <div v-if="isSelectedCountryIndia && bannerPlaceHolderForTSSpointsmodel && user && parseFloat(user.tss_points) > 0 && parseFloat(bannerPlaceHolderForTSSpointsmodel.description) <= parseFloat(user.tss_points) && tssPoint && !(tssPoint.price_after_tss_point_redemption === '' || tssPoint.price_after_tss_point_redemption === null || tssPoint.price_after_tss_point_redemption === undefined)"
                  style="margin-bottom: 18px;"
                >
                <div style="
                  display: inline-flex;
                  align-items: center;
                  background-color: #F0F0F0;
                  padding: 8px 12px;
                  border-radius: 8px;
                  font-family: 'Segoe UI', sans-serif;
                  font-size: 14px;
                  color: #333;
                ">
                  <img 
                    style="width: 14px; height: 14px; cursor: pointer; margin-right: 8px;" 
                    @click="setTSSPointsData" 
                    src="https://tss-static-images.gumlet.io/icons/tssHelpDetails.png" 
                    alt="More Info"
                  >
                  <span style="line-height: 1.2;">
                    <strong>Get this for</strong> 
                   <span class="irupee">
                     <strong style="color: #148c8d;">
                      {{ currencySymbol + roundedPriceAfterRedemption }}
                    </strong>
                    </span>


                    <strong>using your TSS points.</strong>
                  </span>
                </div>
              </div>

                <div v-if="bannerPlaceHolderSnapmintSection && isSelectedCountryIndia" class="snapmint-wrapper">
                  <div class="snap_emi_txt" :class="{mt20:product && product.price && product.exclusive_price && !isExclusive && showNonMemberExclusivePrice}"></div>
                  <span class="snapmint_lowest_emi_value" style="display:none;" 
                        :data-snapmint-price="getMerchantPrice * formData.quantity" 
                        :data-snapmint-merchant_id="merchantId" 
                        data-snapmint-page="products_page">
                  </span>
                </div>
                </div>
                <div v-if="bannerPlaceHolderForGstInclusiveLabel" class="gstInclusiveLabel mb-1">
                  <span :style="`color: ${bannerPlaceHolderForGstInclusiveLabel.banner_text_color}; background: ${bannerPlaceHolderForGstInclusiveLabel.banner_color};`">{{bannerPlaceHolderForGstInclusiveLabel.tag_text}}</span>
                </div>
                <div class="exclusivePrice mb20" v-if="bannerPlaceHolderPDPExclusivePrice && !isExclusive && product.show_exclusive_message" :style="bannerPlaceHolderPDPExclusivePrice.styles">
                  <p><span style="font-weight: bold"><span class="irupee">{{ currencySymbol }}</span> {{product.exclusive_price}} {{bannerPlaceHolderPDPExclusivePrice.text}}</span>
                  <span @click="knowPrice()" class="knowLink">KNOW MORE?</span>
                  </p>
                </div>
                
                <div v-if="product.is_printable" class="customization-wrapper mb-2">
                  <div class="d-flex align-items-center customized-input">
                    <span class="customcheckbox">
                      <input type="checkbox" name="av" id="accept" :checked="isCustomizedProdModal || isCustomizedProd" @change="handleCustomization($event.target.checked)">
                      <label for="accept" class='mb0'>&nbsp;</label>
                    </span>
                    <span class="customise-heading pointer" @click="handleCustomization(!(isCustomizedProdModal || isCustomizedProd))">Customise This {{ customisableProductText }}</span>
                    <span class='darkblcolor fbold customise-price'> ({{ currencyRsToUSD }} {{product.extra_price}} extra)</span>
                  </div>
                </div>
                <div class='combo-products-wrapper' v-if="product.prod_type === 6 && product.options.length">
                  <!-- <div class="combo-select-size" v-if="product.options.length > 1">Please select top and bottom wear size</div> -->
              <div v-for="(op, index) in product.options" :key="op.option_id" class='combo-product-wrapper' :class="{'combo-border-b': index !== product.options.length - 1}">
                <div class='d-flex combo-prod-name-wrapper mb10'>
                  <p class='bundleProName'>{{op.option_name}}</p>
                </div>
                <div class='row margin-unset'>
                  <select class="bundle-dropdown fregular col-md-5 col-12" :value="selectedComboVariants[op.option_id] ? selectedComboVariants[op.option_id]['sku'] : ''" @input="handleVarientChange($event, op, index)">
                    <option selected value="">-- Please Select Product --</option>
                    <option v-for="varnt in op.variants" :key="varnt.variant_id" :value="varnt.sku" :disabled="!varnt.stock">{{varnt.name}}</option>
                  </select>
                </div>
                <div class="specific-combo-size pt-3" v-if="!product.is_common_sizeChart_applicable && specificComboVarArr[index] && Object.keys(specificComboVarArr[index]).length">
                  <p class="select-size">
                    <span class="f16 font-weight-bold">Please select  {{ product.platform === 'KIDS' ? 'an age' : 'a size' }}. &nbsp;</span>
                    <span
                    @click="getSizeChartData(specificComboVarArr[index].product_slug, specificComboVarArr[index].category_id, specificComboVarArr[index].category, index)"
                    class="selectcolor pointer text-uppercase font-weight-normal"
                    >Size Chart
                    </span>
                  </p>
                  <div>
                    <ul class="sizelist">
                      <li class="oval" v-for="(val, key, index2) in (specificComboVarArr[index] && specificComboVarArr[index].variant)" :key="index2" v-bind:class="{ outstock: (val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock, selectedSize: (val.id == specificComboFormData[index]), unselectedSize: (val.id != specificComboFormData[index]) }">
                        <input style="z-index:-1" type="radio" name="sub_prod" :id="`${index}_${key}`" :value="val.id" v-model="specificComboFormData[index]"
                        @click="changevalue(val)" :disabled="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock || isSouledOut">
                        <label :class="{'strikethrough':((val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock)}"  style="border-radius: 30px; position: static;" :for="`${index}_${key}`">
                          <span class="" v-if="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock">{{getSizeAttribute(val.attributes).value}}</span>
                          <span class="sizetext" v-else>{{getSizeAttribute(val.attributes).value}}</span>
                        </label>
                        <section class="total-stock bx1 total-size-based-stock" v-if="enableTotalStockLeft && (product.prod_type === 3 || specificComboVarArr[index]) && specificComboFormData[index] && val.id == specificComboFormData[index] && val.stock > 0 && val.stock < stockLeftLimit && product.artist_slug !== 'bhadipa'">
                          {{val.stock}} Left
                        </section>
                      </li>
                    </ul>
                    <div class="disableclick outOfStockBox" v-if="specificComboVarArr[index] && specificComboVarArr[index].variant && specificComboVarArr[index].variant.filter(itm => itm.stock === 0).length">
                      <size-hover :parentid="product.id" :proType="product.prod_type" :isOptions="true" :sizes="specificComboVarArr[index] ? [...specificComboVarArr[index].variant] : [...product.variant]" :isSouledOut="isSouledOut" :platform="product.platform || ''"></size-hover>
                    </div>
                  </div>
                  <transition name="fade">      
                    <div class="alert alert-danger" role="alert" v-if="specificSizeError && specificSizeError[index] && !isComboBreaked && !isSpecificSizeError">Please select {{ product.platform === 'KIDS' ? ' an age' : 'a size' }}.</div>
                  </transition>
                </div>
                <div class="specific-combo-size pt-3" v-if="isProductOutOfStock(op)">
                  <div>
                    <ul class="sizelist">
                      <li class="oval" v-for="(val, key, index2) in outofStockFirstProductsize" :key="index2" v-bind:class="{ outstock: true || isOutOfStock, selectedSize: false, unselectedSize: true }">
                        <input style="z-index:-1" type="radio" name="sub_prod" :id="`${index}_${key}`" :value="val.id" v-model="specificComboFormData[index]"
                        :disabled="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock">
                        <label :class="{'strikethrough':(true || isOutOfStock)}"  style="border-radius: 30px; position: static;" :for="`${index}_${key}`">
                          <span class="" v-if="true || isOutOfStock">{{ getSizeAttribute(val.attributes).value }}</span>
                        </label>
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isColorWebEnable && product && product.color_group_details && product.color_group_details.length && product.color_group_details.length > 0">
              <p class="group-header" v-if="colorWebHeader">
                <span class="f16 font-weight-bold">{{ colorWebHeader.description }}&nbsp;</span>
              </p>

              <div class="d-flex color-list-container-old" v-if="!isColorImgWebEnable">
                <div class="color-parent" v-for="(val, colorDetailIndex) in product.color_group_details" :class="product.product_slug === val.url_key ? 'active' : ''" :key="colorDetailIndex">
                  <div @click="prodRedirection(val.url_key)"
                  class="color-child"
                  :style="{ 
                    backgroundColor: val.color, 
                  }">
                  </div>
                </div>
              </div>

              <div class="color-web-wrapper" v-else>
                <carousel :navigationEnabled="isDesktop"
                  :paginationEnabled="false" navigationNextLabel=""
                  :paginationPadding="2" :paginationPosition="'bottom'"
                  navigationPrevLabel="" :autoplay="false"
                  :minSwipeDistance="1" :speed="100"
                  :scrollPerPage="true"
                  :paginationSize="7"
                  :perPageCustom="[[292, 3], [350, 4], [450, 4.8], [600, 6], [768, 3], [900, 4], [1029, 4.8], [1200, 6], [1920, 6]]"
                  ref="my-carousel" class="color-web-carousel"
                >
                  <slide class="color-parent"
                    v-for="(val, colorDetailIndex) in reorderedColorGroupDetails"
                    :class="product.product_slug === val.url_key ? 'active' : ''"
                    :key="colorDetailIndex"
                    v-if="val && (val.default_image || val.color)"
                  >
                    <div class="d-flex color-list-container">
                      <div
                        class="color-parent new-img-pallet"
                        :class="product.product_slug === val.url_key ? 'active' : ''"
                      >
                        <div
                          @click="prodRedirection(val.url_key)"
                          class="color-child"
                          :style="{ backgroundColor: val.color }"
                        >
                          <div v-lazyloadImage class="image-wrapper">
                            <div class="sold-out-text" v-if="val.prod_qty === 0"> Souled Out</div>
                            <img :data-url="prdImg + val.default_image" class="pointer reecomended-img" />
                            <div
                              class="hover-color-overlay"
                              :style="{ background: `linear-gradient(to top, ${val.color}, transparent)` }"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>
              </div>
                <div class="bx1" v-if="((product.variant && product.variant.length || (product.is_common_sizeChart_applicable && commonComboVariantsProd && Object.keys(commonComboVariantsProd).length && commonComboVariantsProd.variant && commonComboVariantsProd.variant.length))
                    && (productSlug !== 'black-panther-proutility-backpack' || (productSlug === 'black-panther-proutility-backpack' && endDate != exclusiveDate && ((now >= exclusiveDate && isExclusive) || now > endDate)))
                    && (!['black-panther-proutility-backpack'].includes(productSlug) || (['black-panther-proutility-backpack'].includes(productSlug) && now >= endDate))
                    && (productSlug !== 'avengers-varsity-jacket' || (productSlug === 'avengers-varsity-jacket' && now > endDate))
                    && (productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (productSlug === 'mumbai-indians-fan-rohit-45-jersey' && now > endDate))
                    && (productSlug !== 'anniversary-collection-captain-america-tshirt' || (productSlug === 'anniversary-collection-captain-america-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-spider-man-tshirt' || (productSlug === 'anniversary-collection-spider-man-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-black-panther-tshirt' || (productSlug === 'anniversary-collection-black-panther-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-hulk-tshirt' || (productSlug === 'anniversary-collection-hulk-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-thor-tshirt' || (productSlug === 'anniversary-collection-thor-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-iron-man-tshirt' || (productSlug === 'anniversary-collection-iron-man-tshirt' && now > endDate))
                  )">
                  
                  <div class="seperator mb-1 seperatorExtra" :class="product.prod_type === 6 ? 'mt-3' : ''"></div>
                  <div>
                    <p class="select-size group-header"><span class="f16 font-weight-bold">Please select {{ product.platform === 'KIDS' ? 'an age' : 'a size' }}. &nbsp;</span>
                      <span
                        @click="Object.keys(commonComboVariantsProd).length && commonComboVariantsProd ? getSizeChartData(commonComboVariantsProd.product_slug, commonComboVariantsProd.category_id, commonComboVariantsProd.category, null) : getSizeChartData(product.product_slug, product.category_id, product.category, null)"
                        class="selectcolor pointer text-uppercase font-weight-normal"
                        >Size Chart
                      </span>
                    </p>
                      <div v-if="product.prod_type == 3 && productWiseSizeChartData && getVarientSizeDetails" class="size-data-details font-weight-bold" v-html="getVarientSizeDetails">
                      </div>
                      <div v-if="product.prod_type == 3 || Object.keys(commonComboVariantsProd).length">
                        <ul class="sizelist">
                          <li class="oval" v-for="(val, key, index) in Object.keys(commonComboVariantsProd).length && commonComboVariantsProd ? commonComboVariantsProd.variant : product.variant" :key="index" @click="changevalue(val)" v-bind:class="{ outstock: (val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock, selectedSize: (val.id == selectedProductVariant.id), unselectedSize: (val.id != selectedProductVariant.id) }">
                            <input style="z-index:-1" type="radio" name="sub_prod" :id="key" :value="val.id" v-model="formData.prod_id" 
                                   :disabled="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock">
                          <label :class="{'strikethrough':((val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock)}"  style="border-radius: 30px; position: static;" :for="key">
                              <span class="" v-if="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock">{{getSizeAttribute(val.attributes).value}}</span>
                              <span class="sizetext" v-else>{{getSizeAttribute(val.attributes).value}}</span>
                            </label>
                            <section class="total-stock bx1 total-size-based-stock" v-if="enableTotalStockLeft && (product.prod_type === 3 || commonComboVariantsProd) && selectedProductVariant && val.id == selectedProductVariant.id && val.stock > 0 && val.stock < stockLeftLimit && product.artist_slug !== 'bhadipa'">
                              {{val.stock}} Left
                            </section>
                          </li>
                        </ul>
                        <div class="disableclick outOfStockBox" v-if="isSizeOutOfStock || isSouledOut || isOutOfStock">
                          <size-hover :parentid="product.id" :proType="product.prod_type" :isOptions="true" :sizes="Object.keys(commonComboVariantsProd).length && commonComboVariantsProd ? [...commonComboVariantsProd.variant] : [...product.variant]" :isSouledOut="isSouledOut" :platform="product.platform || ''"></size-hover>
                        </div>
                      </div>
                <transition name="fade">
                  <div class="alert alert-danger" :class="isNewDesign ? 'new-design-size-error' : ''" role="alert" v-if="sizeError">Please select {{ product.platform === 'KIDS' ? 'an age' : 'a size' }}.</div>
                </transition>
              </div>
              <div v-if="product.prod_type !== 6" class="seperator mt-1 seperatorExtra"></div>
            </div>
            <section class="total-stock bx1" v-if="product.prod_type === 3 && product.prod_qty && product.prod_qty < stockLeftLimit && (![149, 598].includes(product.category_id) || ([149, 598].includes(product.category_id) && (now < '2019-12-27 00:00:00' || now > '2019-12-27 01:59:59')))">
              <span v-if="!(selectedProductVariant && selectedProductVariant.stock)">
                Total {{product.prod_qty}} Left
              </span>
            </section>
            <section class="total-stock bx1" v-if="$route.path === '/product/bhadipa-varta-laugh-ticket'">
                Total {{product.stock}} Left
            </section>
            <div class="bx1 mb-1"
              v-if="!isSouledOut && !isOutOfStock && $parent.isDesktop
              && (productSlug !== 'black-panther-proutility-backpack' || (productSlug === 'black-panther-proutility-backpack' && endDate != exclusiveDate && ((now >= exclusiveDate && isExclusive) || now > endDate)))
              && (productSlug !== 'camouflage-olive-hoodie' || (productSlug === 'camouflage-olive-hoodie' && now >= endDate && isExclusive))
              && (!['black-panther-proutility-backpack'].includes(productSlug) || (['black-panther-proutility-backpack'].includes(productSlug) && now >= endDate))
              && (productSlug !== 'avengers-varsity-jacket' || (productSlug === 'avengers-varsity-jacket' && now > endDate))
              && (productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (productSlug === 'mumbai-indians-fan-rohit-45-jersey' && now > endDate))
              && (productSlug !== 'anniversary-collection-captain-america-tshirt' || (productSlug === 'anniversary-collection-captain-america-tshirt' && now > endDate))
              && (productSlug !== 'anniversary-collection-spider-man-tshirt' || (productSlug === 'anniversary-collection-spider-man-tshirt' && now > endDate))
              && (productSlug !== 'anniversary-collection-black-panther-tshirt' || (productSlug === 'anniversary-collection-black-panther-tshirt' && now > endDate))
              && (productSlug !== 'anniversary-collection-hulk-tshirt' || (productSlug === 'anniversary-collection-hulk-tshirt' && now > endDate))
              && (productSlug !== 'anniversary-collection-thor-tshirt' || (productSlug === 'anniversary-collection-thor-tshirt' && now > endDate))
              && (productSlug !== 'anniversary-collection-iron-man-tshirt' || (productSlug === 'anniversary-collection-iron-man-tshirt' && now > endDate))"
            >
              <div class="mb-2">
                <div class='d-flex align-items-center'>
                  <div class="CartsetQty mr20" v-if="!isTssCorpProduct">
                    <div class="fltdiv lh28">Quantity  &nbsp; </div>
                    <select class="qtyOption" v-model="formData.quantity" @change="changevalue(null,formData.quantity)" :disabled="product.is_mystery_product === 1">
                      <option v-for="no in 10" :value="no" :key="no">{{ no < 10 ? '0' + no : no }}</option>
                    </select>
                  </div>
                  <div v-if="$parent.isDesktop && mockUpLabel && Object.keys(mockUpLabel).length && isLabelLieInTime" class='d-flex align-items-center label-container prelative'>
                    <i class="fa fa-bolt pabsolute" :style="{borderColor: mockUpLabel.label.label_background_color}"></i>
                    <span class="fbold ecltext" :style="{backgroundColor: mockUpLabel.label.label_background_color, color: mockUpLabel.label.label_text_color}">{{mockUpLabel.label.label_name}}</span>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>

            <div v-if="product && product.additional_note && showAdditionalNote" class="bx1 mb-3">
              <span class="additional-note" :style="{ 
                    color: showAdditionalNote && showAdditionalNote.description || '#292b2c', 
                  }">{{ product.additional_note }}</span>
            </div>
            <!-- Product Atrribute -->
      
            <!-- <div v-if="!(product && product.tags[0].tag_slug === 'solids' && product.tags[1].tag_slug === 'combos')"> -->
              <div class="bx1 prod-attr-wrapper-desktop" v-if="(product.variant && product.variant.length > 0 && colorOptions && colorOptions.length > 0)">
                <p class="select-color-header">Select Colors</p>
                <div v-if="product.prod_type == 3" class="row">
                  <!-- <ul :style="[showMoreColors ? { 'height': 'auto' } : { 'height': '50px' }]" -->
                  <ul v-bind:class="{ fixedHeight: !showMoreColors, autoHeight: showMoreColors, 'colorsList col-xs-12 col-md-10 col-xl-8': true }">
                    <li v-for="prod in colorOptions" :title="prod.product_name" :style="[currentRouteName === prod.product_slug ? (prod.is_multicolor ? { 'border': '4px solid #ffffff', 'box-shadow': [`0 0 0 3px ${prod.product_color}`], 'background': [`linear-gradient( 90deg, ${prod.product_color} 50%, ${prod.product_color2} 50% )`] } : { 'border': '4px solid #ffffff', 'box-shadow': [`0 0 0 3px ${prod.product_color}`], background: prod.product_color }) : (prod.is_multicolor ? { 'border': '2px solid #999696', 'background': [`linear-gradient( 90deg, ${prod.product_color} 50%, ${prod.product_color2} 50% )`] } : { 'border': '2px solid #999696', background: prod.product_color })]"
                      @click="changeColor(prod.product_slug)" v-bind:key="prod.product_slug">
                      <!-- <img v-if="currentRouteName === prod.product_slug" data-src="https://tss-static-images.gumlet.io/check-mark-white-md.png" alt="selected">  -->
                    </li>
                  </ul>
                  <div class="color-size-wrapper less pointer" v-if="showMoreColors && this.colorOptions.length > 7" @click="showColor()"><u>Less <i class="fa fa-caret-up"></i></u></div>
                  <div class="color-size-wrapper more pointer" v-else-if="!showMoreColors && this.colorOptions.length > 7" @click="showColor()"><u>More <i class="fa fa-caret-down"></i></u></div>
                </div>
              </div>
            <!-- </div> -->

            <!-- <div v-if="!(product && product.tags[0].tag_slug === 'solids' && product.tags[1].tag_slug === 'combos')"> -->
              <div class="bx1 prod-attr-wrapper-mobile" v-if="(product.variant && product.variant.length > 0 && colorOptions && colorOptions.length > 0)">
                <p class="select-color-header">Select Colors</p>
                <div v-if="product.prod_type == 3">
                  <ul class="colorsListMob">
                    <li v-for="prod in colorOptions" :style="[currentRouteName === prod.product_slug ? (prod.is_multicolor ? { 'border': '4px solid #ffffff', 'box-shadow': [`0 0 0 3px ${prod.product_color}`], 'background': [`linear-gradient( 90deg, ${prod.product_color} 50%, ${prod.product_color2} 50% )`] } : { 'border': '4px solid #ffffff', 'box-shadow': [`0 0 0 3px ${prod.product_color}`], background: prod.product_color }) : (prod.is_multicolor ? { 'border': '2px solid #999696', 'background': [`linear-gradient( 90deg, ${prod.product_color} 50%, ${prod.product_color2} 50% )`] } : { 'border': '2px solid #999696', background: prod.product_color })]"
                      @click="changeColor(prod.product_slug)" v-bind:key="prod.product_slug">
                    </li>
                  </ul>
                </div>
              </div>
            <!-- </div> -->
            <div>
            <div class="bx1 brd0 mb_mbo" :class="isNewDesign ? 'new-design-btn' : ''">
              <BuyNowMobile v-if="isBuyNowPopup" :closeBuyNow="hideBuyNowPopup"></BuyNowMobile>
              <!-- move to cart popup starts -->
              <div class="movePopup" v-if="bannerPlaceHolderForAddToCartSizePopup && !$parent.isDesktop && isSizePopupActive">
                <div class="movePopupModalOverlay"  @click="isSizePopupActive = false"></div>
                <div class="movePopup-wrapper py-1 px-3"  @click.stop>
                  <div class="d-flex flex-row-reverse pb-1 my-1" @click="isSizePopupActive = false">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </div>
                  <div v-if="((product.variant && product.variant.length) || (commonComboVariantsProd && Object.keys(commonComboVariantsProd).length && commonComboVariantsProd.variant && commonComboVariantsProd.variant.length))" :class="isSizeOutOfStock || isSouledOut || isOutOfStock ? '' : 'pb-2 mb-1'">
                    <p class="select-size mb-1">
                      <span class="font-weight-bold">Please select {{ product.platform === 'KIDS' ? 'an age' : 'a size' }}.&nbsp;</span>
                      <span
                        @click="commonComboVariantsProd && Object.keys(commonComboVariantsProd).length ? getSizeChartData(commonComboVariantsProd.product_slug, commonComboVariantsProd.category_id, commonComboVariantsProd.category, null) : getSizeChartData(product.product_slug, product.category_id, product.category, null)"
                        class="selectcolor text-uppercase pointer"
                      >
                        Size Chart
                      </span>
                    </p>
                    <div v-if="product.prod_type == 3 || commonComboVariantsProd">
                      <ul class="sizelist">
                        <li
                          class="oval"
                          v-for="(val, key, index) in (Object.keys(commonComboVariantsProd).length && commonComboVariantsProd ? commonComboVariantsProd.variant : product.variant)" :key="index"
                          :class="{ outstock: (val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock, selectedSize: (val.id == selectedProductVariant.id), unselectedSize: (val.id != selectedProductVariant.id) }"
                        >
                          <input
                            style="z-index:-1"
                            type="radio"
                            name="sub_prod"
                            :id="key"
                            :value="val.id"
                            @change="changevalue(val)"
                            :disabled="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock"
                          >
                          <label :class="{'strikethrough':((val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock)}"  style="border-radius: 30px; position: static;" :for="key">
                            <span class="" v-if="(val.stock <= 0 && product.jit_value != 'JIT') || isOutOfStock">{{getSizeAttribute(val.attributes).value}}</span>
                            <span class="sizetext" v-else>{{getSizeAttribute(val.attributes).value}}</span>
                          </label>
                          <section
                            class="total-stock bx1 total-size-based-stock"
                            v-if="enableTotalStockLeft && (product.prod_type === 3 || (commonComboVariantsProd && Object.keys(commonComboVariantsProd).length)) && selectedProductVariant && val.id == selectedProductVariant.id && val.stock > 0 && val.stock < stockLeftLimit && product.artist_slug !== 'bhadipa'"
                          >
                            {{val.stock}} Left
                          </section>
                        </li>
                      </ul>
                      <div class="disableclick outOfStockBox" v-if="isSizeOutOfStock || isSouledOut || isOutOfStock">
                        <size-hover
                          :parentid="product.id"
                          :proType="product.prod_type"
                          :isOptions="true"
                          :sizes="commonComboVariantsProd && Object.keys(commonComboVariantsProd).length ? [...commonComboVariantsProd.variant] : [...product.variant]"
                          :isSouledOut="isSouledOut"
                          :isMoveToCartPopup="true"
                          :platform="product.platform || ''"
                        ></size-hover>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="authStatus && product && product.stock <= 0 && product.prod_qty <= 0 && getVoteCardDetails && getVotedProductText" :class="$parent.isDesktop ? 'return-and-tss-message-box p-2 my-3' : 'my-1'">
                <transition name="fade">
                  <span v-if="!productVoted">
                    <img
                      class="tss-vote-icon"
                      :class="{ 'my-1' : !$parent.isDesktop }"
                      src="https://tss-static-images.gumlet.io/vote.png"
                      alt="Vote image"
                    >
                  <span @click="voteSoldedOutProduct" class="pointer voteNowStyles pl-2">
                    {{ getVoteCardDetails.tag_text }} </span> {{ getVoteCardDetails.description }}
                  </span>
                  <span v-else>
                    <img 
                      class="tss-vote-icon"
                      :class="{ 'my-1' : !$parent.isDesktop }"
                      src="https://tss-static-images.gumlet.io/round_tick.png"
                      alt="Voted image"
                    >
                    <span class="pl-2">
                      {{ getVotedProductText.description }}
                    </span>
                  </span>
                </transition>
                <div class="seperator seperatorExtra mt-1"></div>
              </div>
              <!-- move to cart popup ends -->
              <div class="mbstickyfooter" v-if="(!productZoomMobile) && (!isBuyNowPopup)">
                <input type="hidden" name="prod_id" id="prod_id" v-model="formData.prod_id">
                <input type="hidden" name="prod_type" value="product.prod_type" v-model="formData.prod_type">
                <div class="notification-message" v-if="exclusiveMembershipAdded">
                  The Souled Store Membership has been added to cart.
                </div>

                <div class="row">
                  <div :class="!bannerPlaceHolderForBuyNow ? 'col-2' : 'col-5'" v-if="enableActionBoton && isBlurProductClickablePdp && !isSouledOut && !$parent.isDesktop && isWishlist">
                    <button
                      class="btn btn-lg btn-block pointer wishlistBtnMobile text-uppercase p-0"
                      :style="!bannerPlaceHolderForBuyNow ? 'padding: 0;' : ''"
                      type="button"
                      @click="updateWishlist(getWishistPrmData, $event)"
                    >
                      <span
                        class='wishlistIcon'
                        :class="product && wishlistItemsIDs && wishlistItemsIDs[product.id] ? 'wishlistActive' : 'wishlist'"
                        :style="!bannerPlaceHolderForBuyNow ? 'left: 25%;' : ''"
                      ></span>
                      <span class="wishlistText" v-if="bannerPlaceHolderForBuyNow">&emsp; wishlist</span>
                    </button>
                  </div>
                  <div class="col btnRow">
                    <router-link :to="'/cart'" class="btn btn-primary btn-lg btn-block  pointer text-uppercase btnWidth"
                      v-if="goToCart || (product.prod_type === 6 && isComboProductAddedInCart) || (isTssCorpProduct && isTssCorporateProductAddedInCart)" @click.native="goToCartClick" :class="{'mr0': isTssCorpProduct || product.prod_type === 6}">Go to cart
                    </router-link>
                    <button class="btn btnWidth btn-lg btn-block pointer stockButton disabled" type="button" v-else-if="(isSouledOut || isOutOfStock) && !isComboBreaked">
                      Out of Stock
                    </button>
                      <button :style=[cartSaleStyle] class="btn btn-danger btnWidth btn-lg btn-block pointer" type="button" v-on:click="addToCart()" v-else-if="enableActionBoton && isBlurProductClickablePdp && !['camouflage-olive-hoodie', 'black-panther-proutility-backpack', 'black-panther-proutility-backpack', 'avengers-varsity-jacket', 'mumbai-indians-fan-rohit-45-jersey', 'anniversary-collection-captain-america-tshirt', 'anniversary-collection-spider-man-tshirt', 'anniversary-collection-black-panther-tshirt', 'anniversary-collection-hulk-tshirt', 'anniversary-collection-thor-tshirt', 'anniversary-collection-iron-man-tshirt'].includes(productSlug) || (productSlug === 'camouflage-olive-hoodie' && now >= endDate && isExclusive)
                        || (['black-panther-proutility-backpack'].includes(productSlug) && now >= endDate)
                        || (productSlug === 'black-panther-proutility-backpack' && endDate != exclusiveDate && ((now >= exclusiveDate && isExclusive) || now > endDate))
                        || (productSlug === 'batman-3d-logo-tshirt' && endDate != exclusiveDate && ((now >= exclusiveDate && isExclusive) || now > endDate))
                        || (productSlug === 'avengers-varsity-jacket' && now > endDate)
                        || (productSlug === 'mumbai-indians-fan-rohit-45-jersey' && now > endDate)
                        || (productSlug === 'anniversary-collection-captain-america-tshirt' && now > endDate)
                        || (productSlug === 'anniversary-collection-spider-man-tshirt' && now > endDate)
                        || (productSlug === 'anniversary-collection-black-panther-tshirt' && now > endDate)
                        || (productSlug === 'anniversary-collection-hulk-tshirt' && now > endDate)
                        || (productSlug === 'anniversary-collection-thor-tshirt' && now > endDate)
                        || (productSlug === 'anniversary-collection-iron-man-tshirt' && now > endDate)
                        "
                              :disabled="disabled || isProductInLocalCart || isProductInLocalCartProperty || checkDisabled() || (this.product.prod_type === 6 && selectedComboVariants && Object.keys(selectedComboVariants).length <= 0)"
                              :class="{'mr0': isTssCorpProduct || product.prod_type === 6}"
                              >
                             {{cartSaleStyle && cartSaleStyle.text ? cartSaleStyle.text : 'Add to cart'}}
                      </button>
                      <button class="btn btn-danger btnWidth btn-lg btn-block pointer" type="button" v-else-if="enableActionBoton && isBlurProductClickablePdp && (productSlug === 'camouflage-olive-hoodie' && (!isExclusive || (isExclusive && now < endDate)))
                      || (['black-panther-proutility-backpack'].includes(productSlug) && now < endDate)
                      || (productSlug === 'black-panther-proutility-backpack' && (now < exclusiveDate) || (now < endDate && endDate != exclusiveDate && !isExclusive))
                      || (productSlug === 'batman-3d-logo-tshirt' && (now < exclusiveDate) || (now < endDate && endDate != exclusiveDate && !isExclusive))
                      || (productSlug === 'avengers-varsity-jacket' && now <= endDate)
                      || (productSlug === 'mumbai-indians-fan-rohit-45-jersey' && now <= endDate)
                      || (productSlug === 'anniversary-collection-captain-america-tshirt' && now <= endDate)
                      || (productSlug === 'anniversary-collection-spider-man-tshirt' && now <= endDate)
                      || (productSlug === 'anniversary-collection-black-panther-tshirt' && now <= endDate)
                      || (productSlug === 'anniversary-collection-hulk-tshirt' && now <= endDate)
                      || (productSlug === 'anniversary-collection-thor-tshirt' && now <= endDate)
                      || (productSlug === 'anniversary-collection-iron-man-tshirt' && now <= endDate)
                      "
                              disabled :class="{'mr0': isTssCorpProduct || product.prod_type === 6}">Add to cart
                      </button>
                      <button class="btn pointer wishList_Btn" type="button" v-if="enableActionBoton && isBlurProductClickablePdp && isWishlist" @click="updateWishlist(getWishistPrmData, $event)"><i class="fa" :class="wishlistItemsIDs && product && wishlistItemsIDs[product.id] ? 'fa-heart' : 'fa-heart-o'" aria-hidden="true"></i>
                        <span v-if="product && wishlistItemsIDs && wishlistItemsIDs[product.id]">Added to Wishlist</span>
                        <span v-else>Add to Wishlist</span>
                      </button>
                  </div>
                  <div class="col" v-if="enableActionBoton && isBlurProductClickablePdp && !isSouledOut && !$parent.isDesktop && !bannerPlaceHolderForBuyNow && product.prod_type !== 6 && !isTssCorpProduct">
                    <button class="btn btn-lg btn-info btn-block pointer" style="border-radius: 3px; background-color: teal;" type="button" @click="buyNowHandler()">BUY NOW
                    </button>
                  </div>
                </div>
                <div class="membership_action_Btn" v-if="!enableActionBoton">
                  <button class="btn pointer membership_Btn" type="button" v-if="isWishlist" @click="AddMembership()">
                    <img class="ml-2" src="https://tss-static-images.gumlet.io/Vector.svg" alt=""> <span class="membership_Btn_text">Purchase membership to access</span>
                  </button>
                </div>
              </div>
            </div>
            </div>

            <div class="bx1 brdnone" v-if="!isTssCorpProduct && $parent.isDesktop">
              <div v-if="!isNewDesign" class="mb_mbo mb15">
                <div class="pull-left">Share </div>
                <div class="sharebtns f22" @click="open">
                  <social-sharing :url="tss + $route.path" inline-template :title="product.product">
                    <div>
                      <network network="whatsapp" class="showmobile disinline f24" v-if="!$parent.isDesktop" id="whatsapp">
                        <i class="fa fa-fw fa-whatsapp"></i>
                      </network>
                      <a :href="'https://web.whatsapp.com/send?text=https://www.thesouledstore.com'+this.$route.fullPath" class="nonecolor showdesktoplinine"  rel="noopener noreferrer" target="_blank" id="whatsapp"><span
                        class="fa fa-whatsapp"></span></a>
                      <network network="facebook" id="facebook">
                        <i class="fa fa-fw fa-facebook-square"></i>
                      </network>
                      <network network="twitter" id="twitter">
                        <i class="fa fa-fw fa-twitter"></i>
                      </network>
                      <a href="https://www.instagram.com/TheSouledStore/" class="nonecolor" target="_blank" rel="noopener noreferrer" id="instagram"><span
                        class="fa fa-instagram"></span></a>
                    </div>
                  </social-sharing>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="seperator seperatorExtra" v-if="bannerPlaceHolderTSSPoints && bannerPlaceHolderTSSPoints.tss_points && !(product.variant && product.variant.length > 0
                    && (productSlug !== 'black-panther-proutility-backpack' || (productSlug === 'black-panther-proutility-backpack' && endDate != exclusiveDate && ((now >= exclusiveDate && isExclusive) || now > endDate)))
                    && (!['black-panther-proutility-backpack'].includes(productSlug) || (['black-panther-proutility-backpack'].includes(productSlug) && now >= endDate))
                    && (productSlug !== 'avengers-varsity-jacket' || (productSlug === 'avengers-varsity-jacket' && now > endDate))
                    && (productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (productSlug === 'mumbai-indians-fan-rohit-45-jersey' && now > endDate))
                    && (productSlug !== 'anniversary-collection-captain-america-tshirt' || (productSlug === 'anniversary-collection-captain-america-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-spider-man-tshirt' || (productSlug === 'anniversary-collection-spider-man-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-black-panther-tshirt' || (productSlug === 'anniversary-collection-black-panther-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-hulk-tshirt' || (productSlug === 'anniversary-collection-hulk-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-thor-tshirt' || (productSlug === 'anniversary-collection-thor-tshirt' && now > endDate))
                    && (productSlug !== 'anniversary-collection-iron-man-tshirt' || (productSlug === 'anniversary-collection-iron-man-tshirt' && now > endDate))
                  )"></div>
            <div :class="$parent.isDesktop ? 'return-and-tss-message-box my-3' : 'my-1'">
              <!-- TSS Points Message starts here -->
              <div class="row" v-if="bannerPlaceHolderTSSPoints && bannerPlaceHolderTSSPoints.tss_points && isSelectedCountryIndia">
                <div class="col-12 col-md-12 return-msg-pdp tss-points-message-pdp d-flex justify-content-start align-items-center">
                  <img class="tss-points-icon" data-src="https://prod-img.thesouledstore.com/public/theSoul/images/appIcons/ic_tssMoney1@3x.png" alt="The Souled Store Points"/>
                  <p class=''>
                    <span :style="{color: bannerPlaceHolderTSSPoints.banner_text_color }">{{bannerPlaceHolderTSSPoints.prev_text}}</span>
                    <span class='tss-points'>{{bannerPlaceHolderTSSPoints.tss_points}}</span>
                    <span :style="{color: bannerPlaceHolderTSSPoints.banner_text_color }">{{bannerPlaceHolderTSSPoints.after_text}}</span>
                  </p>
                </div>
              </div>
              <!-- TSS Points Message ends here -->
            </div>
            <div class="seperator mb-1 seperatorExtra" v-if="bannerPlaceHolderTSSPoints && bannerPlaceHolderTSSPoints.tss_points"></div>
            <div :class="isNewDesign ? 'new-design-delivery' : ''" v-if="bannerPlaceHolderForDeliveryDetails && !isSelectedCountryUAE">
              <p class='delivery-details-txt'>Delivery Details</p>
              <form @submit.prevent="handlePinCodeChange">
                <div class='pincode-input-wrapper'>
                  <input
                    class="form-control"
                    :placeholder="isSelectedCountryIndia ? 'Enter Pincode' : 'Enter Zipcode'"
                    v-model="pincode" 
                    :minlength="isSelectedCountryUK ? 5 : pincodeLength" 
                    :maxlength="pincodeLength"
                    v-on:keydown="validatePinCode($event, pincodeLength, this.countryId)"
                    @input="handlePinCodeInputChange"
                    @paste="handlePaste">
                  <div class='pincode-btn-wrapper'>
                    <button class='btn-pincode' type="submit">{{pincodeBtnType}}</button>
                  </div>
                </div>
              </form>
              <div class="error-message" v-if="showSelectSizeValidationMsg">Please select {{ product.platform === 'KIDS' ? 'an age' : 'a size' }}</div>
              <div class="error-message" v-if="showPincodeValidationMsg">{{ validation.firstError('pincode') }}</div>
              <div v-if="deliveryDetails && deliveryDetails.success && deliveryDetails.data" class='mt15 delivery-details-content'>
                <div class='cod-message-text-wrapper' v-if="!isTssCorpProduct">
                  <img data-src='https://prod-img.thesouledstore.com/public/theSoul/images/icons/money-icon.png' alt="COD Details"/>
                  <p v-if="deliveryDetails.data.check_cod">{{bannerPlaceHolderForCODMessage && bannerPlaceHolderForCODMessage.tag_text}}</p>
                  <p v-else>{{bannerPlaceHolderForCODMessage && bannerPlaceHolderForCODMessage.description}}</p>
                </div>
                <div class='cod-message-text-wrapper'>
                <img data-src='https://prod-img.thesouledstore.com/public/theSoul/images/icons/truck-icon.png' alt="Delivery Estimate"/>
                <p v-if="deliveryDetails.data.serviceability && deliveryDetails.data.max_estimated_days_new">Estimated Delivery
                    <span v-if="estimatedDeliveryText">between {{getDeliveryDateRange}}.</span>
                    <span v-else>by {{getDeliveryDate}}.</span>
                </p>
                <p v-else>Delivery is not serviceable at this Pincode</p>
                </div>
              </div>
              <div class="mt10" v-else-if="deliveryDetails && deliveryDetails.data && !deliveryDetails.success">
                <p class="error-message">Delivery is not serviceable at this Pincode</p>
              </div>
            </div>
            <div class='return-and-tss-message-box my-3'>
              <!-- Return Message starts here -->
              <div class="row" v-if="product.exchange_return_message" >
                <div class="col-12 col-md-12 return-msg-pdp">
                  <div class="d-flex justify-content-start align-items-start">
                    <img class="return-icon-pdp img-auto" data-src="https://tss-static-images.gumlet.io/icons/return-icon.png" width="27" height="27" alt="Return Policy"/>
                    <div >
                      <p v-if="product.exchange_return_message && !product.exchange_return_message.toLowerCase().includes('know more')" class='mb-0' :style="showBoldReturnText && 'font-weight: bold'">{{product.exchange_return_message}}</p>
                      <p v-else class='mb-0' :style="showBoldReturnText && 'font-weight: bold'">
                        <span v-for="(text, index) in productReturnMsgArr(product.exchange_return_message)" :key="index">
                          <span v-if="text && text.toLowerCase() === 'know more'"  class="selectcolor pointer" :class="!$parent.isDesktop ? 'dspBlock' : ''" @click="returnPolicyKnowMore = !returnPolicyKnowMore">{{text}}</span>
                          <span v-else v-html="text"></span>
                        </span>
                      </p>
                      <div class='mt10' v-if="$parent.isDesktop && returnPolicyKnowMore && customisedProdFaqs && Object.keys(customisedProdFaqs).length">
                        <p class='fbold mb0'>FAQs</p>
                        <faqsQuestionsListing :selectedFaq="customisedProdFaqs" :selectedFaqIndex="1" callerComp="customised-prod-faqs"></faqsQuestionsListing>
                      </div>
                    </div>

                  </div>
                  <div class='mt10' v-if="!$parent.isDesktop && returnPolicyKnowMore && customisedProdFaqs && Object.keys(customisedProdFaqs).length">
                      <p class='fbold mb0'>FAQs</p>
                      <faqsQuestionsListing :selectedFaq="customisedProdFaqs" :selectedFaqIndex="1" callerComp="customised-prod-faqs"></faqsQuestionsListing>
                    </div>
                </div>
              </div>
              <!-- Return Message ends here -->
            </div>
            <div v-if="showTickerPoints && tickerPoint && isSelectedCountryIndia" class="ticker-point mt-3 d-flex justify-content-start align-items-center">
              <img src="https://tss-static-images.gumlet.io/gift-box.png" alt="wishlist" width="40" height="40" />
              <p class="ticker-text m-0 p-0" v-html="tickerPoint"></p>
            </div>            
        <div class="mtb15 w100 mr-0">
          <div v-if="isNewDesign && $parent.isDesktop" class="new-design-tabs">
            <ul class="nav nav-pills" role="tablist">
              <li class="nav-item" v-if="bannerPlaceHolderForCustomerReviews && product.category && (product.category === 'Women Pajamas' || product.category === 'Women Pajama Sets' || product.category === 'Women Pajama Set' || product.category.indexOf('Pocket Dresses') !== -1 || product.category === 'Women Bikini' || product.category === 'Women Boy Shorts' || product.category === 'Women Hipster Underwear')">
                <a class="nav-links" data-toggle="pill" href="#tabs-1">Customer Reviews</a>
              </li>
              <li class="nav-item" v-if="product.add_desc">
                <a class="nav-links active" data-toggle="pill" href="#tabs-2">Product Details</a>
              </li>
              <li class="nav-item" v-if="product.short_desc">
                <a class="nav-links" data-toggle="pill" href="#tabs-3">Product Description</a>
              </li>
              <li class="nav-item" v-if="product.user_description">
                <a class="nav-links" data-toggle="pill" href="#tabs-4">Artist's Details</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade" id="tabs-1" v-if="bannerPlaceHolderForCustomerReviews && product.category && (product.category === 'Women Pajamas' || product.category === 'Women Pajama Sets' || product.category === 'Women Pajama Set' || product.category.indexOf('Pocket Dresses') !== -1 || product.category === 'Women Bikini' || product.category === 'Women Boy Shorts' || product.category === 'Women Hipster Underwear')">
                <div class="card-block pg-block" v-if="productPerData && productPerData.length">
                  <div  v-for="(val, index) in productPerData" :key="index">
                    <div class="pg-col" v-if="product.category.indexOf(val.category) !== -1">
                    <span>{{val.title}}</span>
                      <div class="progress progress-danger active" aria-valuenow="12">
                        <div class="bar" :style="'width:'+val.percentage+'%'"></div>
                      </div>
                    <span class="pull-right prg-text">{{val.text}} ({{val.percentage}}%)</span>
                    </div>
                  </div>
                </div>
                <div v-if="reviewsData && reviewsData.length" class="scrolldiv">
                  <div v-for="(rew, index) in shuffle(reviewsData)" :key="index" >
                    <div class="cus-review" v-if="product.category.indexOf(rew.category) !== -1">
                      <span  v-html="rew.text"></span>
                      <div class="name-age"><span>{{rew.name}}</span><span v-if="rew.age"> | Age - {{rew.age}} years</span></div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="tab-pane active" id="tabs-2" v-if="product.add_desc">
              <div class="card-block clearfix">
                <p v-html="product.add_desc"></p>
              </div>
            </div>
            <div class="tab-pane fade" id="tabs-3" v-if="product.short_desc">
              <div class="card-block clearfix">
                <p>
                  <span v-html="product.short_desc"></span>
                </p>
              </div>
            </div>
            <div class="tab-pane fade" id="tabs-4" v-if="product.user_description">
              <div class="card-block clearfix">
                <p>
                  <span v-html="product.user_description"></span>
                </p>
              </div>
            </div>
            </div>
          </div>
          <div v-else id="accordion" role="tablist" aria-multiselectable="true" class="accordiontabs">
            <div class="card" v-if="bannerPlaceHolderForCustomerReviews && product.category && (product.category === 'Women Pajamas' || product.category === 'Women Pajama Sets' || product.category === 'Women Pajama Set' || product.category.indexOf('Pocket Dresses') !== -1 || product.category === 'Women Bikini' || product.category === 'Women Boy Shorts' || product.category === 'Women Hipster Underwear')">
              <div class="card-header" role="tab" id="headingThree">
                <h5 class="mb-0 accordianheading">
                  <a class="collapsed cusrev" style="display:block" data-toggle="collapse" data-parent="#accordion" href="#collapseThree"
                    aria-expanded="true" aria-controls="collapseThree" @click="productDescription">
                    <!-- <img class="tss-points-icon" data-src="https://prod-img.thesouledstore.com/public/theSoul/images/icons/review.svg" alt="The Souled Store Points"/> -->
                    Customer Reviews
                  </a>
                </h5>
              </div>
              <div id="collapseThree" class="collapse show" role="tabpanel" aria-labelledby="headingThree">
                <div class="card-block pg-block" v-if="productPerData && productPerData.length">
                  <div  v-for="(val, index) in productPerData" :key="index">
                    <div class="pg-col" v-if="product.category.indexOf(val.category) !== -1">
                      <span>{{val.title}}</span>
                      <div class="progress progress-danger active" aria-valuenow="12">
                        <div class="bar" :style="'width:'+val.percentage+'%'"></div>
                      </div>
                      <span class="pull-right prg-text">{{val.text}} ({{val.percentage}}%)</span>
                    </div>
                  </div>
                </div>
                <div v-if="reviewsData && reviewsData.length" class="scrolldiv">
                  <div v-for="(rew, index) in shuffle(reviewsData)" :key="index" >
                    <div class="cus-review" v-if="product.category && product.category.indexOf(rew.category || '') !== -1">
                      <span  v-html="rew.text"></span>
                      <div class="name-age"><span>{{rew.name}}</span><span v-if="rew.age"> | Age - {{rew.age}} years</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="product.add_desc">
              <div class="card-header" role="tab" id="headingOne">
                <h5 class="mb-0 accordianheading">
                  <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" :aria-expanded="bannerPlaceHolderForCustomerReviews && product.category && (product.category === 'Women Pajamas' || product.category === 'Women Pajama Sets' || product.category === 'Women Pajama Set' || product.category.indexOf('Pocket Dresses') !== -1 || product.category === 'Women Bikini' || product.category === 'Women Boys Shorts' || product.category === ' Women Hipster Underwear') ? 'false' : 'true'"
                    aria-controls="collapseOne" @click="productDetails">
                    Product Details
                  </a>
                </h5>
              </div>
              <div id="collapseOne" :class="bannerPlaceHolderForCustomerReviews && product.category && (product.category === 'Women Pajamas' || product.category === 'Women Pajama Sets' || product.category === 'Women Pajama Set' || product.category.indexOf('Pocket Dresses') !== -1 || product.category === 'Women Bikini' || product.category === 'Women Boys Shorts' || product.category === ' Women Hipster Underwear') ? 'collapse' : 'collapse show'" aria-expanded="false" role="tabpanel"
                  aria-labelledby="headingOne">
                <div class="card-block" ref="descBlock" @click="handleCertificateClick">
                  <p v-html="product.add_desc"></p>
                </div>
              </div>
            </div>
            <div class="card" v-if="product.short_desc">
              <div class="card-header" role="tab" id="headingTwo">
                <h5 class="mb-0 accordianheading">
                  <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo"
                    aria-expanded="false" aria-controls="collapseTwo" @click="productDescription">
                    Product Description
                  </a>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                <div class="card-block">
                  <p>
                    <span v-html="product.short_desc"></span>
                  </p>
                </div>
              </div>
            </div>
            <div class="card" v-if="product.user_description">
              <div class="card-header" role="tab" id="headingArtist">
                <h5 class="mb-0 accordianheading">
                  <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseArtist"
                    aria-expanded="false" aria-controls="collapseArtist" @click="artistDetails">
                    Artist's Details
                  </a>
                </h5>
              </div>
              <div id="collapseArtist" class="collapse" role="tabpanel" aria-labelledby="headingArtist">
                <div class="card-block">
                  <p>
                    <span v-html="product.user_description"></span>
                  </p>
                </div>
              </div>
            </div>
        </div>
        <div v-if="bannerPlaceHolderReviewSection && product.avg_product_rating > 0">
            <ReviewModal :avgRating="product.avg_product_rating" :productId="this.product.id"></ReviewModal>
        </div>
        </div>

          </div>
        </div>
      </div>
      <!-- Recommended Products -->
      <div v-if="!isTssCorpProduct" class="d-flex flex-column">
        <!-- Show Frequent bought listing -->
        <div
          v-if="showFrequentlyBoughtListing && frequentlyBoughtPdpListing && frequentlyBoughtPdpListing.data && frequentlyBoughtPdpListing.data.length && product.images"
          class="pb-3 pdp-slider-listing"
          :style="{order: checkIsNumber(showFrequentlyBoughtListing.model_position)}"
        >
          <div class="seperator pb-3"></div>
          <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{ showFrequentlyBoughtListing.tag_text || 'Frequently Bought Products'}}</h3>
          <div class="headtop prelative top-banner">
            <carousel
              :navigationEnabled="$parent.isDesktop"
              :paginationEnabled="false"
              navigationNextLabel=" " navigationPrevLabel=" "
              :autoplay="false"
              class="bannerview pdpcarouselview"
              :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
              :perPage="$parent.isDesktop ? 4 : 2.5"
            >
              <slide v-for="(prm, index) in frequentlyBoughtPdpListing.data" :key="prm.id" class="col">
                <div class="alsoavail vueCaraSlidr" >
                  <img-block
                    :parry="prm.images" :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                    @click.native="frequentlyBoughtPdpEventHandler(prm)"
                    :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artist.name"
                    :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                    :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category.name" :genderType="prm.genderType"
                    :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                    :prodType="prm.prodType" :togglePopup="togglePopup" :imageCount="frequentlyBoughtPdpListing.data.length" :showImageBlurSoldOutDesign="true"
                    :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                    :headingTitle="showFrequentlyBoughtListing.tag_text || 'Frequently Bought Products'"
                  >
                  </img-block>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
        
        <!-- AI/ML Products -->
        <div v-if="productRecommData && Object.keys(productRecommData).length && product.images" id="crossSellProducts">
          <div v-for="(widget, widgetKey, index) of productRecommData" :key="index">
            <div v-if="widget && widget.length && bannerPlaceHolderForProductRecommData && bannerPlaceHolderForProductRecommData.includes(widgetKey)">
              <div v-if="!$parent.isDesktop" class="seperator pb-3"></div>
              <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{productRecommTitleMapping && productRecommTitleMapping[widgetKey]}}</h3>
              <carousel :perPage="2.5" :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel=" " navigationPrevLabel=" "  :autoplay="false" :perPageCustom="[[480, 2.5], [768, 3], [1200, 4]]">
                <slide v-for="(prm, index) in widget" :key="prm.id" class="col-md-3 col-6">
                  <div class="alsoavail vueCaraSlidr" >
                    <img-block :parry="prm.imageUrl" :position="index" :isExclusive="isExclusive"
                      :index="index" :urlKey="prm.product_slug" :productTitle="prm.product"
                      :productPrice="prm.price" :exclusivePrice="prm.exclusive_price" :jitValue="prm.jitValue" :productCat="prm.artist"
                      :pstock="prm.stock" :spprice="prm.spl_price" :listCat="prm.category && prm.category[0]" :genderType="prm.gender_type"
                      :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prod_qty" :scrollToProduct="scrollNow"
                      :prodType="prm.prod_type" :togglePopup="togglePopup" :showImageBlurSoldOutDesign="true"
                      :headingTitle="productRecommTitleMapping && productRecommTitleMapping[widgetKey]"
                      ></img-block>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
        <!-- SIMILAR SELL PRODUCTS -->
        <div
          v-else-if="showSimilarProductDetails && crossSellItems && crossSellItems.length > 0 && product.images"
          id="crossSellProducts"
          class="pb-3 pdp-slider-listing"
          :style="{order: checkIsNumber(showSimilarProductDetails.model_position)}"
        >
          <div class="seperator pb-3"></div>
          <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{showSimilarProductDetails.tag_text || 'Similar Products'}}</h3>
          <div class="headtop prelative top-banner">
            <carousel
              :navigationEnabled="$parent.isDesktop"
              :paginationEnabled="false"
              navigationNextLabel=" " navigationPrevLabel=" "
              :autoplay="false"
              class="bannerview pdpcarouselview"
              :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
              :perPage="$parent.isDesktop ? 4 : 2.5"
            >
              <slide v-for="(prm, index) in crossSellItems" :key="prm.id" class="col">
                <div class="alsoavail vueCaraSlidr" >
                  <img-block
                    :parry="prm.images" :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                    @click.native="crossSellEventHandler(prm)"
                    :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artist.name"
                    :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                    :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category.name" :genderType="prm.genderType"
                    :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                    :prodType="prm.prodType" :togglePopup="togglePopup" :imageCount="crossSellItems.length" :showImageBlurSoldOutDesign="true" :callerComp="crossSellName || 'Similar Products'"
                    :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                    :headingTitle="showSimilarProductDetails.tag_text || 'Similar Products'"
                  >
                  </img-block>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
        <!-- visenzeSearchItem PDP Listing -->
        <div v-if="true && visenzeSearchItem.products && visenzeSearchItem.products.length && isSelectedCountryIndia && enableVincenzeSearch"
          class="pb-3 pdp-slider-listing"
          id="visenzeSearchItem"
          :style="{order: checkIsNumber(4)}"
        >
          <div class="seperator pb-3"></div>
          <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{'Recommended Products'}}</h3>
          <div class="headtop prelative top-banner">
            <carousel
              :navigationEnabled="$parent.isDesktop"
              :paginationEnabled="false"
              navigationNextLabel=" " navigationPrevLabel=" "
              :autoplay="false"
              class="bannerview pdpcarouselview"
              :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
              :perPage="$parent.isDesktop ? 4 : 2.5"
            >
              <slide v-for="(prm, index) in visenzeSearchItem.products" :key="prm.id" class="col">
                <div class="alsoavail vueCaraSlidr" >
                  <img-block
                    :parry="prm.images" :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                    @click.native="crossSellPdpEventHandler(prm)"
                    :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artist.name"
                    :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                    :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category.name" :genderType="prm.genderType"
                    :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                    :prodType="prm.prodType" :togglePopup="togglePopup" :imageCount="visenzeSearchItem.length" :showImageBlurSoldOutDesign="true"
                    :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                    :headingTitle="'Recommended Products'" callerComp='Recommended Products'
                  >
                  </img-block>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
        <!-- CROSS SELL PDP LISTING -->
        <div v-if="crossSellPdpListing && crossSellPdpListing.data && crossSellPdpListing.data.length && crossSellingPdpDetails && product.images"
          class="pb-3 pdp-slider-listing"
          id="crossSellPdpListing"
          :style="{order: checkIsNumber(crossSellingPdpDetails.model_position)}"
        >
          <div class="seperator pb-3"></div>
          <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{ crossSellingPdpDetails.tag_text || 'You may also like'}}</h3>
          <div class="headtop prelative top-banner">
            <carousel
              :navigationEnabled="$parent.isDesktop"
              :paginationEnabled="false"
              navigationNextLabel=" " navigationPrevLabel=" "
              :autoplay="false"
              class="bannerview pdpcarouselview"
              :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
              :perPage="$parent.isDesktop ? 4 : 2.5"
            >
              <slide v-for="(prm, index) in crossSellPdpListing.data" :key="prm.id" class="col">
                <div class="alsoavail vueCaraSlidr" >
                  <img-block
                    :parry="prm.images" :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                    @click.native="crossSellPdpEventHandler(prm)"
                    :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artist.name"
                    :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                    :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category.name" :genderType="prm.genderType"
                    :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                    :prodType="prm.prodType" :togglePopup="togglePopup" :imageCount="crossSellPdpListing.data.length" :showImageBlurSoldOutDesign="true"
                    :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                    :headingTitle="crossSellingPdpDetails.tag_text || 'You may also like'"
                  >
                  </img-block>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
        <div v-if="showPersonalizedWidgetListing && personalizedWidgetListing && personalizedWidgetListing.data && personalizedWidgetListing.data.length && authStatus  && product.images"
          class="pb-3 pdp-slider-listing"
          id="crossSellPdpListing"
          :style="{order: checkIsNumber(showPersonalizedWidgetListing.model_position)}"
        >
          <div class="seperator pb-3"></div>
          <h3 :class="!$parent.isDesktop ? 'px-3' : ''" class="widget-heading fbold" style="color: black">{{ showPersonalizedWidgetListing.tag_text || 'Personalized products'}}</h3>
          <div class="headtop prelative top-banner">
            <carousel
              :navigationEnabled="$parent.isDesktop"
              :paginationEnabled="false"
              navigationNextLabel=" " navigationPrevLabel=" "
              :autoplay="false"
              class="bannerview"
              :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
              :perPage="$parent.isDesktop ? 4 : 2.5"
            >
              <slide v-for="(prm, index) in personalizedWidgetListing.data" :key="prm.id" class="col">
                <div class="alsoavail vueCaraSlidr" >
                  <img-block
                    :parry="prm.images" :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                    @click.native="crossSellPdpEventHandler(prm)"
                    :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artist.name"
                    :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                    :pstock="prm.stock" :spprice="prm.splPrice" :listCat="prm.category.name" :genderType="prm.genderType"
                    :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                    :prodType="prm.prodType" :togglePopup="togglePopup" :imageCount="personalizedWidgetListing.data.length" :showImageBlurSoldOutDesign="true"
                    :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                    :headingTitle="showPersonalizedWidgetListing.tag_text || 'Personalized products'"
                  >
                  </img-block>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!------ {{prview}} --------{{magActiveimg}} ---{{proimages}} -->
    <product-view v-if="prview" :isDesktop="this.$parent.isDesktop" @close="prview = false" :imgArray="product.images" :videoUrl="prviewImage"
                  :activeImg="magActiveimg"></product-view>
    <sizeimage-modal v-if="isImageModal" @close="isImageModal = false" :imageModalData="imageModalData"></sizeimage-modal>
    <MembershipPopUpBanner  :isVisible="isMembershipModalVisible" @close="closeMembershipPopup" @exclusiveMembershipAdded="handleExclusiveAdded" :bannerPlaceHolderForMemberShipBanner="bannerPlaceHolderForMemberShipBanner" v-if="bannerPlaceHolderForMemberShipBanner"></MembershipPopUpBanner>
    <div class="productAdded">Product has been added to cart.</div>
    <exclusive-modal v-if="isNotifyVisible" :addExclusive="addExclusive" :togglePopup="togglePopup" :exclusiveAdded="exclusiveAdded" :removeExcFromCart="removeExcFromCart" :memberSavings="product.price && product.exclusive_price && parseInt(product.price) - parseInt(product.exclusive_price)"/>
    <customized-prod-modal v-if="isCustomizedProdModal && imageModalData && Object.keys(imageModalData).length" :customizedProdData="imageModalData" @close="isCustomizedProdModal = false" :confirmCustomization="confirmCustomization" :prodPrintName="print_name" :prodPrintNumber="print_number" :artistSlug="product.artist_slug"></customized-prod-modal>
    </div>
<tssHelpDetails v-if="isHelp" :setPopup="helpDetails" :processData="processData" />

  </div>
</template>
<script data-obct type="text/javascript">
</script>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import {Carousel, Slide} from 'vue-carousel'
  import imgBlock from './common/imgBlock.vue'
  import tssHelpDetails from './common/tssHelpDetails.vue'

  import sizeHover from './common/sizeHover.vue'
  import popupModal from './common/popupModal.vue'
  import Loader from './common/loader.vue'
  // import auth from '../auth/index.js'
  import {metaElements} from '../assets/js/metaElements'
  import productView from './widgets/productView'
  import sizeimageModal from './widgets/sizeimageModal'
  import {mapGetters} from 'vuex'
  import Countdown from './common/Countdown'
  import Viewers from './common/Viewers'
  import ExclusiveModal from './common/ExclusiveModal.vue'
  import NoProductsFound from './common/NoProductsFound.vue'
  import NoProductFoundListing from './common/NoProductFoundListing.vue'
  import ExclusiveSavingsInfo from './common/ExclusiveSavingInfo'
  import VideoPlayer from './common/VideoPlayer.vue'
  import ExcBand from './common/ExcBand'
  import BannerPlaceHolderMsg from './common/BannerPlaceHolderMsg'
  import moment from 'moment/src/moment'
  import Vue from 'vue'
  import getLastPage from '../assets/js/getLastPage'
  import SocialSharing from 'vue-social-sharing'
  import SimpleVueValidation from 'simple-vue-validator'
  import SizeChartModal from './common/sizeChartModal.vue'
  import BuyNowMobile from './common/buyNowMobile.vue'
  import ProductZoomModal from './common/productZoomModal.vue'
  import customizedProdModal from './common/customizedProdModal.vue'
  import webPush from '@/assets/js/webPushNotification'
  import faqsQuestionsListing from './common/faqsQuestionsListing.vue'
  import {getProductUrl} from '../assets/js/common'
  import ReviewModal from './common/reviewModal.vue'
  import {appMixins} from '../assets/js/appMixins'
  import validationMixin from '../mixins/validationMixin'
  import NewDesignBanner from './common/NewDesignBanner'
  import ProductDetailMweb from './productdetailsmweb.vue'
  import MembershipPopUpBanner from './membershipPopUpBanner.vue'
  var Validator = SimpleVueValidation.Validator
  Vue.use(SocialSharing)

  export default {
    name: 'productdetails',
    mixins: [metaElements, appMixins, validationMixin],
    data () {
      return {
        isHelp: false,
        processDataTSSPoints: [],
        processData: [],
        contentScript: 'https://d1qflh9ill7vje.cloudfront.net/whatmore.js',
        contentKey: 'STRHFVBOIST',
        audio: null,
        noProductAllowed: false,
        isScrollAllowed: true,
        playVideo: true,
        demo: '',
        tickerText: [],
        isTickerActive: false,
        isshuffled: false,
        currentTickerIndex: 0,
        tickerInterval: null,
        productVoted: false,
        deviceType: '',
        addToCartData: {},
        productPageData: {},
        isMembershipModalVisible: false,
        exclusiveMembershipAdded: false,
        altPrefix: ['', 'Shop ', 'Buy ', 'Get ', 'Buy Online ', 'Best ', '', '', '', ''],
        prview: false,
        loading: false,
        prviewImage: '',
        prdImg: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
        customTextImg: process.env.CUSTOMIZE_TEXT_IMG,
        imgBaseUrl: process.env.IMG_BASE_URL,
        sizeChart: process.env.SIZE_CHART,
        imgSize: 'cdn-cgi/image/width=499,height=770,quality=100/',
        tss: process.env.TSS_URL,
        currentUrl: window.location.href,
        tactive: 0,
        magActiveimg: 0,
        showMoreColors: false,
        proimages: '',
        count: 1,
        sizevalid: false,
        getAvail: {},
        buynow: '',
        formData: {
          prod_id: '',
          prod_type: '',
          sub_prod: '',
          quantity: 1,
          category: '',
          spl_price: 0,
          price: 0,
          product: '',
          print_name: '',
          prod_qty: 0,
          is_mystery_product: 0
        },
        print_name: '',
        print_number: '',
        selectedProductVariant: '',
        options: {},
        category: '',
        addCartbtn: true,
        notifyvalid: false,
        notifymsg: '',
        disabled: false,
        sizeError: false,
        printNameError: false,
        staticImg: process.env.STATIC_IMG,
        now: '',
        startDate: '',
        endDate: '',
        exclusiveDate: '',
        liveSaleText: '',
        earlyAccessText: 'To get early access, add Exclusive membership to your cart (₹ 199/year)',
        bannerName: '',
        hourlyDealTimer: ['2019-12-25 12:00:00', '2019-12-25 13:00:00', '2019-12-25 14:00:00', '2019-12-25 15:00:00', '2019-12-25 16:00:00', '2019-12-25 17:00:00', '2019-12-25 18:00:00', '2019-12-25 19:00:00', '2019-12-25 20:00:00', '2019-12-25 21:00:00', '2019-12-25 22:00:00', '2019-12-25 23:00:00', '2019-12-26 00:00:00'],
        gifName: '',
        mp4Name: '',
        timerColor: '#d99b00',
        isOutOfStock: false,
        plistCheck: '[]',
        isNotifyVisible: false,
        exclusiveAdded: false,
        productSlug: '',
        exclusiveTimer: {
          TIMER_START: process.env.TIMER_START,
          TIMER_END: process.env.TIMER_END
        },
        selectedProduct: 0,
        IMG_URL: process.env.IMG_BASE_URL + process.env.PROD_IMG,
        timerInterval: '',
        stockLeftLimit: 10,
        curRoute: '',
        crossSellItems: [],
        visenzeSearchItem: [],
        crossSellName: '',
        addImgDescDesk: '',
        imgDimensions: {},
        addImgDescMob: '',
        imgPath: process.env.IMG_BASE_URL + 'public/theSoul/storage/',
        showExcBar: false,
        excBand: {
          showExcStyle: {
            backgroundColor: '#3498DB',
            color: '#ffffff'
          },
          excText: 'Exclusive Members get this t-shirt at ₹199 ONLY! Sign up for just ₹199 and save big all year round!'
        },
        saleDet: {},
        showTimer: false,
        showEarlyText: false,
        showCountDown: false,
        cartSaleStyle: {},
        showBlur: false,
        canonicalUrl0: '',
        canonicalUrl: '',
        productLiveDate: {
          date: null,
          dateSup: null,
          time: null,
          month: null
        },
        pincode: '',
        deliveryDetails: {},
        pincodeBtnType: 'CHECK',
        showPincodeValidationMsg: false,
        showSelectSizeValidationMsg: false,
        isSizeChartVisible: false,
        buyNowMobileVisibility: false,
        selectedComboVariants: {},
        selectedComboSizeChart: {},
        utm: {},
        productZoomMobile: false,
        hideWishlist: false,
        labelTimeInterval: null,
        isLabelLieInTime: false,
        isImageModal: false,
        isCustomizedProdModal: false,
        isCustomizedProd: false,
        imageModalData: '',
        isSizePopupActive: false,
        returnPolicyKnowMore: false,
        outofStockFirstProduct: {},
        outofStockFirstProductsize: [],
        productPerData: [
          {title: 'Fit', percentage: '91', text: 'True to Size', category: 'Pocket Dresses'},
          {title: 'Length', percentage: '84', text: 'As shown in image', category: 'Pocket Dresses'},
          {title: 'Fabric', percentage: '88', text: 'Premium', category: 'Pocket Dresses'},
          {title: 'Fit', percentage: '85', text: 'True to Size', category: 'Pajama'},
          {title: 'Length', percentage: '89', text: 'As shown in image', category: 'Pajama'},
          {title: 'Fabric', percentage: '92', text: 'Premium', category: 'Pajama'},
          {title: 'Fit', percentage: '94', text: 'True to Size', category: 'Women Bikini'},
          {title: 'Length', percentage: '86', text: 'As shown in image', category: 'Women Bikini'},
          {title: 'Fabric', percentage: '98', text: 'Premium', category: 'Women Bikini'},
          {title: 'Fit', percentage: '94', text: 'True to Size', category: 'Women Boy Shorts'},
          {title: 'Length', percentage: '86', text: 'As shown in image', category: 'Women Boy Shorts'},
          {title: 'Fabric', percentage: '98', text: 'Premium', category: 'Women Boy Shorts'},
          {title: 'Fit', percentage: '94', text: 'True to Size', category: 'Women Hipster Underwear'},
          {title: 'Length', percentage: '86', text: 'As shown in image', category: 'Women Hipster Underwear'},
          {title: 'Fabric', percentage: '98', text: 'Premium', category: 'Women Hipster Underwear'}
        ],
        reviewsData: [
          {
            text: 'The material is very good , comfortable to wear. It`s just like the picture. I will recommend the dress.',
            name: 'Ruchika Parashar Gupta',
            category: 'Pocket Dresses',
            age: '25'
          },
          {
            text: 'Good material & perfect fit! I had brought this for my sister and she loved it! The material is good and love the print as well. I have brought 2 patterns and would buy again.Excellent!',
            name: 'Melanie',
            category: 'Pocket Dresses',
            age: '29'
          },
          {
            text: 'Fancy, cute, enormously comfortable, colour is a little lighter than I expected, but the cutting complements body shape really well. the length is perfect with my 5.2" height, it just touches the knee. as good as it looks, the material is unbelievably soft too..really happy with the purchase at this price.',
            name: 'Ankur priyadarshi',
            category: 'Pocket Dresses',
            age: '27'
          },
          {
            text: 'Beautiful color excellent fit superb cotton. Colour as shown in the picture. True to size. Soft comfortable cotton cloth. Decent and beautiful dress.',
            name: 'Divya M.',
            category: 'Pocket Dresses',
            age: '22'
          },
          {
            text: 'Sooper classy colour is way good than when compared to the image....',
            name: 'Mavuri Madhuri',
            category: 'Pocket Dresses',
            age: '32'
          },
          {
            text: 'Its a beautiful dress the colour is so pretty loved it.',
            name: 'Reema Tiwari',
            category: 'Pocket Dresses',
            age: '28'
          },
          {
            text: 'A lil big and long on me. But loved the print. So kept it. Looks supercute.',
            name: 'Suparna',
            category: 'Pocket Dresses',
            age: '21'
          },
          {
            text: 'Awesome dress, exactly the same as I wanted 👍👍👍👍',
            name: 'Anita',
            category: 'Pocket Dresses',
            age: '25'
          },
          {
            text: 'Nice dress...quality is good....my daughter love it',
            name: 'Ami Mehta',
            category: 'Pocket Dresses',
            age: '31'
          },
          {
            text: 'These are so cute but yet super comfy for work, been wearing these regularly. Especially loving the oversized fit dresses!',
            name: 'Shivani',
            category: 'Pocket Dresses',
            age: '26'
          },
          {
            text: 'Was worried about the fit and length but it’s exactly how it is on the model. Super happy with the product, really nice quality especially for the price',
            name: 'Miloni',
            category: 'Pocket Dresses',
            age: '24'
          },
          {
            text: 'In summers there’s nothing better than changing out of jeans to these pajamas. So soft and airy, just what I needed!',
            name: 'Pralisha',
            category: 'Pajama',
            age: '28'
          },
          {
            text: 'Loveeee the prints and the quality is really good too. Been using it for 5 months regularly now and it is still the same.',
            name: 'Jidgyasa',
            category: 'Pajama',
            age: '25'
          },
          {
            text: 'The prints are cute but what’s best is that these dont shrink like all other pajamas even after regular washing',
            name: 'Lavina',
            category: 'Pajama',
            age: '21'
          },
          {
            text: 'Superrrr comfy, bought them for the prints but love how the fabric feels so soft on your skin.',
            name: 'Dhara',
            category: 'Pajama',
            age: '23'
          },
          {
            text: 'Want more prints in the pajama sets like the coord sets, rest these are super comfy.',
            name: 'Komal',
            category: 'Pajama',
            age: '25'
          },
          {
            text: 'The quality and print is top notch for the pricing. Usually these pajama sets cost a good 2k.',
            name: 'Shreya',
            category: 'Pajama',
            age: '29'
          },
          {
            text: 'They’re so soft and nice on the skin that wearing them all day long now, I hate getting into pants or jeans after having worn these! ',
            name: 'Priyanshi',
            category: 'Pajama',
            age: '26'
          },
          {
            text: 'The plain one is so pretty and classy, please bring more colours in it.',
            name: 'Tanvi',
            category: 'Pajama',
            age: '20'
          },
          {
            text: 'Good material, really cute prints. The fabric remains the same even after several washing otherwise pajamas usually tend to shrink or lose shape. So great job there!',
            name: 'Richika',
            category: 'Pajama',
            age: '27'
          },
          {
            text: 'Saw all my favourite influencers wear it and bought it after that. Super happy with the quality, everybody who sees me in these asks where they are from. Already got 3 of them, waiting for more designs to launch',
            name: 'Kinal',
            category: 'Pajama',
            age: '19'
          },
          {
            text: 'I recently purchased 2 pairs of the hipster briefs. I read all the testimonials about these before buying, then decided that I would only buy 2 pairs because I doubt these are THAT good! But they are in fact very good, I actually am not aware I’m wearing them most of the time!',
            name: 'Swati',
            category: 'Women Bikini',
            age: '26'
          },
          {
            text: 'Been trying different undies and probably spent more than I should. Wish I found these ones from Souled Store first!!! Soft, smoothh, fits, not constricting... in short amazing.',
            name: 'Dhara',
            category: 'Women Bikini',
            age: '23'
          },
          {
            text: 'Bought the briefs in size M. Well made, not flimsy like a lot of printed underwears these days. Material is quite thick, but, very comfortable. The fit is perfect for my size and shape, no riding up or having to constantly adjust like most cheap briefs.',
            name: 'Manisha',
            category: 'Women Bikini',
            age: '31'
          },
          {
            text: 'Very comfortable, fit well and fast delivery.',
            name: 'Priyanshi',
            category: 'Women Bikini',
            age: '22'
          },
          {
            text: 'Very soft and easy on the skin. No rolling or lifting, well made and I will be purchasing again.',
            name: 'Yaamini',
            category: 'Women Bikini',
            age: '27'
          },
          {
            text: 'Breathable but firm enough to feel secure. Very happy with my purchase. :-)',
            name: 'Pakhi',
            category: 'Women Bikini',
            age: '21'
          },
          {
            text: 'I love love love them, no riding up and cutest prints.',
            name: 'Nina',
            category: 'Women Bikini',
            age: '29'
          },
          {
            text: 'I went for these because I wnated some fun prints and didnt expect much from quality but I was happily surprised.',
            name: 'Kashmira',
            category: 'Women Bikini',
            age: '26'
          },
          {
            text: 'Really like these but wish they removed more solid colours.',
            name: 'Tamanna',
            category: 'Women Bikini',
            age: '22'
          },
          {
            text: 'First time I’ve bought from you guys. I’ve been searching everywhere to find some cute good quality underwear. Then I came across an ad for these on Facebook. So happy I tried these, keep recommending it to my friends and family!!',
            name: 'Heena',
            category: 'Women Bikini',
            age: '24'
          },
          {
            text: 'I recently purchased 2 pairs of the hipster briefs. I read all the testimonials about these before buying, then decided that I would only buy 2 pairs because I doubt these are THAT good! But they are in fact very good, I actually am not aware I’m wearing them most of the time!',
            name: 'Swati',
            category: 'Women Boy Shorts',
            age: '26'
          },
          {
            text: 'Been trying different undies and probably spent more than I should. Wish I found these ones from Souled Store first!!! Soft, smoothh, fits, not constricting... in short amazing.',
            name: 'Dhara',
            category: 'Women Boy Shorts',
            age: '23'
          },
          {
            text: 'Bought the briefs in size M. Well made, not flimsy like a lot of printed underwears these days. Material is quite thick, but, very comfortable. The fit is perfect for my size and shape, no riding up or having to constantly adjust like most cheap briefs.',
            name: 'Manisha',
            category: 'Women Boy Shorts',
            age: '31'
          },
          {
            text: 'Very comfortable, fit well and fast delivery.',
            name: 'Priyanshi',
            category: 'Women Boy Shorts',
            age: '22'
          },
          {
            text: 'Very soft and easy on the skin. No rolling or lifting, well made and I will be purchasing again.',
            name: 'Yaamini',
            category: 'Women Boy Shorts',
            age: '27'
          },
          {
            text: 'Breathable but firm enough to feel secure. Very happy with my purchase. :-)',
            name: 'Pakhi',
            category: 'Women Boy Shorts',
            age: '21'
          },
          {
            text: 'I love love love them, no riding up and cutest prints.',
            name: 'Nina',
            category: 'Women Boy Shorts',
            age: '29'
          },
          {
            text: 'I went for these because I wnated some fun prints and didnt expect much from quality but I was happily surprised.',
            name: 'Kashmira',
            category: 'Women Boy Shorts',
            age: '26'
          },
          {
            text: 'Really like these but wish they removed more solid colours.',
            name: 'Tamanna',
            category: 'Women Boy Shorts',
            age: '22'
          },
          {
            text: 'First time I’ve bought from you guys. I’ve been searching everywhere to find some cute good quality underwear. Then I came across an ad for these on Facebook. So happy I tried these, keep recommending it to my friends and family!!',
            name: 'Heena',
            category: 'Women Boy Shorts',
            age: '24'
          },
          {
            text: 'I recently purchased 2 pairs of the hipster briefs. I read all the testimonials about these before buying, then decided that I would only buy 2 pairs because I doubt these are THAT good! But they are in fact very good, I actually am not aware I’m wearing them most of the time!',
            name: 'Swati',
            category: 'Women Hipster Underwear',
            age: '26'
          },
          {
            text: 'Been trying different undies and probably spent more than I should. Wish I found these ones from Souled Store first!!! Soft, smoothh, fits, not constricting... in short amazing.',
            name: 'Dhara',
            category: 'Women Hipster Underwear',
            age: '23'
          },
          {
            text: 'Bought the briefs in size M. Well made, not flimsy like a lot of printed underwears these days. Material is quite thick, but, very comfortable. The fit is perfect for my size and shape, no riding up or having to constantly adjust like most cheap briefs.',
            name: 'Manisha',
            category: 'Women Hipster Underwear',
            age: '31'
          },
          {
            text: 'Very comfortable, fit well and fast delivery.',
            name: 'Priyanshi',
            category: 'Women Hipster Underwear',
            age: '22'
          },
          {
            text: 'Very soft and easy on the skin. No rolling or lifting, well made and I will be purchasing again.',
            name: 'Yaamini',
            category: 'Women Hipster Underwear',
            age: '27'
          },
          {
            text: 'Breathable but firm enough to feel secure. Very happy with my purchase. :-)',
            name: 'Pakhi',
            category: 'Women Hipster Underwear',
            age: '21'
          },
          {
            text: 'I love love love them, no riding up and cutest prints.',
            name: 'Nina',
            category: 'Women Hipster Underwear',
            age: '29'
          },
          {
            text: 'I went for these because I wnated some fun prints and didnt expect much from quality but I was happily surprised.',
            name: 'Kashmira',
            category: 'Women Hipster Underwear',
            age: '26'
          },
          {
            text: 'Really like these but wish they removed more solid colours.',
            name: 'Tamanna',
            category: 'Women Hipster Underwear',
            age: '22'
          },
          {
            text: 'First time I’ve bought from you guys. I’ve been searching everywhere to find some cute good quality underwear. Then I came across an ad for these on Facebook. So happy I tried these, keep recommending it to my friends and family!!',
            name: 'Heena',
            category: 'Women Hipster Underwear',
            age: '24'
          }
        ],
        isVarientSelectedSizeChart: false,
        googleAdwordsId: process.env.GOOGLE_ADWORDS_ID,
        isProdMounted: false,
        pdpLandingDate: '',
        specificComboVarArr: [],
        specificComboFormData: [],
        specificSizeError: [],
        commonComboVariantsProd: {},
        newDesignShare: false,
        hasScrolled: false,
        hasScrolledClass: false,
        isPriceSectionFixed: false,
        merchantId: process.env.SNAPMINT_MERCHANT_ID,
        newDesignMweb: false,
        updatedVersion: 0,
        tickerPoint: null,
        tssPoint: null,
        countryId: this.$store.state.selectedCountryAddress.countryId,
        isProductInLocalCartProperty: false
      }
    },
    components: {imgBlock, tssHelpDetails, Carousel, Slide, sizeHover, popupModal, productView, sizeimageModal, Countdown, Viewers, ExclusiveModal, NoProductsFound, Loader, ExclusiveSavingsInfo, VideoPlayer, ExcBand, BannerPlaceHolderMsg, SizeChartModal, BuyNowMobile, ProductZoomModal, customizedProdModal, faqsQuestionsListing, NoProductFoundListing, ReviewModal, NewDesignBanner, ProductDetailMweb, MembershipPopUpBanner},
    methods: {
      waitForUserData () {
        if (this.user && this.user.tss_points !== undefined) {
          this.updateTSSPointsData()
        } else {
          setTimeout(this.waitForUserData, 50) // Retry until user is available
        }
      },
      handleCertificateClick (event) {
        const anchor = event.target.closest('#testCertificate')
        if (anchor) {
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'PRODUCT_TEST_CERTIFICATES_CLICKED',
            payload: {
              UserId: this.user && this.user.user_id,
              DateTime: new Date() && new Date().toISOString(),
              Platform: 'WEB'
            }}
          )
          this.$store.commit('GTAG_EVENT', {eventName: 'PRODUCT_TEST_CERTIFICATES_CLICKED',
            payload: {
              UserId: this.user && this.user.user_id,
              DateTime: new Date() && new Date().toISOString(),
              Platform: 'WEB'
            }}
          )
        }
      },
      updateTSSPointsData () {
        if (this.user && this.user.tss_points !== undefined) {
          const tssPoints = parseFloat(this.user.tss_points).toFixed(2)
          const expiry = this.user.tss_point_expiry || (this.tssPoints && this.tssPoint.tss_point_expiry_date)
          const hasExpiry = !!expiry
          const expiryFormatted = hasExpiry ? this.formatExpiryDate(expiry) : ''

          let bannerDescriptions = []

          if (this.bannerPlaceHolderForTSSpointsdescription && this.bannerPlaceHolderForTSSpointsdescription.description) {
            try {
              bannerDescriptions = JSON.parse(this.bannerPlaceHolderForTSSpointsdescription.description)
            } catch (e) {
              console.error('Invalid JSON in banner.description', e)
            }
          }
          let headerMessage = ''
          if (this.bannerPlaceHolderForTSSPointsHeaderMessage && this.bannerPlaceHolderForTSSPointsHeaderMessage.description && tssPoints > 0) {
            headerMessage = this.bannerPlaceHolderForTSSPointsHeaderMessage.description
              .replace('{value}', tssPoints)

            if (hasExpiry) {
              headerMessage = headerMessage.replace('{expiry_date}', expiryFormatted)
            } else {
              headerMessage = headerMessage.replace(/\s*(by)?\s*{expiry_date}/, '')
            }
          }

          // Remove first banner item if it duplicates headerMessage
          if (bannerDescriptions.length > 0 && bannerDescriptions[0] === headerMessage) {
            bannerDescriptions.shift()
          }

          this.processDataTSSPoints = [headerMessage, ...bannerDescriptions]
        }
      },
      formatExpiryDate (dateStr) {
        const dateOnly = dateStr.split(' ')[0] // Get "YYYY-MM-DD"
        const date = new Date(dateOnly)

        const day = date.getDate()
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const month = monthNames[date.getMonth()]
        const year = date.getFullYear()

        // Add ordinal suffix to day
        const getOrdinal = (n) => {
          const s = ['th', 'st', 'nd', 'rd']
          const v = n % 100
          return s[(v - 20) % 10] || s[v] || s[0]
        }

        return `${day}${getOrdinal(day)} ${month}, ${year}.`
      },
      helpDetails () {
        this.isHelp = !this.isHelp
      },
      setTSSMoneyData () {
        this.processData = this.processDataTSSMoney
        this.isHelp = true
      },
      setTSSPointsData () {
        // this.processDataTSSPoints[1] = `You can pay a maximum ${this.calculations.tss_points_discount}% of your cart value as TSS points.`
        this.processData = this.processDataTSSPoints
        this.isHelp = true
      },
      loadWhatmoreScript () {
        const existingScript = document.getElementById('whatmore-script')
        if (existingScript) {
          existingScript.remove()
        }
        const script = document.createElement('script')
        script.id = 'whatmore-script'
        script.src = this.contentScript
        script.defer = true
        script.type = 'text/javascript'
        document.body.appendChild(script)
        script.onload = () => {
          console.log('Whatmore script loaded and ready.')
        }
      },
      isProductInLocalCartMethod () {
        const localCartMeta = Vue.ls.get('localcart') && Vue.ls.get('localcart').products && Vue.ls.get('localcart').products.items || []
        const currentProdId = this.product && this.product.id
        this.isProductInLocalCartProperty = localCartMeta.some(item => {
          // Log each item's product ID for debugging
          // Check if the product ID matches and is not a mystery product
          return item.parent_prod_id === currentProdId && item.is_mystery_product === 1
        })
      },
      startTicker () {
        if (this.bannerPlaceHolderForPdpTicker) {
          const intervalTime = parseInt(this.bannerPlaceHolderForPdpTicker.description) || 2000
          this.tickerInterval = setInterval(() => {
            this.$nextTick(() => {
              this.$store.commit('SET_CURRENT_TICKER_TEXT', this.tickerText[this.currentTickerIndex])
              this.currentTickerIndex = (this.currentTickerIndex + 1) % this.tickerText.length
            })
          }, intervalTime)
        }
      },
      detectDeviceType () {
        const userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.includes('mobi')) {
          this.deviceType = 'mobile'
        } else if (userAgent.includes('tablet')) {
          this.deviceType = 'tablet'
        } else {
          this.deviceType = 'desktop'
        }
      },
      trackAddToCart () {
        // Dynamically create iframe
        const iframe = document.createElement('iframe')
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = '0'
        iframe.style.display = 'none'
        iframe.src = `https://catalog2.hypd.store/affiliate/tracking?merchant=SOULEDSTORE&event=add_to_cart&value=${encodeURIComponent(JSON.stringify(this.addToCartData))}`
        // Append iframe to the DOM
        document.body.appendChild(iframe)
        // Remove iframe after a short delay to clean up
        // setTimeout(() => document.body.removeChild(iframe), 1000)
        iframe.onload = () => {
          setTimeout(() => document.body.removeChild(iframe), 10000)
        }
        iframe.onerror = () => {
          document.body.removeChild(iframe)
        }
      },
      loadProductPageIframe () {
        const iframe = document.createElement('iframe')
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = '0'
        iframe.style.display = 'none'
        iframe.src = `https://catalog2.hypd.store/affiliate/tracking?merchant=SOULEDSTORE&event=product_page&value=${encodeURIComponent(JSON.stringify(this.productPageData))}`
        // Append iframe to the DOM
        document.body.appendChild(iframe)
        // Remove iframe after a short delay
        iframe.onload = () => {
          setTimeout(() => document.body.removeChild(iframe), 10000)
        }
        iframe.onerror = () => {
          document.body.removeChild(iframe)
        }
      },
      openMembershipPopup () {
        this.isMembershipModalVisible = true
      },
      closeMembershipPopup () {
        this.isMembershipModalVisible = false
      },
      handleExclusiveAdded (value) {
        this.exclusiveMembershipAdded = value
      },
      personalizedWidgetData () {
        if (this.showPersonalizedWidgetListing) {
          this.$store.dispatch('GET_PERSONALIZED_WIDGET_LISTING', { user_id: this.userInfo.user_id })
        }
      },
      modifyName (pr) {
        return pr.replace('.', '_').replace(/\?.*$/, '') || ''
      },
      updateDotPosition (index) {
        let refPrduct = this.$refs.image
        const image = refPrduct[index] || refPrduct[0]
        this.imgDimensions = {
          x: image.naturalWidth,
          y: image.naturalHeight,
          imageWidth: image.offsetWidth
        }
      },
      naviagteToShopTheLookPrd (slug) {
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'SHOP_THE_LOOK_CLICKED',
          payload: {
            Redirect_to: slug,
            UserId: this.userInfo && this.userInfo.user_id ? this.userInfo.user_id : 'NA',
            First_Name: this.userInfo && this.userInfo.firstname ? this.userInfo.firstname : 'NA',
            Last_Name: this.userInfo && this.userInfo.lastname ? this.userInfo.lastname : 'NA',
            email: this.userInfo && this.userInfo.email ? this.userInfo.email : 'NA',
            Type: 'WEB',
            Platform: 'WEB'
          }
        })
        // this.$router.push(`/product/${slug}?gte=${this.product.gender_type || 0}`)
      },
      getDotPosition (index, x, y) {
        x = parseInt(x)
        y = parseInt(y)
        const imageElement = this.$refs.image[index]
        if (imageElement && this.imgDimensions && this.imgDimensions.imageWidth) {
          let left = x
          left = (index * this.imgDimensions.imageWidth) + x
          const top = y
          return {
            left: `${left - 15}px`,
            top: `${top - 15}px`
          }
        }
        return { left: '0px', top: '0px' }
      },
      calculatePercentage (px, axis, i) {
        px = parseInt(px)
        return `${px - 15}px`
      },
      isActiveSlide (index) {
        const currentIndex = this.$refs['my-carousel'] && this.$refs['my-carousel'].currentPage >= 0 ? this.$refs['my-carousel'].currentPage : null
        return currentIndex === index
      },
      prodRedirection (url) {
        if (this.product && this.product.combo_url_key && this.product.combo_type === 1) {
          const comboLink = '/product/' + url + '?gte=' + (this.product.gender_type || 0)
          this.$router.push(comboLink)
        } else if (url && this.product.prod_type !== 8) {
          let prodLink = ''
          if (this.product.gender_type) {
            prodLink = '/product/' + url + '?gte=' + this.product.gender_type
          } else {
            prodLink = '/product/' + url
          }
          this.$store.commit('MOENGAGE_EVENT', {
            eventName: 'TRACK_PDP_COLOR_FILTER_WEB',
            payload: {
              UserId: this.userInfo && this.userInfo.user_id ? this.userInfo.user_id : null,
              Platform: 'WEB',
              product_slug: url
            }
          })
          this.$router.push(prodLink)
        } else {
          return ''
        }
      },
      checkIsNumber (numb) {
        return Number.isNaN((Number(numb))) === true || numb === 0 ? 1 : numb
      },
      voteSoldedOutProduct () {
        this.$store.dispatch('VOTE_SOLD_OUT_PRODUCT', {
          user_id: this.userInfo.user_id,
          product_id: this.product.id
        }).then(() => {
          this.productVoted = true
        })
      },
      isProductOutOfStock (option) {
        const variants = option.variants
        const allOutOfStock = variants.every(variant => variant.stock === 0)
        if (allOutOfStock) {
          this.outofStockFirstProduct = variants[0]
          // this.outofStockFirstProductsize = variants[0].sub_variants
          return true
        }
        return false
      },
      getDataValue: function (number) {
        const units = [' Ratings', 'k Ratings', 'm Ratings', 'b Ratings']
        let unitIndex = 0
        while (number >= 1000 && unitIndex < units.length - 1) {
          number /= 1000
          unitIndex++
        }
        return number + units[unitIndex]
      },
      shuffle: function (a) {
        let j, x, i
        if ((!this.isshuffled)) {
          for (i = a.length - 1; i > 0; i--) {
            j = Math.round(Math.random() * (i + 1))
            x = a[i]
            a[i] = a[j]
            a[j] = x
          }
          this.isshuffled = true
        }
        return a
      },
      getSizeChartImage: function (categoryId) {
        if (this.sizeChartData && this.sizeChartData.length) {
          let sizeChart = this.sizeChartData.find(item => parseInt(item.category_id) === parseInt(categoryId))
          if (sizeChart && sizeChart.size_chart_image) {
            this.isImageModal = true
            this.imageModalData = {
              magnifyImg: sizeChart.size_chart_image
            }
          } else {
            Vue.toasted.show('Size Chart not available',
              {
                theme: 'primary',
                className: 'toasted-customred',
                position: 'top-right',
                duration: 3000
              }
            )
          }
        }
      },
      handleVarientChange: function (event, option, optionIndex) {
        if (event.target.value && event.target.selectedIndex) {
          this.selectedComboVariants = {
            ...this.selectedComboVariants,
            [option.option_id]: option.variants && option.variants[event.target.selectedIndex - 1]
          }
          this.specificCatComboVarient(option, optionIndex, event.target.selectedIndex)
        } else {
          const combosVariants = {
            ...this.selectedComboVariants
          }
          delete combosVariants[option.option_id]
          this.selectedComboVariants = {...combosVariants}
          this.specificComboVarArr[optionIndex] = {}
        }
        Object.keys(this.selectedComboVariants).length === this.product.options.length
        ? this.combosPriceChangeHandler(this.selectedComboVariants)
        : this.comBoPriceResethandler()
      },
      comBoPriceResethandler () {
        this.commonComboVariantsProd = {}
        this.$store.commit('MODIFY_COMBO_PRICE_RESET')
      },
      combosPriceChangeHandler (selectedComboVariants) {
        this.commonComboSizeChartHandler()
        let data = {
          'product_id': this.product && this.product.id
        }
        data.options = this.product && this.product.options && this.product.options.map((opt, index) => {
          return {
            'option_id': opt.option_id,
            'variant': this.selectedComboVariants && this.selectedComboVariants[opt.option_id] && this.selectedComboVariants[opt.option_id].parent_id
          }
        })
        this.$store.dispatch('COMBO_PRICE_CHANGE_UPDATE', data).then((res) => {
          res && Object.keys(res).length
          ? this.$store.commit('MODIFY_COMBO_PRICE', res)
          : ''
        })
      },
      commonComboSizeChartHandler () {
        if (this.product && this.product.prod_type === 6 && this.product.options && this.product.options.length && this.product.is_common_sizeChart_applicable) {
          if (this.product && this.product.options &&
            this.product.options[0] && this.product.options[0].variants &&
            this.product.options[0].variants[0] && this.product.options[0].variants[0].sub_variants &&
            this.product.options[0].variants[0].sub_variants.length) {
            const variant = this.product.options[0].variants[0].sub_variants.map(item => {
              return {
                ...item,
                stock: this.product && this.product.min_size_stock && this.product.min_size_stock[this.getSizeAttribute(item.attributes).value]
              }
            })
            this.commonComboVariantsProd = {
              category: this.product.options[0].variants[0].category,
              category_id: this.product.options[0].variants[0].category_id,
              product_slug: this.product.options[0].variants[0].url_key,
              images_new: this.product.options[0].variants[0].images_new,
              variant
            }
          }
        }
      },
      getComboVarientImages: function (variantImg) {
        const variantImages = variantImg && JSON.parse(variantImg)
        let images = []
        if (variantImages && Object.keys(variantImages).length) {
          if (this.product.gender_type === 1 && variantImages.male && variantImages.male.length) {
            images = [...variantImages['male']]
          } else if (this.product.gender_type === 2 && variantImages.female && variantImages.female.length) {
            images = [...variantImages['female']]
          } else {
            images = [...variantImages['male'], ...variantImages['female'], ...variantImages['unisex']]
          }
        }
        return images
      },
      getMockUpTagPositionClass: function (mockUpTagPosition) {
        switch (mockUpTagPosition) {
          case 'BOTTOM_LEFT':
            return 'mockup-tag-bottom-left'
          case 'BOTTOM_RIGHT':
            return 'mockup-tag-bottom-right'
          case 'TOP_LEFT':
            return 'mockup-tag-top-left'
          case 'TOP_RIGHT':
            return 'mockup-tag-top-right'
          default:
            return ''
        }
      },
      knowPrice: function () {
        this.isNotifyVisible = true
      },
      AddMembership () {
        this.addExclusive(this.EXCLUSIVE_PRODUCTS[2].prod_id)
      },
      updateWishlist: function (item, e) {
        if ((this.exclusiveUser || this.isExclusive) && this.$route.path === '/product/the-souled-store-exclusive') {
          Vue.toasted.show('You are already a member', {
            theme: 'primary',
            position: 'top-right',
            className: 'toasted-customred',
            duration: 5000
          })
          return
        }
        if (!this.userInfo.user_id && this.$route.path === '/product/the-souled-store-exclusive') {
          Vue.toasted.show('Please login first to add this item', {
            theme: 'primary',
            position: 'top-right',
            className: 'toasted-customred',
            duration: 5000
          })
          return
        }
        if (this.wishlistItemsIDs && item && item.id) {
          const wishlistData = {
            category: item.category && item.category.name,
            gender_type: item.genderType && item.genderType.toString(),
            images: item.images,
            parent_prod_id: item.id,
            price: item.price,
            prod_id: item.id,
            prod_type: item.prodType,
            prod_qty: item.prodQty,
            quantity: 1,
            product: item.product,
            size: item.size,
            prArtist: item.product_artist,
            spl_price: item.splPrice || item.spl_price,
            url_key: item.product_slug,
            is_mystery_product: item.is_mystery_product,
            platform: item.platform || (this.webcategory === 'kids' ? 'KIDS' : this.webcategory)
          }
          if (this.wishlistItemsIDs[item.id]) {
            this.$store.dispatch('UPDATE_WISHLIST', {operation: 'delete', type: 'products', data: wishlistData}).then(res => {
              this.disabled = false
              if (e) {
                e.target.parentElement.querySelector('.wishlistIcon') && e.target.parentElement.querySelector('.wishlistIcon').classList.add('wishlistAnimation')
                setTimeout(function () {
                  e.target.parentElement.querySelector('.wishlistIcon') && e.target.parentElement.querySelector('.wishlistIcon').classList.remove('wishlistAnimation')
                }, 1000)
              }
            })
          } else {
            this.$store.dispatch('UPDATE_WISHLIST', {operation: 'add', type: 'products', data: wishlistData}).then(data => {
              if (e) {
                e.target.parentElement.querySelector('.wishlistIcon') && e.target.parentElement.querySelector('.wishlistIcon').classList.add('wishlistAnimation')
                setTimeout(function () {
                  e.target.parentElement.querySelector('.wishlistIcon') && e.target.parentElement.querySelector('.wishlistIcon').classList.remove('wishlistAnimation')
                }, 1000)
              }
              this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'add_to_wishlist',
                payload: {
                  currency: 'INR',
                  value: this.isExclusive ? this.product.exclusive_price : (this.product.spl_price && this.product.spl_price > 0) ? this.product.spl_price : this.product.price,
                  items: [
                    {
                      item_name: wishlistData.product,
                      item_id: wishlistData.prod_id,
                      price: this.getProductPrice,
                      item_category: wishlistData.category,
                      discount: this.product.price - this.getProductPrice,
                      quantity: wishlistData.quantity,
                      currency: 'INR',
                      item_category2: wishlistData.size || this.selectedProductVariant.size || 'NA',
                      item_brand: 'The Souled Store'
                    }
                  ]
                }
              })
              this.disabled = false
            })
          }
        }
      },
      open: function (network) {
        let type = network.path[1].id
        if (type === 'facebook') {
          this.$store.commit('GTAG_EVENT', {eventName: 'facebook', payload: {}})
          this.socialsharingEventHandler('Facebook')
        } else if (type === 'whatsapp') {
          this.$store.commit('GTAG_EVENT', {eventName: 'whatsapp', payload: {}})
          this.socialsharingEventHandler('Whatsapp')
        } else if (type === 'twitter') {
          this.$store.commit('GTAG_EVENT', {eventName: 'twitter', payload: {}})
          this.socialsharingEventHandler('Twitter')
        } else if (type === 'instagram') {
          this.$store.commit('GTAG_EVENT', {eventName: 'instagram', payload: {}})
          this.socialsharingEventHandler('Instagram')
        }
      },
      handlePinCodeChange: function () {
        if (this.pincodeBtnType === 'CHECK') {
          this.showPincodeValidationMsg = true
          this.$validate().then((success) => {
            if (success) {
              this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_CHECK_PIN_DELIVERY', payload: {PINCODE: this.pincode}})
              /** Check for single product with no variant */
              if (this.product.variant.length === 0) {
                this.$store.dispatch('GET_DELIVERY_DETAILS_FROM_PINCODE', { pincode: this.pincode, id: this.product.id })
              } else if (this.product.prod_type === 3 && this.selectedProductVariant && this.selectedProductVariant.id) {
                this.$store.dispatch('GET_DELIVERY_DETAILS_FROM_PINCODE', { pincode: this.pincode, id: this.selectedProductVariant.id })
              } else if (this.product.prod_type === 5 || this.product.prod_type === 6 || this.product.prod_type === 8) {
                this.$store.dispatch('GET_DELIVERY_DETAILS_FROM_PINCODE', { pincode: this.pincode })
              } else {
                this.showSelectSizeValidationMsg = true
                return
              }
              this.pincodeBtnType = 'CHANGE'
            }
          }, error => {
            console.log(error)
          })
        } else {
          this.showPincodeValidationMsg = false
          this.pincodeBtnType = 'CHECK'
          this.deliveryDetails = {}
          this.pincode = ''
        }
      },
      handlePinCodeInputChange: function () {
        const regex = this.isSelectedCountryUK ? /[^a-zA-Z0-9\s]/g : /\D/g
        this.pincode = this.pincode.replace(regex, '').slice(0, this.pincodeLength)
        this.showPincodeValidationMsg = false
        this.pincodeBtnType = 'CHECK'
        this.deliveryDetails = {}
      },
      handlePaste (e) {
        const pastedContent = (e.clipboardData || window.clipboardData).getData('text')
        let processedContent
        const regex = this.isSelectedCountryUK ? /[\w\s]/ : /\d/
        if (regex.test(pastedContent)) {
          const replaceregex = this.isSelectedCountryUK ? /[^a-zA-Z0-9\s]/g : /\D/g
          processedContent = pastedContent.replace(replaceregex, '').slice(0, this.pincodeLength)
          this.pincode = processedContent
        } else {
          this.pincode = ''
        }
        setTimeout(() => {
          this.pincode = processedContent
        }, 10)
      },
      altTagDisplay: function (index, productName, productCategory) {
        if (index === 1) {
          return productName + ' ' + productCategory + ' online'
        } else if (index === 2) {
          return productName + ' ' + productCategory + ' price'
        } else if (index === 3) {
          return 'Buy ' + productName + ' ' + productCategory
        } else {
          return productName + ' ' + productCategory
        }
      },
      removeExcFromCart: function (ExcProdid) {
        this.$store.dispatch('UPDATE_CART', {operation: 'delete', name: 'Exclusive', type: 'products', data: {prod_id: ExcProdid}}).then((res) => {
          this.$store.commit('GTAG_EVENT', {eventName: 'continue_ignore_exc_membership_cart', payload: {exclusive_tracker: this.$route.path}})
          if (this.bannerPlaceHolderForAddToCartScroll) {
            setTimeout(function () {
              let elm = document.getElementById('crossSellProducts')
              elm && elm.scrollIntoView({block: 'center', behavior: 'smooth'})
            }, 1000)
          }
        })
        this.exclusiveAdded = false
        this.togglePopup()
      },
      expandVideo: function () {
      },
      updateCart: function () {
        /** CMS check to on/off audio on PDP */
        if (this.product && this.product.artist_audio && this.enableAddToCartAudio) {
          const baseUrl = process.env.IMG_BASE_URL + 'public/theSoul/uploads/users/artists/'
          this.audio = new Audio(baseUrl + this.product.artist_audio)
          this.audio.play()
        }
        if (this.isCustomizedProd && this.print_name && this.print_number) {
          this.formData.print_name = this.print_name + '|' + this.print_number
        }
        this.$store.dispatch('UPDATE_CART', {operation: 'add', type: 'products', data: this.formData}).then((data) => {
          this.print_name = ''
          this.print_number = ''
          if (data.animate) {
            panimate()
          }
          if (this.bannerPlaceHolderForAddToCartScroll) {
            setTimeout(function () {
              let elm = document.getElementById('crossSellProducts')
              elm.scrollIntoView({block: 'center', behavior: 'smooth'})
            }, 1000)
          }
          if (this.webpushInitiator) {
            webPush.webpushSubscription().then(() => {
              this.$store.commit('WEBPUSH_INITIATOR', false)
            }).catch(err => console.log('webpush not for staging', err))
          }
          this.isSizePopupActive = false
          this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'add_to_cart',
            payload: {
              value: this.formData.quantity * this.getProductPrice,
              items: [
                {
                  item_name: this.formData.product,
                  item_id: this.formData.prod_id,
                  price: parseInt(this.getProductPrice),
                  item_category: this.formData.category,
                  discount: this.product.price - this.getProductPrice,
                  quantity: this.formData.quantity,
                  currency: 'INR',
                  item_brand: 'The Souled Store',
                  item_list_name: this.product.breadcrum_title ? this.product.breadcrum_title : 'NA',
                  item_category2: this.formData.size || 'NA'
                }
              ]
            }
          })
          this.$store.commit('GTAG_EVENT', {eventName: 'UNBXD_ADD_TO_CART', payload: {productID: this.formData.prod_id, route: this.$route.path}})
          this.addToCartData = {
            product_name: this.formData.product,
            product_id: this.formData.parent_prod_id,
            sku: this.formData.prod_id,
            inventory: this.selectedProductVariant && this.selectedProductVariant.stock, // need to ask
            quantity: this.formData.quantity,
            retail_price: parseInt(this.getProductPrice), // need to ask
            base_price: this.product.price,
            user_id: this.userInfo && this.userInfo.user_id ? this.userInfo.user_id : 'NA',
            cart_id: 'NA', // need to ask
            event_time: new Date().toISOString(),
            utm_params: this.formData.utm
          }
          this.trackAddToCart()
        }).catch((err) => {
          this.disabled = false
          console.log(err)
        })
      },
      setAddToCartParams: function () {
        if ((this.product.prod_type === 6 && this.selectedProductVariant && Object.keys(this.selectedProductVariant).length) || this.product.prod_type === 3) {
          if (!(this.selectedProductVariant && Object.keys(this.selectedProductVariant).length)) {
            this.sizeError = true
            this.isSizePopupActive = true
            this.exclusiveMembershipAdded = false
            if (this.isSizeChartVisible && !this.$parent.isDesktop) {
              Vue.toasted.show('Please Select Size', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 3000})
            }
            if (!this.$parent.isDesktop) {
              var d = $('.productinfo').offset().top
              $(window).scrollTop(d)
            }
            return false
          } else {
            this.formData = {
              ...this.formData,
              size: this.selectedProductVariant.size,
              prod_id: this.selectedProductVariant.id
            }
          }
        } else if (this.product.prod_type === 6) {
          let prIdData = String(this.formData.prod_id)
          if (this.product.is_common_sizeChart_applicable) {
            if (prIdData.length <= 0) {
              this.sizeError = true
              return false
            }
          } else {
            this.product.options.map((option, index) => {
              if (option.size_chart_applicable && !(this.specificComboFormData[index] > 0)) {
                this.specificSizeError[index] = true
              } else {
                this.specificSizeError[index] = false
              }
            })
            this.specificSizeError = [...this.specificSizeError]
            let checker = this.specificSizeError.every(v => v === false)
            if (!checker) {
              return false
            }
          }
          this.formData.prod_id = this.product.id
        } else {
          this.formData.prod_id = this.product.id
        }
        this.formData.url_key = this.$route.params.pname
        this.formData.product = this.product.product
        this.formData.categories = this.product.cat
        this.formData.category = this.product.category
        this.formData.spl_price = this.product.spl_price
        this.formData.price = this.product.price
        this.formData.images = this.product.images
        this.formData.prod_type = this.product.prod_type
        this.formData.is_mystery_product = this.product.is_mystery_product
        if (this.product.prod_type === 6) {
          if (['1', '2'].includes(this.gender_type)) {
            this.formData.combo_gender_type = this.gender_type
          } else if (this.gender_type === '0') {
            const selectedCategory = Vue.ls.get('tss_landingCategory')
            this.formData.combo_gender_type = selectedCategory === 'women' ? 2 : 1
          }
        }
        this.formData.gender_type = this.gender_type
        this.formData.parent_prod_id = this.product.id
        this.formData.artist_slug = this.product.artist_slug
        this.formData.prod_qty = this.product.prod_qty

        if (this.utm && Object.keys(this.utm).length) {
          this.formData.utm = this.utm
        }
        if (this.product.prod_type === 6) {
          let options = []
          this.product.options.map((option, index) => {
            const variant = this.selectedComboVariants[option.option_id]
            if (variant) {
              let sizeDet
              if (this.selectedProductVariant && this.product.is_common_sizeChart_applicable && this.commonComboVariantsProd) {
                const subVariant = variant && variant.sub_variants && variant.sub_variants.find(subVar => this.getSizeAttribute(subVar.attributes).value === this.selectedProductVariant.size)
                sizeDet = {
                  size: this.selectedProductVariant.size || '',
                  sku: subVariant.sku
                }
              } else if (variant && variant.sub_variants && variant.sub_variants.length) {
                const selectedId = this.specificComboFormData[index]
                if (!selectedId) {
                  this.specificSizeError[index] = true
                  return
                }
                const subVariant = variant.sub_variants.find(subVar => subVar.id === selectedId)
                if (!subVariant || !subVariant.attributes) {
                  this.specificSizeError[index] = true
                  return
                }
                sizeDet = {
                  size: this.getSizeAttribute(subVariant.attributes).value || '',
                  sku: subVariant.sku
                }
                this.specificSizeError[index] = false
              } else {
                const sizeObj = this.getSizeAttribute(variant.attributes)
                sizeDet = {
                  size: (sizeObj && sizeObj.value) || '',
                  sku: variant.sku
                }
              }
              const images = this.getComboVarientImages(variant.images_new)
              options = [
                ...options,
                {
                  option_id: option.option_id,
                  price: variant.price,
                  images,
                  ...sizeDet
                }
              ]
            }
          })
          this.specificSizeError = [...this.specificSizeError]
          this.formData.options = [...options]
        }
        if (this.product.prod_type === 6 && this.formData.options && this.formData.options.length > 0) {
          this.formData.prod_id = this.product.id
        }
        this.disabled = true
        Vue.ls.set('utm_value', {})
      },
      goToCartClick () {
        this.$store.commit('GTAG_EVENT', {eventName: 'goToCart_Clicked', payload: {}})
        this.$store.commit('GTAG_EVENT', {eventName: 'Go_to_Cart', payload: {}})
      },
      changeColor: function (slug) {
        if (this.currentRouteName !== slug) {
          this.$store.state.product.isLoading = true
          setTimeout(function () {
            this.$router.push({path: slug})
            this.$store.commit('GTAG_EVENT', {eventName: 'pdp.solids.cutom.clicked', payload: {solid_slug: slug}})
            this.$store.state.product.isLoading = false
          }.bind(this), 500)
        }
      },
      showColor: function () {
        this.showMoreColors = !this.showMoreColors
      },
      formatTime: function (date) {
        let d = date ? new Date(date) : new Date()
        return [
          d.getFullYear(),
          ('0' + (d.getMonth() + 1)).slice(-2),
          ('0' + d.getDate()).slice(-2)
        ].join('-') + ' ' +
          [('0' + d.getHours()).slice(-2),
            ('0' + d.getMinutes()).slice(-2),
            ('0' + d.getSeconds()).slice(-2)
          ].join(':')
      },
      formatDate: function (date) {
        let t = new Date(date.replace(/\s/, 'T') + '+05:30')
        return [
          ('0' + t.getDate()).slice(-2),
          ('0' + (t.getMonth() + 1)).slice(-2),
          t.getFullYear()
        ].join(' / ')
      },
      toggleExclusiveBar () {
        if (Vue.ls.get('exclusive') !== 1) {
          let $exclusiveElement = $('.exclusive-topbar')
          $exclusiveElement.slideDown()
          $exclusiveElement.find('.close').on('click', function () {
            $exclusiveElement.slideUp()
            Vue.ls.set('exclusive', 1, 30 * 60 * 1000)
          })
        }
      },
      addToCart: function () {
        if ((this.exclusiveUser || this.isExclusive) && this.$route.path === '/product/the-souled-store-exclusive') {
          Vue.toasted.show('You are already a member', {
            theme: 'primary',
            position: 'top-right',
            className: 'toasted-customred',
            duration: 5000
          })
          return
        }
        if (!this.userInfo.user_id && this.$route.path === '/product/the-souled-store-exclusive') {
          Vue.toasted.show('Please login first to add this item', {
            theme: 'primary',
            position: 'top-right',
            className: 'toasted-customred',
            duration: 5000
          })
          return
        }
        this.sizeError = false
        this.setAddToCartParams()
        let comboSizeChecker = this.specificSizeError.every(v => v === false)
        if (!this.sizeError && ((this.isComboBreaked && this.selectedComboVariants && Object.keys(this.selectedComboVariants).length) || comboSizeChecker)) {
          this.updateCart()
        }
        window.obApi('track', 'AddToCartSouledStore')
        if (this.isNewDesign && this.sizeError) {
          let elmnt = document.getElementById('scroll-till-that')
          elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      },
      addExclusive (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            this.exclusiveAdded = true
            this.isSizeChartVisible = false
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      addExclusiveToCart (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            this.exclusiveAdded = true
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      addExclusiveToCartFromBand (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            this.isNotifyVisible = true
            this.exclusiveAdded = true
            this.$store.commit('MEMBERSHIP_MANUALLY_ADDED', true)
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      productDescription () {
        this.$store.commit('GTAG_EVENT', {eventName: 'product-description', payload: {}})
      },
      productDetails () {
        this.$store.commit('GTAG_EVENT', {eventName: 'product-details', payload: {}})
      },
      artistDetails () {
        this.$store.commit('GTAG_EVENT', {eventName: 'artist-details', payload: {}})
      },
      togglePopup () {
        this.isNotifyVisible = !this.isNotifyVisible
      },
      changevalue: function (selectedVariant, quantity) {
        this.isProductInLocalCartMethod()
        if ((selectedVariant.stock <= 0 && this.product.jit_value !== 'JIT') || this.isOutOfStock) {
          return
        }
        // setting stock value of selected variant
        if (selectedVariant) {
          this.showSelectSizeValidationMsg = false
          this.selectedProductVariant = {
            ...this.selectedProductVariant,
            id: selectedVariant.id,
            size: this.getSizeAttribute(selectedVariant.attributes).value,
            stock: selectedVariant.stock
          }
          const params = {
            product_type: this.product.product_slug,
            product_category: this.product.category
          }
          this.isVarientSelectedSizeChart = true
          this.productWiseSizeChartData && Object.keys(this.productWiseSizeChartData).length > 1 && this.productWiseSizeChartData.product_type === this.product.product_slug ? '' : this.$store.dispatch('GET_PRODUCT_WISE_SIZE_CHART_DATA', {params, showSizeChartFallback: false, isVarientSelectedSizeChart: this.isVarientSelectedSizeChart})
          this.$store.commit('GTAG_EVENT', {eventName: 'quantity', payload: {quantity}})
          this.$store.commit('GTAG_EVENT', {eventName: 'Selected_Product_Size',
            payload: {
              id: selectedVariant.id,
              name: selectedVariant.name,
              size: this.selectedProductVariant && this.selectedProductVariant.size
            }
          })
        } else if (quantity) {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'QUANTITY', payload: {quantity: quantity}})
        }
        this.$store.dispatch('SET_GOTO_CART', false)
        this.addCartbtn = true
        this.disabled = false
        this.sizeError = false
        if (this.bannerPlaceHolderSnapmintSection) {
          this.reloadSnapmintScript()
        }
      },
      magnify (img, ind) {
        // this.pauseVideo()
        let imgInfo = {
          'imageURL': img,
          'index': ind
        }
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_PRODUCT_IMAGE',
          payload: {
            PRODUCT_NAME: this.product.product,
            PARENT_SKU: this.product.id,
            PRODUCT_CATEGORY: this.product.category,
            ARTIST_NAME: this.product.firstname.replace('\u0099', ''),
            PRODUCT_TAG: this.product.product_slug,
            IMAGE_INDEX: ind
          }}
        )
        this.$store.commit('GTAG_EVENT', {eventName: 'similar-product', payload: {index: ind}})
        this.$store.commit('GTAG_EVENT', {eventName: 'product-img',
          payload: {
            imageURL: imgInfo.imageURL,
            index: imgInfo.index
          }}
        )
        if (this.$parent.isDesktop && !this.product.is_blur) {
          this.prviewImage = img
          this.magActiveimg = ind
          this.prview = true
        } else {
          if (!this.product.is_blur) {
            this.magActiveimg = ind
            this.productZoomMobile = true
            document.body.classList.add('noscroll')
          }
        }
      },
      pauseVideo: function () {
        $('.pause_video').trigger('click')
        this.$children[0].videoState = 'paused'
      },
      pthumbSlide (id) {
        this.$refs['my-carousel'].goToPage(id)
        this.tactive = id
      },
      checkout (products) {
        this.$store.dispatch('checkout', products)
      },
      batmanSale: function () {
        this.bannerName = 'batman-active'
        this.liveSaleText = 'Pre Order Starts in'
        this.startDate = '2019-10-17 10:00:00'
        this.endDate = '2019-10-19 12:00:00'
        this.exclusiveDate = '2019-10-19 10:00:00'
      },
      formatAMPM: function (date) {
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours || 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        return strTime
      },
      dateSubscript: function (d) {
        var n = ''
        if (d > 3 && d < 21) return 'th'
        switch (d % 10) {
          case 1:
            n = 'st'
            break
          case 2:
            n = 'nd'
            break
          case 3:
            n = 'rd'
            break
          default:
            n = 'th'
            break
        }
        return n
      },
      getDateToShowForLive: function () {
        this.productLiveDate.date = this.endDate && moment(this.endDate).date()
        this.productLiveDate.dateSup = this.productLiveDate.date && this.dateSubscript(this.productLiveDate.date)
        this.productLiveDate.time = this.endDate && this.formatAMPM(new Date(this.endDate))
        this.productLiveDate.month = this.endDate && new Date(this.endDate).toLocaleString('default', { month: 'short' })
      },
      checkDisabled () {
        let saleDetails = this.saleDet
        let excStartDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
        let excEndDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
        let nonExcStartDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
        let nonExcEndDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
        if ((this.exclusiveUser || this.isExclusive) && saleDetails && saleDetails.early_access) {
          if (moment(this.now) >= moment(excStartDate) && moment(this.now) < moment(excEndDate) && !saleDetails.add_cart_status_web) {
            this.disabled = true
            this.hideWishlist = true
            return
          } else if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            this.disabled = false
            this.hideWishlist = false
            // need to add logic for change cart text & its color
            this.cartSaleStyle.backgroundColor = '#ec3d25'
            this.cartSaleStyle.borderColor = '#fff'
            this.cartSaleStyle.text = ''
            return
          }
          // need to add logic for change cart text & its color
          this.cartSaleStyle.backgroundColor = '#ec3d25'
          this.cartSaleStyle.borderColor = '#fff'
          this.cartSaleStyle.text = ''
          this.disabled = false
          this.hideWishlist = false
        } else {
          if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate) && !(saleDetails && saleDetails.add_cart_status_web)) {
            this.disabled = true
            this.hideWishlist = true
            return
          }
          // need to add logic for change cart text & its color
          this.cartSaleStyle.backgroundColor = '#ec3d25'
          this.cartSaleStyle.borderColor = '#fff'
          this.cartSaleStyle.text = ''
          this.disabled = false
          this.hideWishlist = false
        }
      },
      getSaleTextToShow () {
        let saleDetails = this.saleDet
        let excStartDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
        let excEndDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
        let nonExcStartDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
        let nonExcEndDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
        this.now = this.formatTime()
        this.checkDisabled()
        if ((this.exclusiveUser || this.isExclusive) && saleDetails.early_access) {
          if (moment(this.now) >= moment(excStartDate) && moment(this.now) < moment(excEndDate)) {
            if (saleDetails.early_access) this.liveSaleText = saleDetails.pre_early_access_text
            else this.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.showCountDown) this.showCountDown = true
            // show blur
            this.showBlur = saleDetails.is_blurred
            return saleDetails.pre_early_access_text
          } else if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.liveSaleText !== saleDetails.early_access_text) this.liveSaleText = saleDetails.early_access_text
            // show timer
            if (!this.showCountDown) this.showCountDown = true
            this.showEarlyText = true
            // hide blur
            this.showBlur = false
            return
          }
          // show timer
          if (this.showCountDown) this.showCountDown = false
          // hide blur
          this.showBlur = false
        } else {
          if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.liveSaleText !== saleDetails.pre_live_sale_text) this.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.showCountDown) this.showCountDown = true
            // show blur
            this.showBlur = saleDetails.is_blurred
            return
          }
          // show timer
          if (this.showCountDown) this.showCountDown = false
          // hide blur
          this.showBlur = false
        }
      },
      saleBanner: function (saleDetails) {
        this.now = this.formatTime()
        if (saleDetails && Object.keys(saleDetails).length) {
          this.saleDet = saleDetails
          this.showTimer = saleDetails.timer_status
          if (saleDetails.add_cart_status_web) {
            // need to add logic for disabling the add to cart button
          } else {
            // need to add logic for change cart text & its color
            this.cartSaleStyle.backgroundColor = saleDetails.add_cart_color
            this.cartSaleStyle.borderColor = saleDetails.add_cart_color
            this.cartSaleStyle.text = saleDetails.add_cart_text
          }
          // early access true & user is exclusive or added membership in cart
          if (saleDetails.early_access && (this.exclusiveUser || this.isExclusive)) {
            this.exclusiveDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            this.startDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            this.endDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
          } else {
            this.startDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
            this.endDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
          }
        }
        this.getSaleTextToShow()
        this.getDateToShowForLive()
      },
      checkStatus: function () {
        this.now = this.formatTime()
        if (this.now > this.startDate && this.now > this.endDate) {
          clearInterval(this.timerInterval)
        }
      },
      getFilteredCSellProducts (cSellProducts) {
        return cSellProducts.filter(product => {
          if (product.prodType === 3) {
            return product.prodQty > 0 && product.product_slug !== this.productSlug
          } else {
            return product.stock > 0 && product.product_slug !== this.productSlug
          }
        })
      },
      getVisenzeProduct (product) {
        if (this.enableVincenzeSearch) {
          this.$store.dispatch('VISENZE_SEARCH_PRODUCT', product.id).then(visenzeProduct => {
            this.visenzeSearchItem = (visenzeProduct && visenzeProduct) || []
          })
        }
      },
      getCrossSellProductListing: function () {
        if (this.product && this.product.category && !this.bannerPlaceHolderForProductRecommData) {
          let productCategory = this.product.category_id
          this.$store.dispatch('CROSS_SELL_DATA', this.product.category).then(item => {
            if (item && item.category) {
              this.$store.dispatch('GET_GENDER_WISE_PRODUCT_CATEGORIES').then(genCatObj => {
                this.crossSellName = item.model_title
                let categoryArr = item.category.split(',').map(Number)
                const isGenderWomen = genCatObj && Object.keys(genCatObj).length && categoryArr && categoryArr.length && categoryArr.some(cat => genCatObj.women.includes(cat))
                this.$store.dispatch('FETCH_CROSS_SELL_PRODUCTS', {category: categoryArr, genderType: isGenderWomen ? 2 : 1}).then(cSellProducts => {
                  this.crossSellItems = this.getFilteredCSellProducts(cSellProducts)
                })
              })
            } else {
              this.$store.dispatch('FETCH_CROSS_SELL_PRODUCTS', {category: Number(productCategory), genderType: this.product.gender_type}).then(cSellProducts => {
                this.crossSellItems = this.getFilteredCSellProducts(cSellProducts)
              })
            }
          })
        }
      },
      getRecommendedProducts: function () {
        if (this.bannerPlaceHolderForProductRecommData) {
          const loggedInUserProdSuggKeys = {
            'recommended category': 'user_category_result',
            'recommended artist': 'user_artist_result',
            'recommended themes': 'theme_result',
            'top products': 'top_products',
            'user products': 'user_products'
          }
          const guestUserProdSuggKeys = {
            'recommended category': 'category_result',
            'recommended artist': 'artist_result',
            'recommended themes': 'theme_result',
            'top products': 'top_products',
            'user products': 'user_products'
          }
          let priorityStr = ''
          if (this.authStatus) {
            this.bannerPlaceHolderForProductRecommData && this.bannerPlaceHolderForProductRecommData.map(item => {
              if (loggedInUserProdSuggKeys[item] && !priorityStr.includes(loggedInUserProdSuggKeys[item])) {
                priorityStr = priorityStr ? priorityStr + ',' + loggedInUserProdSuggKeys[item] : priorityStr + loggedInUserProdSuggKeys[item]
              }
            })
            this.bannerPlaceHolderForProductRecommData && this.bannerPlaceHolderForProductRecommData.map(item => {
              if (guestUserProdSuggKeys[item] && guestUserProdSuggKeys[item] !== loggedInUserProdSuggKeys[item]) {
                priorityStr = priorityStr ? priorityStr + ',' + guestUserProdSuggKeys[item] : priorityStr + guestUserProdSuggKeys[item]
              }
            })
          } else {
            this.bannerPlaceHolderForProductRecommData && this.bannerPlaceHolderForProductRecommData.map(item => {
              if (guestUserProdSuggKeys[item] && !priorityStr.includes(guestUserProdSuggKeys[item])) {
                priorityStr = priorityStr ? priorityStr + ',' + guestUserProdSuggKeys[item] : priorityStr + guestUserProdSuggKeys[item]
              }
            })
          }
          const params = {
            category: this.product.category,
            artist: this.product && this.product.firstname && this.product.firstname.replace('\u0099', ''),
            gender_code: this.product.gender_type,
            theme: this.product && this.product.tags && this.product.tags[0] && this.product.tags[0].tag_name,
            product_id: this.product.id,
            duplicate_priority: priorityStr
          }
          this.$store.dispatch('GET_PDP_PRODUCT_RECOMMENDATION', params)
        }
      },
      scrollNow: function () {},
      getExcBand (cat) {
        let prodSlug = this.productSlug
        this.$store.dispatch('GET_EXC_BAND_DATA').then(response => {
          let res = response.filter(item => item.banner_for === 'PDP' && item.banner_with_checkbox === true)
          let resWithCat = res && res.length && res.find(item => item.product_type &&
            item.product_type.toLowerCase() === cat && cat.toLowerCase())
          let resWithProductSlug = res && res.length && res.find(item => item.product_slug === prodSlug)
          if (resWithProductSlug && Object.keys(resWithProductSlug).length) {
            this.showExcBar = true
            this.excBand.showExcStyle.backgroundColor = resWithProductSlug.banner_color
            this.excBand.showExcStyle.color = resWithProductSlug.banner_text_color
            this.excBand.excText = resWithProductSlug.exclusive_tag_text
            return
          } else if (resWithCat && Object.keys(resWithCat).length) {
            this.showExcBar = true
            this.excBand.showExcStyle.backgroundColor = resWithProductSlug.banner_color
            this.excBand.showExcStyle.color = resWithProductSlug.banner_text_color
            this.excBand.excText = resWithProductSlug.exclusive_tag_text
            return
          } else if (res && res.length && !res[0].product_slug && !res[0].product_type) {
            this.showExcBar = true
            this.excBand.showExcStyle.backgroundColor = res[0].banner_color
            this.excBand.showExcStyle.color = res[0].banner_text_color
            this.excBand.excText = res[0].exclusive_tag_text
            return
          }
          this.showExcBar = false
        })
      },
      getSaleProductDetails () {
        this.$store.dispatch('GET_SALE_PRODUCT_DETAILS', this.productSlug).then(response => {
          this.saleBanner(response)
        })
      },
      getDailyDropForPDP () {
        if (!(this.dailyDropForPDP && Object.keys(this.dailyDropForPDP).length)) {
          this.$store.dispatch('GET_DAILY_DROP_DATA')
        }
      },
      handleComboSizeChart (option) {
        if (option && option.variants && option.variants.length) {
          const variant = this.selectedComboVariants[option.option_id] ? this.selectedComboVariants[option.option_id] : option.variants[0]
          this.selectedComboSizeChart = {option, variant}
          this.getSizeChartData(variant.url_key, variant.category_id, variant.category, null)
        }
      },
      getSizeChartData (productType, categoryId, productCategory, optionIndex) {
        this.$store.commit('GTAG_EVENT', {eventName: 'Size_Chart_Viewed', payload: {}})
        this.isSizePopupActive = false
        if (this.bannerPlaceHolderForSizeChart) {
          this.getSizeChartImage(categoryId)
        } else {
          const countryId = this.$store.state.selectedCountryAddress.countryId
          const params = {
            product_type: productType,
            product_category: productCategory,
            country_id: countryId
          }
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'SIZE_CHART_CLICKED',
            payload: {
              PRODUCT_NAME: this.product.product,
              PRODUCT_CATEGORY: this.product.category,
              ARTIST_NAME: this.product && this.product.firstname && this.product.firstname.replace('\u0099', ''),
              PARENT_SKU: this.product.id,
              PRODUCT_TAG: this.product.product_slug,
              SIZE: this.selectedProductVariant && this.selectedProductVariant.size || 'NA'
            }
          })
          this.isVarientSelectedSizeChart = false
          this.$store.dispatch('GET_PRODUCT_WISE_SIZE_CHART_DATA', {params, showSizeChartFallback: this.bannerPlaceHolderForSizeChartFB})
          if (this.product && this.product.prod_type === 6 && !this.product.is_common_sizeChart_applicable) {
            this.commonComboVariantsProd = this.specificComboVarArr && this.specificComboVarArr[optionIndex]
            if (this.specificComboFormData && this.specificComboFormData[optionIndex] && this.specificComboFormData[optionIndex] > 0) {
              let resultSize = this.specificComboVarArr && this.specificComboVarArr[optionIndex] && this.specificComboVarArr[optionIndex].variant && this.specificComboVarArr[optionIndex].variant.find(itm => {
                return itm.id === this.specificComboFormData[optionIndex]
              })
              this.selectedProductVariant = {
                ...this.selectedProductVariant,
                id: resultSize.id,
                size: this.getSizeAttribute(resultSize.attributes).value,
                stock: resultSize.stock
              }
            } else {
              delete this.selectedProductVariant.size
            }
          }
        }
      },
      updateSizeVariant (updatedVariant) {
        let filteredVariant
        if (this.commonComboVariantsProd && Object.keys(this.commonComboVariantsProd).length) {
          filteredVariant = this.commonComboVariantsProd.variant.find(st => st.attributes[0].value === updatedVariant)
          if (this.product && !this.product.is_common_sizeChart_applicable) {
            let optionIndex = this.specificComboVarArr && this.specificComboVarArr.length && this.specificComboVarArr.map(object => object.parent_id).indexOf(this.commonComboVariantsProd.parent_id)
            this.specificComboFormData[optionIndex] = filteredVariant.id
          } else {
            this.formData.prod_id = filteredVariant.id
          }
        } else {
          filteredVariant = this.product.variant.find(st => st.attributes[0].value === updatedVariant)
        }
        this.sizeError = false
        this.changevalue(filteredVariant)
        this.$store.commit('GTAG_EVENT', {eventName: 'sizechartmodal_size', payload: {variant: filteredVariant.id, route: (Vue.ls.get('routeObj')).current}})
      },
      closeProductZoomModal (updatedFlag) {
        this.productZoomMobile = updatedFlag
      },
      sizeChartVisibilityHandler (updatedVisibility) {
        this.isSizeChartVisible = updatedVisibility
      },
      buyNowHandler () {
        this.sizeError = false
        this.setAddToCartParams()
        if (!this.sizeError) {
          this.isSizePopupActive = false
          if (this.isCustomizedProd && this.print_name && this.print_number) {
            this.formData.print_name = this.print_name + '|' + this.print_number
          }
          this.$store.dispatch('UPDATE_BUYNOW_CART', {operation: 'add', type: 'products', data: this.formData}).then((data) => {
            this.checkBuyNowStock()
          })
        }
      },
      hideBuyNowPopup () {
        this.$store.commit('SET_BUYNOW_POPUP_VISIBILITY', false)
        this.disabled = false
      },
      checkBuyNowStock () {
        if (this.authStatus) {
          // After authorisation, on click of checkout button dispatches the UI to js for further process
          this.$store.dispatch('BUYNOW_VALIDATE_CHECKOUT')
        } else {
          this.$router.push(`/login?redirect=${this.$route.path}`)
        }
      },
      addMemToCartInitial () {
        if (this._cart && this._cart.products && this._cart.products.items && this._cart.products.items.length) {
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', name: 'Exclusive', data: {prod_id: this.excPopupData.product_id, quantity: 1, categories: []}}).then((res) => {
            this.isNotifyVisible = true
            this.exclusiveAdded = true
            if (res && res.animate) {
              Vue.ls.set('popupShownOnce', true)
            }
          })
        } else {
          return false
        }
      },
      getSizeAttribute: function (attributes) {
        return attributes && attributes.length && attributes.find(attr => attr.name === 'size')
      },
      checkLabelStatus: function () {
        if (this.mockUpLabel && Object.keys(this.mockUpLabel).length) {
          const now = new Date()
          if (moment(now) >= moment(this.mockUpLabel.label_start_time) && moment(now) < moment(this.mockUpLabel.label_end_time)) {
            this.isLabelLieInTime = true
          } else {
            this.isLabelLieInTime = false
            clearInterval(this.labelTimeInterval)
          }
        }
      },
      crossSellEventHandler (prm) {
        this.$store.dispatch('pushViewContent', {
          itemId: prm.id,
          price: prm.price,
          category: prm.category.name
        })
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_PAGE_SIMILAR_PRODUCT',
          payload: {
            PRODUCT_NAME: prm.product,
            PRODUCT_CATEGORY: prm.category.name,
            PARENT_SKU: prm.id
          }}
        )
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'SIMILAR_PRODUCT',
          payload: {
            Product_Category: String(prm.category.name),
            Product_Name: String(prm.product),
            Product_ID: String(prm.id),
            Product_Price: Number(prm.splPrice || prm.spl_price || prm.exclusivePrice ? this.isExclusive ? prm.exclusivePrice : prm.splPrice || prm.spl_price : prm.price),
            Quantity: 1,
            Product_Artist: String(prm.artist && prm.artist.name),
            ProductImage_URL: String(this.prdImg + (prm.images && prm.images[0])),
            Product_URL: String(this.getProductUrl(true, prm.product_slug, prm.gender_type))
          }}
        )
      },
      crossSellPdpEventHandler (prm) {
        this.$store.dispatch('pushViewContent', {
          itemId: prm.id,
          price: prm.price,
          category: prm.category.name
        })
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'PDP_PAGE_CROSS_SELL_PRODUCT',
          payload: {
            Product_Category: prm.category.name,
            Product_Name: prm.product,
            Product_ID: prm.id,
            Product_Price: prm.splPrice || prm.spl_price || prm.exclusivePrice ? this.isExclusive ? prm.exclusivePrice : prm.splPrice || prm.spl_price : prm.price,
            Quantity: 1,
            Product_Artist: prm.artist && prm.artist.name,
            ProductImage_URL: this.prdImg + (prm.images && prm.images[0]),
            Product_URL: this.getProductUrl(true, prm.product_slug, prm.gender_type)
          }}
        )
      },
      frequentlyBoughtPdpEventHandler (prm) {
        this.$store.dispatch('pushViewContent', {
          itemId: prm.id,
          price: prm.price,
          category: prm.category.name
        })
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'FREQ_BOUGHT_PRODUCT_CLICK_PDP',
          payload: {
            Product_Category: prm.category.name,
            Product_Name: prm.product,
            Product_ID: prm.id,
            Product_Price: prm.splPrice || prm.spl_price || prm.exclusivePrice ? this.isExclusive ? prm.exclusivePrice : prm.splPrice || prm.spl_price : prm.price,
            Quantity: 1,
            Product_Artist: prm.artist && prm.artist.name,
            ProductImage_URL: this.prdImg + (prm.images && prm.images[0]),
            Product_URL: this.getProductUrl(true, prm.product_slug, prm.gender_type)
          }}
        )
      },
      specificCatComboVarient (option, index, varientIndex) {
        varientIndex && varientIndex > 0 ? varientIndex = varientIndex - 1 : varientIndex = 0
        if (option && option.variants && option.variants.length && option.variants[varientIndex] && option.variants[varientIndex].sub_variants && option.variants[varientIndex].sub_variants.length) {
          let variant = option.variants[varientIndex].sub_variants.map(item => {
            return {
              ...item,
              stock: option.variants[varientIndex] && option.variants[varientIndex].min_stock && option.variants[varientIndex].min_stock[this.getSizeAttribute(item.attributes).value]
            }
          })
          this.specificComboVarArr[index] = {
            category: option.variants[varientIndex].category,
            category_id: option.variants[varientIndex].category_id,
            product_slug: option.variants[varientIndex].url_key,
            images_new: option.variants[varientIndex].images_new,
            parent_id: option.variants[varientIndex].parent_id,
            variant
          }
          if (this.specificComboFormData && this.specificComboFormData[index] && this.specificComboFormData[index] > 0) {
            let prevSizeSel = this.getPrevComboSubvarient(option, this.specificComboFormData[index])
            let newVarSelectId = variant && variant.length && variant.find(itm => {
              return this.getSizeAttribute(itm.attributes).value === prevSizeSel ? itm.id : null
            })
            if (newVarSelectId && newVarSelectId.stock) {
              this.specificComboFormData[index] = newVarSelectId.id
            } else {
              this.specificComboFormData[index] = 0
            }
          }
        }
      },
      getPrevComboSubvarient (option, subVarID) {
        let subVar = null
        option && option.variants && option.variants.filter(vari => {
          vari && vari.sub_variants && vari.sub_variants.find(itm => {
            itm.sku === subVarID ? subVar = itm : ''
          })
        })
        return this.getSizeAttribute(subVar.attributes).value
      },
      artistEventHandler (artist, product) {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'ARTIST_NAME_CLICK',
          payload: {
            ARTIST_NAME: artist.replace('\u0099', ''),
            PRODUCT_NAME: product.product,
            PARENT_SKU: product.id,
            PRODUCT_CATEGORY: product.category,
            PRODUCT_TAG: product.product_slug
          }}
        )
      },
      confirmCustomization: function (printName, printNumber) {
        this.print_name = printName
        this.print_number = printNumber
        this.isCustomizedProdModal = false
        this.isCustomizedProd = true
        Vue.toasted.show(this.selectedProductVariant && Object.keys(this.selectedProductVariant).length ? 'Design has been successfully uploaded.' : 'Design has been successfully uploaded. Proceed to select size.',
          {
            theme: 'primary',
            className: 'toasted-customblack',
            containerClass: 'tshirt-customised-toaster',
            position: 'top-right',
            duration: 3000
          }
        )
      },
      handleCustomization: function (flag) {
        this.isCustomizedProdModal = flag
        if (flag && this.product.customized_image) {
          const magnifyImage = this.prdImg + this.product.customized_image
          this.imageModalData = {
            magnifyImg: magnifyImage,
            textColor: this.product && this.product.text_color,
            customizationPrice: this.product.extra_price
          }
        } else {
          this.isCustomizedProd = false
          this.formData.print_name = ''
        }
        this.$store.dispatch('SET_GOTO_CART', false)
        this.disabled = false
      },
      resetFormData: function () {
        this.formData = {
          prod_id: '',
          prod_type: '',
          sub_prod: '',
          quantity: 1,
          category: '',
          spl_price: 0,
          price: 0,
          product: '',
          print_name: '',
          prod_qty: 0
        }
      },
      socialsharingEventHandler: function (medium) {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'SOCIAL_MEDIA_CLICKS',
          payload: {
            PRODUCT_NAME: this.product.product || '',
            PRODUCT_CATEGORY: this.product.category || '',
            ARTIST_NAME: this.product.firstname.replace('\u0099', '') || '',
            PARENT_SKU: this.product.id || '',
            PRODUCT_TAG: this.product.product_slug || '',
            MEDIUM: medium
          }
        })
      },
      productReturnMsgArr: function (returnMsg) {
        if (returnMsg) {
          const msg = returnMsg.toLowerCase()
          const msgIndex = msg && msg.indexOf('know more')
          const clickHereLen = 'know more'.length
          return [returnMsg.slice(0, msgIndex), returnMsg.slice(msgIndex, msgIndex + clickHereLen), returnMsg.slice(msgIndex + clickHereLen)]
        }
      },
      async shareNavigatorHandler () {
        if (navigator.share) {
          // const response = await fetch(`${this.prdImg}${this.product.images && this.product.images[0]}`)
          // const blob = await response.blob()
          // const filesArray = [
          //   new File(
          //     [blob],
          //     'product.jpg',
          //     {
          //       type: blob.type,
          //       lastModified: new Date().getTime()
          //     }
          // )
          // ]
          const shareData = {
            // files: filesArray,
            text: `${this.shareProductText && this.shareProductText.tag_text || ''} ${this.product && this.product.product}\n`,
            url: document.URL
          }
          navigator.share(shareData)
        } else {
          Vue.toasted.show('Sharing is not available on this Browser',
            {
              theme: 'primary',
              className: 'toasted-customred',
              position: 'top-right',
              duration: 3000
            }
          )
        }
      },
      jsonProductInjection () {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.text = JSON.stringify(this.productSchema)
        document.head.appendChild(script)
      },
      jsonListItemInjection () {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.text = JSON.stringify(this.listItemSchema)
        document.head.appendChild(script)
      },
      getProductUrl,
      crossSellPdpHandler () {
        this.$store.dispatch('GET_CROSS_SELL_PDP_LISTING', {
          category: this.product.category_id,
          product_id: this.product.id,
          category_name: this.product.category,
          is_ab_visible: true
        })
      },
      goToPreviousPage () {
        window.history.back()
      },
      newDesignScroll () {
        if (!this.hasScrolled) {
          this.hasScrolledClass = true
          this.hasScrolled = true
        }
        if (this.hasScrolled) {
          const bannerHeight = this.$refs.bannerSection.offsetHeight
          let scrollThreshold = bannerHeight - 475
          this.isPriceSectionFixed = window.scrollY > scrollThreshold
        }
      },
      snapmintInit () {
        var snapmint = document.createElement('script')
        snapmint.type = 'text/javascript'
        snapmint.async = true
        snapmint.src = ((document.location.protocol === 'https:') ? 'https://' : 'http://') + `assets.snapmint.com/assets/merchant/${this.merchantId}/snapmint_emi.js`
        var s = document.getElementsByTagName('script')[1]
        s.parentNode.insertBefore(snapmint, s)
      },
      reloadSnapmintScript () {
        const existingScript = document.querySelector('script[src*="snapmint_emi.js"]')
        if (existingScript) {
          existingScript.parentNode.removeChild(existingScript)
        }
        this.snapmintInit()
      },
      getNewPdp () {
        const getUdatednewDesignMweb = Vue.ls.get('updatednewDesignMweb')
        if (getUdatednewDesignMweb === 'NEW_DESIGN') {
          this.newDesignMweb = true
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      // this.previousPath = from.fullPath
      Vue.ls.set('routeObj',
        {current: getLastPage(to.name), previous: getLastPage(from.name) || ''})
      next(vm => {
        if (to.query && to.query.utm_source) {
          vm.utm = {
            utm_source: to.query.utm_source,
            utm_medium: to.query.utm_medium,
            utm_campaign: to.query.utm_campaign,
            utm_content: to.query.utm_content,
            utm_url: to.fullPath,
            utm_term: to.query.utm_term
          }
        } else if (from.query && from.query.utm_source) {
          vm.utm = {
            utm_source: from.query.utm_source,
            utm_medium: from.query.utm_medium,
            utm_campaign: from.query.utm_campaign,
            utm_content: from.query.utm_content,
            utm_url: from.fullPath,
            utm_term: from.query.utm_term
          }
        } else if (Vue.ls.get('utm_value')) {
          vm.utm = Vue.ls.get('utm_value')
        }
      })
    },
    created: function () {
      if (this.user && this.user.tss_points !== undefined) {
        this.processDataTSSPoints = [
          `${this.user.tss_points} tss points expiring by`,
          'You can use 10% of your total points for every order'
        ]
      }
      this.detectDeviceType()
      this.$store.commit('SET_GLOBAL_SETTING_KEYS', ['footer_homebrand_text', 'SHOW_WEB_MENU_WOMEN', 'SHOW_WEB_MENU_MEN', 'pincode_length_validation', 'SHOW_WEB_MENU_KIDS'])
      if (this.webcategory) {
        this.productSlug = this.$route.params.pname
        this.gender_type = this.$route.query && this.$route.query.gte ? this.$route.query.gte : this.webcategory === 'women' ? 2 : 1
        this.$store.dispatch('FETCH_PRODUCT', {slug: this.productSlug, _this: this, gender_type: this.gender_type})
        .then(res => {
          this.getSaleProductDetails()
          this.getDailyDropForPDP()
          // this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_item_list',
          //   payload: {
          //     currency: 'INR',
          //     value: res.price,
          //     items: [
          //       {
          //         item_id: res.id,
          //         item_name: res.firstname ? res.firstname : '',
          //         currency: 'INR',
          //         item_category: res.cat ? res.cat[0] : '',
          //         item_category2: res.cat ? res.cat[1] : '',
          //         item_category3: res.cat ? res.cat[2] : '',
          //         item_category4: res.cat ? res.cat[3] : '',
          //         item_category5: res.cat ? res.cat[4] : '',
          //         item_list_name: res.breadcrum_name,
          //         item_variant: res.variant,
          //         price: res.price
          //       }
          //     ]
          //   }
          // })
          if (this.bannerPlaceHolderSnapmintSection) {
            this.snapmintInit()
          }
          this.noProductAllowed = true
        })
      }
      this.$store.dispatch('SET_GOTO_CART', false)
      // get sizeChart Details
      if ((this.bannerPlaceHolderForSizeChartFB || this.bannerPlaceHolderForSizeChart) && !(this.sizeChartData && this.sizeChartData.length)) {
        this.$store.dispatch('GET_SIZE_CHART_DATA')
      }
      // get exc popup data
      const popUpDone = Vue.ls.get('popupShownOnce')
      if (this.showInitialExcPopupOnPdp && !popUpDone && !this.isExclusive && !this.exclusiveUser && !this.isTssCorpProduct) {
        this.$store.dispatch('GET_EXC_MEM_DATA_FROM_CMS')
      }
      if (this.authStatus) {
        this.pincode = this.userInfo && this.userInfo.postcode && this.userInfo.postcode.length ? this.userInfo.postcode : ''
      }
      this.faqs && this.faqs.length ? '' : this.$store.dispatch('GET_FAQS')
      this.getNewPdp()
    },
    mounted () {
      this.waitForUserData()
      this.updateTSSPointsData()
      if (this.showWhatmoreBaner) {
        this.loadWhatmoreScript()
      }
      this.canonicalUrl0 = this.canonicalUrl = window.location.href
      if (parseInt(this.$route.query.gte)) {
        this.canonicalUrl0 = this.canonicalUrl = window.location.href.split('?')[0]
      }
      this.isVarientSelectedSizeChart = false
      const currentDate = new Date()
      this.pdpLandingDate = currentDate
      this.$store.commit('SET_LISTING_LANDING_DATE', currentDate)
      this.currentTickerText = this.tickerText[this.currentTickerIndex]
      if (this.product && this.product.tickers && this.product.tickers.length && this.product.tickers.length > 0) {
        this.tickerText = this.product.tickers
      }
    },
    updated () {
      if (this.product && this.product.options) {
        this.isOutOfStock = this.product.options.some(variant => variant.stock === 0)
      }
      if (this.commonComboVariantsProd && this.commonComboVariantsProd.variant && this.commonComboVariantsProd.variant.length) {
        this.isOutOfStock = this.commonComboVariantsProd.variant.every(variant => variant.stock === 0)
      }
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.newDesignScroll)
      if (this.audio) {
        this.audio.pause()
        this.audio.currentTime = 0 // Reset the audio to the beginning
      }
      clearInterval(this.tickerInterval)
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }
      if (this.labelTimeInterval) {
        clearInterval(this.labelTimeInterval)
      }
      document.body.classList.remove('noscroll')
      if (this.tatvicProductImpression && this.tatvicProductImpression.data.length) {
        // this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_item_list',
        //   payload: {
        //     ecommerce: {
        //       'items': [
        //         ...this.tatvicProductImpression.data
        //       ]
        //     }
        //   }
        // })
        this.$store.commit('EC_PLP_PROD_VIEW_RESET')
      }
      if (this.moengageImpressionData && Object.keys(this.moengageImpressionData).length) {
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'view_product_list',
          payload: {
            ...this.moengageImpressionData
          }
        })
        this.$store.commit('MOENGAGE_PLP_PROD_VIEW_RESET')
      }
      this.$store.commit('SET_LISTING_LANDING_DATE', '')
      const pdpLeavingDate = new Date()
      const timeSpent = Math.floor((pdpLeavingDate.getTime() - this.pdpLandingDate.getTime()) / 1000)
      if (this.product) {
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'product_page_view',
          payload: {
            Product_Category: String(this.product.category),
            Product_Name: String(this.product.product),
            Product_ID: String(this.product.id),
            Product_Price: Number(this.getProductPrice),
            Color: String(this.getCurrentColor),
            Quantity: 1,
            Product_Artist: String(this.product.firstname),
            ProductImage_URL: String(this.prdImg + (this.product.images && this.product.images[0])),
            Product_URL: String(this.getProductUrl(true, this.product.product_slug, this.product.gender_type)),
            Time_Spent: String(timeSpent)
          }
        })
      }
      this.$store.commit('SET_NOT_FOUND_FALSE')
    },
    beforeRouteUpdate (to, from, next) {
      this.commonComboVariantsProd = {}
      if (this.tickerInterval) {
        clearInterval(this.tickerInterval)
      }
      next()
    },
    watch: {
      user: {
        handler (newVal) {
          this.updateTSSPointsData()
          if (newVal && newVal.user_id && this.product && this.product.id) {
            this.$store.dispatch('GET_TICKER_POINTS', {
              prodID: this.product.id,
              isExclusive: this.isExclusive ? 1 : 0,
              ...(this.user && this.user.user_id ? { userid: this.user.user_id } : {})
            }).then(item => {
              this.tickerPoint = item.text
              this.tssPoint = item
            })
          }
        },
        immediate: true,
        deep: true
      },
      bannerPlaceHolderForTSSpointsdescription: {
        handler () {
          this.updateTSSPointsData()
        },
        immediate: true,
        deep: true
      },
      showWhatmoreBaner (val, old) {
        if (val) {
          this.loadWhatmoreScript()
        }
      },
      userInfo () {
        this.personalizedWidgetData()
      },
      outofStockFirstProduct (val) {
        if (val) {
          this.outofStockFirstProductsize = val.sub_variants
        }
      },
      bannerPlaceHolderData: function (value) {
        if (value && Object.keys(value).length) {
          if ((this.bannerPlaceHolderForSizeChartFB || this.bannerPlaceHolderForSizeChart) && !(this.sizeChartData && this.sizeChartData.length)) {
            this.$store.dispatch('GET_SIZE_CHART_DATA')
          }
        }
      },
      showInitialExcPopupOnPdp (value) {
        const popUpDone = Vue.ls.get('popupShownOnce')
        if (value && !popUpDone && !this.isExclusive && !this.exclusiveUser && !this.isTssCorpProduct) {
          this.$store.dispatch('GET_EXC_MEM_DATA_FROM_CMS')
        }
      },
      goToCart () {
        const popUpDone = Vue.ls.get('popupShownOnce')
        if (this.excPopupData && Object.keys(this.excPopupData) && this.goToCart && this.showInitialExcPopupOnPdp && !popUpDone && !this.isExclusive && !this.exclusiveUser && !this.isTssCorpProduct) {
          if (this.EXCLUSIVE_PRODUCTS[2] && parseInt(this.excPopupData.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[2].prod_id)) {
            this.addMemToCartInitial()
          } else if (this.EXCLUSIVE_PRODUCTS[3] && parseInt(this.excPopupData.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[3].prod_id)) {
            this.addMemToCartInitial()
          }
        }
      },
      excPopupData () {
        const popUpDone = Vue.ls.get('popupShownOnce')
        if (this.excPopupData && Object.keys(this.excPopupData) && this.goToCart && this.showInitialExcPopupOnPdp && !popUpDone && !this.isExclusive && !this.exclusiveUser && !this.isTssCorpProduct) {
          if (this.EXCLUSIVE_PRODUCTS[2] && parseInt(this.excPopupData.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[2].prod_id)) {
            this.addMemToCartInitial()
          } else if (this.EXCLUSIVE_PRODUCTS[3] && parseInt(this.excPopupData.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[3].prod_id)) {
            this.addMemToCartInitial()
          }
        }
      },
      '$route' (to, from) {
        if (this.moengageImpressionData && Object.keys(this.moengageImpressionData).length) {
          this.$store.commit('MOENGAGE_EVENT', {
            eventName: 'view_product_list',
            payload: {
              ...this.moengageImpressionData
            }
          })
          this.$store.commit('MOENGAGE_PLP_PROD_VIEW_RESET')
        }
        if (this.product) {
          const pdpLeavingDate = new Date()
          const timeSpent = Math.floor((pdpLeavingDate.getTime() - this.pdpLandingDate.getTime()) / 1000)
          this.$store.commit('MOENGAGE_EVENT', {
            eventName: 'product_page_view',
            payload: {
              Product_Category: String(this.product.category),
              Product_Name: String(this.product.product),
              Product_ID: String(this.product.id),
              Product_Price: Number(this.getProductPrice),
              Color: String(this.getCurrentColor),
              Quantity: 1,
              Product_Artist: String(this.product.firstname),
              ProductImage_URL: String(this.prdImg + (this.product.images && this.product.images[0])),
              Product_URL: String(this.getProductUrl(true, this.product.product_slug, this.product.gender_type)),
              Time_Spent: String(timeSpent)
            }
          })
        }
        const currentDate = new Date()
        this.pdpLandingDate = currentDate
        this.$store.commit('SET_LISTING_LANDING_DATE', currentDate)
        if (this.webcategory) {
          this.productSlug = to.params.pname
          this.gender_type = this.$route.query && this.$route.query.gte ? this.$route.query.gte : this.webcategory === 'women' ? 2 : 1
          this.$store.dispatch('FETCH_PRODUCT', {slug: this.productSlug, _this: this, gender_type: this.gender_type})
          .then(res => {
            this.getSaleProductDetails()
            this.noProductAllowed = true
          })
        }
        // removed go to cart to add to button
        this.$store.dispatch('SET_GOTO_CART', false)
        this.disabled = false
        // unselect the size
        this.selectedProductVariant = ''
        // reset form data
        this.resetFormData()
        // remove sale details timer
        this.saleDet = {}
        this.endDate = ''
      },
      isBuyNowPopup (isOpen) {
        const routeObj = Vue.ls.get('routeObj')
        if (isOpen) {
          document.body.classList.add('noscroll')
          // this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_click',
          //   payload: {route: routeObj.current,
          //     product_added_to_cart: this.formData.prod_id,
          //     quantity: this.formData.quantity
          //   }
          // })
          // this.$store.commit('GTAG_EVENT', {eventName: 'ct_buyNow_click',
          //   payload: {
          //     product_added_to_cart: this.formData.prod_id,
          //     quantity: this.formData.quantity
          //   }
          // })
          this.$store.commit('GTAG_EVENT', {eventName: 'fb_buyNow_click',
            payload: {
              route: routeObj.current,
              prod_id: this.formData.prod_id,
              product_added_to_cart: this.formData.product,
              prod_name: this.formData.prod_name,
              quantity: this.formData.quantity
            }
          })
        } else {
          this.disabled = false
          this.formData = {
            ...this.formData,
            print_name: '',
            print_number: ''
          }
        }
      },
      isSizePopupActive () {
        !this.$parent.isDesktop && this.isSizePopupActive && this.bannerPlaceHolderForAddToCartSizePopup ? document.body.classList.add('noscroll') : document.body.classList.remove('noscroll')
      },
      'active_pricelists' () {
        let plists = JSON.stringify(this.active_pricelists.pricelists)
        this.gender_type = this.$route.query && this.$route.query.gte ? this.$route.query.gte : this.webcategory === 'women' ? 2 : 1
        if (this.plistCheck !== plists && this.webcategory) {
          this.product.prod_type !== 6 ? this.$store.dispatch('FETCH_PRODUCT', {slug: this.productSlug, _this: this, gender_type: this.gender_type}) : ''
        }
        this.plistCheck = plists
      },
      product (value) {
        if (this.product && this.product.prod_type === 6 && this.product.options && this.product.options.length) {
          this.selectedComboVariants = {}
          for (let i = 0; i < this.product.options.length; i++) {
            if (!this.product.is_common_sizeChart_applicable) {
              this.specificComboFormData[i] = 0
              this.specificSizeError[i] = false
            }
            if (this.product.options[i] && this.product.options[i].variants && this.product.options[i].variants.length === 1 &&
              this.product.options[i].variants[0] && this.product.options[i].variants[0].stock && this.product.options[i].variants[0].stock > 0) {
              this.handleVarientChange({
                target: {
                  value: this.product.options[i].variants[0].sku,
                  selectedIndex: 1
                }
              }, this.product.options[i], i)
            }
          }
        }
        if (value.id) {
          this.$store.dispatch('GET_TICKER_POINTS', {
            prodID: value.id,
            isExclusive: this.isExclusive ? 1 : 0,
            ...(this.user && this.user.user_id ? { userid: this.user.user_id } : {})
          }).then(item => {
            this.tickerPoint = item.text
            this.tssPoint = item
          })
        }
        if (this.product.product_slug) {
          Vue.ls.set('pdp_checkDrop', false)
          this.isVarientSelectedSizeChart = false
          this.$store.commit('SET_PRODUCT_WISE_SIZE_CHART_DATA', {})
        }
        if (value && Object.keys(value).length) {
          this.$store.dispatch('RECENTLY_VIEWED', this.product)
          this.getCrossSellProductListing()
          this.getVisenzeProduct(this.product)
          this.getRecommendedProducts()
          this.getExcBand(value.category)
          const payload = {
            parent_event_name: 'general_event',
            event_name: 'pdp',
            url: `https://www.thesouledstore.com${this.$router.currentRoute && this.$router.currentRoute.path}`,
            categories: this.product && this.product.cat,
            artists: [this.product && this.product.firstname && this.product.firstname.replace('\u0099', '')],
            themes: [],
            product_ids: [value.id],
            product_names: [value.product]
          }
          // this.$store.dispatch('TRACK_STORE_EVENT', payload)
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'PDP_USER_HISTORY', payload: payload})
          this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_item',
            payload: {
              items: [
                {
                  item_name: value.product,
                  item_id: value.id,
                  price: this.getProductPrice,
                  item_category: value.category,
                  index: 1,
                  discount: value.price - this.getProductPrice,
                  currency: 'INR',
                  item_brand: 'The Souled Store',
                  item_list_name: value.cat_breadcrum_name ? value.cat_breadcrum_name : 'NA'
                }
              ]
            }
          })
          this.$store.commit('GTM_EVENT', {
            eventName: 'view_item',
            payload: {
              currency: 'INR',
              value: this.getProductPrice || 'NA',
              items: [{
                item_id: value.id || 'NA',
                item_name: value.product || 'NA',
                price: this.getProductPrice || 'NA',
                item_category: value.category || 'NA',
                item_brand: 'The Souled Store',
                affiliation: 'The Souled Store',
                discount: value.price - this.getProductPrice || 'NA'
              }]
            }}
            )
          this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
            payload: {
              sendTo: process.env.GOOGLE_ADWORDS_ID,
              ecomm_prodid: value.id,
              ecomm_pagetype: 'product',
              ecomm_totalvalue: this.getProductPrice,
              product_id: String(this.product.id),
              page_title: 'pdp_page'
            }}
          )
          if (this.product) {
            this.productPageData = {
              product_name: String(this.product.product),
              product_id: String(this.product.id),
              product_retail_price: Number(this.getProductPrice),
              product_base_price: this.product.price,
              product_variants_with_inventory: this.product.variant,
              product_category: String(this.product.category),
              product_img: String(this.prdImg + (this.product.images && this.product.images[0])),
              event_time: new Date().toISOString(),
              user_id: this.userInfo && this.userInfo.user_id ? this.userInfo.user_id : 'NA',
              device_type: this.deviceType,
              referrer_info: document.referrer || ''
            }
          }
          this.loadProductPageIframe()
        }
        if (!this.$parent.isDesktop) {
          this.$store.commit('SET_FOOTER_COLLAPSE_CONTROL', {
            expanded: true,
            expandedClass: 'show', // '' or show
            bottomStyle: 'margin-bottom: 59px;'
          })
        }
        if (this.product && Object.keys(this.product).length && this.product.product_slug) {
          this.crossSellPdpHandler()
          if (this.authStatus) {
            this.personalizedWidgetData()
          }
          if (this.showFrequentlyBoughtListing) {
            const payload = {
              gte: this.$route.query && this.$route.query.gte ? this.$route.query.gte : 0,
              gender: Vue.ls.get('tss_landingCategory') === 'men' ? 1 : Vue.ls.get('tss_landingCategory') === 'women' ? 2 : 3
            }
            this.$store.dispatch('GET_FREQUENT_BOUGHT_PDP_LISTING', payload)
          }
          if (this.isNewDesign && !this.$parent.isDesktop) {
            window.addEventListener('scroll', this.newDesignScroll)
          }
          this.jsonProductInjection()
          this.jsonListItemInjection()
        }
        this.isProdMounted = true
        if (this.bannerPlaceHolderSnapmintSection) {
          this.reloadSnapmintScript()
        }
        if (value && value.tickers && value.tickers.length && value.tickers.length > 0) {
          this.tickerText = value.tickers
        }
      },
      tickerText: {
        immediate: true,
        handler (newVal) {
          if (this.tickerInterval) {
            clearInterval(this.tickerInterval)
          }
          if (newVal && newVal.length > 0) {
            if (!this.isTickerActive && newVal.length > 0) {
              this.$store.commit('MOENGAGE_EVENT', {
                eventName: 'PDP_TICKER_ACTIVE',
                payload: {
                  Product_Name: this.product && this.product.product || 'NA',
                  Product_Sku: this.product && this.product.id || 'NA',
                  Screen_Name: 'PDP Page',
                  Product_Category: this.product && this.product.category || 'NA',
                  Artist: this.product && this.product.firstname || 'NA',
                  Slug: this.product && this.product.product_slug || 'NA',
                  Platform: 'WEB'
                }
              })
              this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_TICKER_ACTIVE',
                payload: {
                  Product_Name: this.product && this.product.product || 'NA',
                  Product_Sku: this.product && this.product.id || 'NA',
                  Screen_Name: 'PDP Page',
                  Product_Category: this.product && this.product.category || 'NA',
                  Artist: this.product && this.product.firstname || 'NA',
                  Slug: this.product && this.product.product_slug || 'NA',
                  Platform: 'WEB'
                }}
              )
              this.isTickerActive = true
            }
            this.startTicker()
          }
        }
      },
      pincodeDeliveryDetails () {
        this.deliveryDetails = {...this.pincodeDeliveryDetails}
      },
      webcategory (value) {
        if (value) {
          this.productSlug = this.$route.params.pname
          this.gender_type = this.$route.query && this.$route.query.gte ? this.$route.query.gte : value === 'women' ? 2 : 1
          this.$store.dispatch('FETCH_PRODUCT', {slug: this.productSlug, _this: this, gender_type: this.gender_type})
          .then(res => {
            this.getSaleProductDetails()
            this.getDailyDropForPDP()
            this.noProductAllowed = true
          })
        }
      },
      productWiseSizeChartData (sizeChartData) {
        if (!this.isVarientSelectedSizeChart && sizeChartData && Object.keys(sizeChartData).length) {
          if (sizeChartData.showSizeChartFallback) {
            this.getSizeChartImage(this.product.category_id)
          } else {
            this.isSizeChartVisible = true
            this.$store.commit('GTAG_EVENT', {eventName: 'sizechartmodal_click', payload: {route: Vue.ls.get('routeObj')}})
          }
        }
      },
      mockUpLabel: function (labelObj) {
        if (labelObj && Object.keys(labelObj).length) {
          const now = new Date()
          if (now && labelObj.label_start_time && labelObj.label_end_time && moment(now) > moment(labelObj.label_start_time) && moment(now) < moment(labelObj.label_end_time)) {
            this.isLabelLieInTime = true
            this.labelTimeInterval = setInterval(() => {
              this.checkLabelStatus()
            }, 1000)
          }
        }
      },
      isCustomizedProdModal: function (value) {
        if (!value) {
          this.imageModalData = ''
        }
      },
      isImageModal: function (flag) {
        if (!flag) {
          this.imageModalData = ''
        }
      },
      authStatus: function () {
        this.getRecommendedProducts()
      },
      bannerPlaceHolderForProductRecommData: function () {
        this.getRecommendedProducts()
      },
      showBlur () {
        this.showBlur ? Vue.ls.set('pdp_checkDrop', true) : Vue.ls.set('pdp_checkDrop', false)
      },
      hasAddressChanged: {
        handler: function () {
          this.$store.dispatch('FETCH_PRODUCT', {slug: this.productSlug, _this: this, gender_type: this.gender_type})
          this.showPincodeValidationMsg = false
          this.pincodeBtnType = 'CHECK'
          this.deliveryDetails = {}
          this.pincode = ''
        },
        deep: true
      }
    },
    validators: {
      pincode: function (value) {
        const isSelectedCountryUK = this.isSelectedCountryUK
        if (isSelectedCountryUK) {
          const minLength = 5
          const maxLength = this.pincodeLength
          return Validator.value(value)
          .required()
          .minLength(minLength)
          .maxLength(maxLength)
        }
        return Validator.value(value).required().length(parseInt(isSelectedCountryUK ? 8 : this.pincodeLength))
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        product: 'FETCH_PRODUCT',
        productState: 'productState',
        colorOptions: 'colors',
        goToCart: 'goToCart',
        relatedProducts: 'relatedProducts',
        alsoAvailable: 'alsoAvailable',
        isLoading: 'isLoading',
        calculations: 'calculations',
        site_config: 'site_config',
        exclusiveProduct: 'exclusiveProduct',
        isExclusive: 'isExclusive',
        active_pricelists: 'active_pricelists',
        notFound: 'notFound',
        exclusiveUser: 'exclusiveUser',
        crossSellProducts: 'crossSellProducts',
        bannerPlaceHolderData: 'bannerPlcaeHolderData',
        _cart: '_cart',
        pdpMockUpTag: 'pdpMockUpTag',
        sizeChartData: 'sizeChartData',
        dailyDropForPDP: 'dailyDropForPDP',
        pincodeDeliveryDetails: 'pincodeDeliveryDetails',
        productWiseSizeChartData: 'productWiseSizeChartData',
        authStatus: 'authStatus',
        isBuyNowPopup: 'isBuyNowPopup',
        wishlistItemsIDs: 'wishlistItemsIDs',
        webcategory: 'webcategory',
        excPopupData: 'excPopupData',
        showInitialExcPopupOnPdp: 'showInitialExcPopupOnPdp',
        memberSavingsTxt: 'memberSavingsTxt',
        disableWishlist: 'disableWishlist',
        userInfo: 'user',
        webpushInitiator: 'webpushInitiator',
        tatvicProductImpression: 'tatvicProductImpression',
        faqs: 'faqs',
        banners: 'banners',
        pdpProductRecommData: 'pdpProductRecommData',
        moengageImpressionData: 'moengageImpressionData',
        crossSellPdpListing: 'crossSellPdpListing',
        frequentlyBoughtPdpListing: 'frequentlyBoughtPdpListing',
        personalizedWidgetListing: 'personalizedWidgetListing',
        nonMemberSavingsTxt: 'nonMemberSavingsTxt',
        currencySymbol: 'currencySymbol',
        isSelectedCountryIndia: 'isSelectedCountryIndia',
        currencyRsToUSD: 'currencyRsToUSD',
        globalBannerPlaceholder: 'globalBannerPlaceholder',
        hasAddressChanged: 'hasAddressChanged',
        currentTickerText: 'currentTickerText'
      }),
      roundedPriceAfterRedemption () {
        const price = this.tssPoint.price_after_tss_point_redemption

        if (price === null || price === undefined || isNaN(price)) return ''

        const decimalPart = price % 1

        if (decimalPart <= 0.5) {
          return Math.floor(price)
        } else {
          return Math.ceil(price)
        }
      },
      maxDiscountAmount () {
        const basePrice = this.product.spl_price
          ? parseFloat(this.product.spl_price)
          : (this.isExclusive && this.showMemberExclusivePrice
              ? parseFloat(this.product.exclusive_price)
              : parseFloat(this.product.price))

        return Math.floor(basePrice * 0.10)
      },
      isProductInLocalCart () {
        const localCartMeta = Vue.ls.get('localcart') && Vue.ls.get('localcart').products && Vue.ls.get('localcart').products.items || []
        const currentProdId = this.product && this.product.id
        return localCartMeta.some(item => {
          // Log each item's product ID for debugging
          // Check if the product ID matches and is not a mystery product
          return item.parent_prod_id === currentProdId && item.is_mystery_product === 1
        })
      },
      showMrpOnPdp () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_MRP_PDP_WEB')
      },
      showWhatmoreBaner () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_WHAT_MORE_PDP_WEB')
      },
      shareProductText () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PDP_PRODUCT_SHARING_WEB')
      },
      showBoldReturnText () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_BOLD_RETURN_TEXT')
      },
      showShopTheLook () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_SHOP_THE_LOOK_WEB')
      },
      showAdditionalNote () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_ADDITIONAL_NOTE')
      },
      enableActionBoton () {
        if (this.product && this.product.is_exclusive_product) {
          if (this.product.is_exclusive_product && this.isExclusive) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      showMrpOnPdpGlobal () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GLOBAL_MRP_TEXT_PDP_WEB')
      },
      showPriceInclusiveOnPdp () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_INC_OF_TEX_TEXT_PDP_WEB')
      },
      isBlurProductClickablePdp () {
        let data = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PDP_BLUR_PRODUCT_CLICKABLE_WEB')
        if (this.product.is_blur) {
          if (data) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      isComboProductAddedInCart: function () {
        const check = this._cart && this._cart.products && this._cart.products.items && this._cart.products.items.length && this._cart.products.items.find(item => item.prod_id === this.product.id)
        return check
      },
      isTssCorporateProductAddedInCart: function () {
        const check = this._cart && this._cart.products && this._cart.products.items && this._cart.products.items.length && this._cart.products.items.find(item => item.parent_prod_id === this.product.id)
        return check
      },
      isTssCorpProduct: function () {
        return this.product && this.isCorporateProduct(this.product.artist_slug)
      },
      enableVincenzeSearch: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Search Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_VINCENZE_SEARCH'.toLowerCase())
      },
      comboProductPriceDetails: function () {
        let priceDetails = {}
        if (this.product && this.product.options) {
          let priceArr = []
          this.product.options.length && this.product.options.map(op => {
            const variant = this.selectedComboVariants[op.option_id]
            if (variant) {
              priceArr = [...priceArr, this.selectedComboVariants[op.option_id].price]
            }
          })
          const price = priceArr.reduce((a, b) => a + b, 0)
          if (this.product.spl_price_percent) {
            const discount = Math.round((this.product.spl_price_percent / 100) * Math.round(price))
            priceDetails = {...priceDetails, spl_price: Math.round(price) - Math.round(discount)}
          }
          priceDetails = {...priceDetails, price}
          return priceDetails
        }
        return {}
      },
      isComboBreaked () {
        if (this.product && this.product.is_common_sizeChart_applicable) {
          return this.selectedComboVariants && this.commonComboVariantsProd.variant && this.product && this.product.options && Object.keys(this.selectedComboVariants).length !== this.product.options.length
        } else {
          return this.specificComboFormData.filter(val => val > 0).length === 1
        }
      },
      isSpecificSizeError () {
        this.product.options.map((option, index) => {
          if (option.size_chart_applicable && !(this.specificComboFormData[index] > 0)) {
            this.specificSizeError[index] = true
          } else {
            this.specificSizeError[index] = false
          }
        })
        const hasFalseValue = this.specificSizeError.some(value => value === false)
        return hasFalseValue
      },
      isWishlist: function () {
        return this.product && !this.disableWishlist && !this.isTssCorpProduct && this.product.prod_type !== 6 && !this.hideWishlist
      },
      isSouledOut: function () {
        let product = this.product
        return ((product.prod_type === 1 || product.prod_type === 6) && product.stock <= 0 && product.jit_value !== 'JIT') || (product.prod_type === 3 && product.prod_qty <= 0 && product.jit_value !== 'JIT')
      },
      isSizeOutOfStock: function () {
        let stock
        if (this.commonComboVariantsProd && Object.keys(this.commonComboVariantsProd).length) {
          let productVariant = this.commonComboVariantsProd && this.commonComboVariantsProd.variant && this.commonComboVariantsProd.variant.length
          for (let i = 0; i < productVariant; i++) {
            if (this.commonComboVariantsProd.variant[i].stock === 0) {
              stock = true
              break
            }
          }
        } else {
          let productVariant = this.product && this.product.variant && this.product.variant.length
          for (let i = 0; i < productVariant; i++) {
            if (this.product.variant[i].stock === 0) {
              stock = true
              break
            }
          }
        }
        return stock
      },
      formattedArtist: function () {
        if (!this.product.firstname) {
          return
        }
        return this.product.firstname.replace('\u0099', '&trade;')
      },
      EXCLUSIVE_PRODUCTS: function () {
        return this.site_config.exclusive_products
      },
      currentRouteName () {
        return this.$route.path
      },
      isExclusiveSavingsInPercent: function () {
        const excSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'SHOW_EXC_SAVING_PERCENT_PDP'.toLowerCase())
        return excSavingsInPercent
      },
      isNonExclusiveSavingsInPercent: function () {
        const excSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'NO_EXC_SAVING_PERCENT_PDP_WEB'.toLowerCase())
        return excSavingsInPercent
      },
      estimatedDeliveryText: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length) {
          return this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_ESTIMATE_DIFF_PDP_WEB'.toLowerCase())
        }
      },
      isColorWebEnable: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length) {
          return this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_PDP_COLORS_WEB'.toLowerCase())
        }
      },
      isColorImgWebEnable: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length) {
          return this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_PDP_COLORS_IMG_WEB'.toLowerCase())
        }
      },
      colorWebHeader: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length) {
          return this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PDP_COLORS_HEADER_TEXT'.toLowerCase())
        }
      },
      bannerPlaceHolderPDP: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length) {
          let PDPBannerObj = this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true &&
            !bannerData.product_type)
          if (PDPBannerObj && Object.keys(PDPBannerObj).length) {
            let PDPBannerPhObj = {}
            PDPBannerPhObj.styles = {
              backgroundColor: PDPBannerObj.banner_color,
              color: PDPBannerObj.banner_text_color
            }
            PDPBannerPhObj.text = PDPBannerObj.tag_text
            PDPBannerPhObj.status = PDPBannerObj.status
            return PDPBannerPhObj
          }
        }
      },
      bannerPlaceHolderPDPWithCat: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.product &&
          Object.keys(this.product).length) {
          let PDPBannerObj = this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true &&
            this.product.category === bannerData.product_type && !bannerData.tag_text.includes('return'))
          if (PDPBannerObj && Object.keys(PDPBannerObj).length) {
            let PDPBannerPhObj = {}
            PDPBannerPhObj.styles = {
              backgroundColor: PDPBannerObj.banner_color,
              color: PDPBannerObj.banner_text_color,
              marginTop: '2px'
            }
            PDPBannerPhObj.text = PDPBannerObj.tag_text
            PDPBannerPhObj.status = PDPBannerObj.status
            return PDPBannerPhObj
          }
        }
      },
      bannerPlaceHolderPDPExclusivePrice: function () {
        if (this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.product &&
          Object.keys(this.product).length) {
          let PDPBannerObj = this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_EXCLUSIVE_BAND_PDP'.toLowerCase())
          if (PDPBannerObj && Object.keys(PDPBannerObj).length) {
            let PDPBannerPhObj = {}
            PDPBannerPhObj.styles = {
              backgroundColor: PDPBannerObj.banner_color,
              color: PDPBannerObj.banner_text_color,
              marginTop: '2px'
            }
            PDPBannerPhObj.text = PDPBannerObj.tag_text
            PDPBannerPhObj.status = PDPBannerObj.status
            return PDPBannerPhObj
          }
        }
      },
      bannerPlaceHolderTSSPoints: function () {
        const tssPointsBannerObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_PDP_TSS_POINTS_WEB'.toLowerCase())
        if (tssPointsBannerObj) {
          const tagText = tssPointsBannerObj.tag_text
          const basePrice = !Object.keys(this.selectedComboVariants).length ? (this.isExclusive ? this.product.exclusive_price : this.product.spl_price) || this.product.price : (this.isExclusive ? this.product.exclusive_price : this.comboProductPriceDetails.spl_price) || this.comboProductPriceDetails.price
          const tssPoints = parseInt(((basePrice || 0) + ((this.product && this.product.extra_price) || 0)) * this.formData.quantity * (((this.calculations && this.calculations.app_cashback_percent) || 0) / 100))
          // const tssPoints = ((this.product.spl_price || this.product.price || 0) + (this.product.extra_price || 0)) * this.formData.quantity * (this.calculations.app_cashback_percent / 100)
          const textArr = tagText.split('{$point}')
          return {
            ...tssPointsBannerObj,
            prev_text: textArr[0],
            after_text: textArr[textArr.length - 1],
            tss_points: `${tssPoints} TSS Points`
          }
        }
        return null
      },
      checkDailyDropObjectExist: function () {
        if (this.dailyDropForPDP && Object.keys(this.dailyDropForPDP).length && this.productSlug) {
          return this.dailyDropForPDP.hasOwnProperty(this.productSlug)
        }
      },
      getDeliveryDate: function () {
        if (this.pincodeDeliveryDetails.data) {
          return this.$parent.formatDateToGivenFormat(moment(new Date()).add(this.pincodeDeliveryDetails.data.max_estimated_days_new, 'days'), 'DD MMM')
        }
      },
      getVoteCardDetails () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_VOTE_SOLD_OUT_PDP_WEB')
      },
      getVotedProductText () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_PRODUCT_VOTED_TEXT_WEB')
      },
      showNonMemberExclusivePrice () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GRAD_NON_MEMBER_PRICE_PDP_WEB')
      },
      enableAddToCartAudio () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'ADD_TO_CART_AUDIO_WEB')
      },
      showMemberExclusivePrice () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GRADIENT_MEMBER_PRICE_PDP_WEB')
      },
      showTickerPoints () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_TICKER_POINT_PDP_WEB')
      },
      getDeliveryDateRange: function () {
        if (this.pincodeDeliveryDetails.data) {
          const minDate = this.$parent.formatDateToGivenFormat((moment(this.pincodeDeliveryDetails.data.min_estimated_date, 'DD/MM/YYYY')), 'DD MMM')
          const maxDate = this.$parent.formatDateToGivenFormat((moment(this.pincodeDeliveryDetails.data.max_estimated_date, 'DD/MM/YYYY')), 'DD MMM')
          return `${minDate} - ${maxDate}`
        }
      },
      bannerPlaceHolderForTSSPointsHeaderMessage: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'TSS_POPUP_PRICE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForTSSpointsmodel: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'TSS_PDP_INFO_MODEL_WEB'.toLowerCase())
      },
      bannerPlaceHolderForTSSpointsdescription: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'TSS_POINTS_DESCRIPTION_WEB'.toLowerCase())
      },
      bannerPlaceHolderForSizeChart: function () {
        const isSizeChartObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'DISABLE_SIZE_CHART_WEB'.toLowerCase())
        if (isSizeChartObj) {
          return true
        }
        return null
      },
      bannerPlaceHolderForBuyNow: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'DISABLE_BUYNOW_MOBILE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForMemberShipBanner: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PDP_MEMBERSHIP_POP_UP_BANNER'.toLowerCase())
      },
      bannerPlaceHolderForAddToCartScroll: function () {
        const isAddToCartScrollObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'CART_SCROLL_SIMILAR_PRODUCTS'.toLowerCase())
        if (isAddToCartScrollObj) {
          return true
        }
        return null
      },
      productReturnMsg: function () {
        if (this.product.is_printable) {
          const returnMsgObj = this.banners && this.banners.find(banner => banner.banner_title && banner.banner_title.toLowerCase() && banner.banner_title.toLowerCase() === 'customised product return policy')
          if (returnMsgObj) {
            return {
              tagText: returnMsgObj.banner_description,
              style: {
                backgroundColor: returnMsgObj.banner_color,
                color: returnMsgObj.banner_text_color
              }
            }
          }
          return null
        }
        let returnMsgObj = this.product && this.bannerPlaceHolderData && this.bannerPlaceHolderData.length &&
          this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for === 'PDP' && bannerData.status === true && bannerData.product_type === this.product.category &&
          bannerData.tag_text.includes('return'))
        if (returnMsgObj) {
          return {
            tagText: returnMsgObj.tag_text,
            style: {
              backgroundColor: returnMsgObj.banner_color,
              color: returnMsgObj.banner_text_color
            }
          }
        }
        return null
      },
      bannerPlaceHolderForSizeChartFB: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_SIZE_CHART_FALLBACK'.toLowerCase())
      },
      mockUpTag: function () {
        if (this.pdpMockUpTag && Object.keys(this.pdpMockUpTag).length && this.pdpMockUpTag.product_slug === this.productSlug && this.pdpMockUpTag.is_active_pdp && this.pdpMockUpTag.tag_name) {
          return this.pdpMockUpTag
        }
      },
      mockUpLabel: function () {
        if (this.pdpMockUpTag && Object.keys(this.pdpMockUpTag).length && this.pdpMockUpTag.product_slug === this.productSlug && this.pdpMockUpTag.label && this.pdpMockUpTag.label.label_is_active_pdp) {
          return this.pdpMockUpTag
        }
      },
      bannerPlaceHolderForAddToCartSizePopup: function () {
        const isAddToCartSizePopupObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'ADD_TO_CART_SIZE_POPUP'.toLowerCase())
        if (isAddToCartSizePopupObj) {
          return true
        }
        return null
      },
      getProductPrice () {
        if (!Object.keys(this.selectedComboVariants).length) {
          if (Math.round(this.product.spl_price) || (this.isExclusive && Math.round(this.product.exclusive_price))) {
            return this.isExclusive ? this.product.exclusive_price && parseInt(this.product.exclusive_price) : this.product.spl_price && parseInt(this.product.spl_price)
          } else if (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(this.productSlug)) {
            return this.$parent.currencyFormate(parseInt(this.product.price))
          } else {
            return parseInt(this.product.price)
          }
        }
      },
      bannerPlaceHolderForGstInclusiveLabel: function () {
        const isGstInclusiveLabelObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GST_INCLUSIVE_LABEL_PDP'.toLowerCase())
        if (isGstInclusiveLabelObj) {
          return isGstInclusiveLabelObj
        }
        return null
      },
      customisedProdFaqs: function () {
        return this.faqs && this.faqs.find(faq => faq.name && faq.name.toLowerCase() === 'customised product web')
      },
      bannerPlaceHolderForDeliveryDetails: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_PDP_DELIVERY_DETAILS_WEB'.toLowerCase())
      },
      bannerPlaceHolderForProductRecommData: function () {
        const data = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'FILTER_PDP_RECOMM_DATA_WEB'.toLowerCase())
        return data && data.tag_text && data.tag_text && data.tag_text.split(',')
      },
      productRecommData: function () {
        if (this.pdpProductRecommData && Object.keys(this.pdpProductRecommData).length) {
          const data = this.pdpProductRecommData
          const recommendation = {
            'recommended category': data.user_category_result && data.user_category_result.response &&
              data.user_category_result.response.products && data.user_category_result.response.products.length
              ? data.user_category_result.response.products
              : (data.category_result && data.category_result.response && data.category_result.response.products) || [],
            'user products': data.user_products && data.user_products.response && data.user_products.response.products,
            'recommended artist': data.user_artist_result && data.user_artist_result.response &&
              data.user_artist_result.response.products && data.user_artist_result.response.products.length
              ? data.user_artist_result.response.products
              : (data.artist_result && data.artist_result.response && data.artist_result.response.products) || [],
            'recommended themes': data.theme_result && data.theme_result.response && data.theme_result.response.products || [],
            'top products': data.top_products && data.top_products.response && data.top_products.response.products
          }
          return recommendation
        }
      },
      productRecommTitleMapping: function () {
        return {
          'recommended category': 'Similar Styles',
          'user products': 'Recommended for you',
          'recommended artist': `More from ${this.product.firstname && this.product.firstname.replace('\u0099', '')}`,
          'recommended themes': 'Recommended Themes',
          'top products': 'Top Selling'
        }
      },
      bannerPlaceHolderForCustomerReviews: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'CUSTOMER_REVIEWS'.toLowerCase())
      },
      bannerPlaceHolderForArtistNameDisplay: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'ARTIST_NAME_DISPLAY_PDP'.toLowerCase())
      },
      bannerPDPRating: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_RATING_ON_PDP_WEB'.toLowerCase())
      },
      reorderedColorGroupDetails () {
        if (!this.product || !Array.isArray(this.product.color_group_details)) {
          return []
        }

        const slug = this.product && this.product.product_slug
        const details = this.product && this.product.color_group_details || [] // clone array to avoid mutating original

        const index = details.findIndex(item => item.url_key === slug)

        if (index > -1) {
          const [matchedItem] = details.splice(index, 1) // remove the matched item
          details.unshift(matchedItem) // add it to the front
        }

        return details
      },
      getVarientSizeDetails () {
        if (this.productWiseSizeChartData && Object.keys(this.productWiseSizeChartData).length) {
          let sizeDetailDataExcept = ['size_category', 'sort_order', 'isAvailableToShow', 'isStockAvailable', 'size_category_obj_id']
          let htmlArray = []
          let selectVarientSizeData = this.productWiseSizeChartData.size && this.productWiseSizeChartData.size.length && this.productWiseSizeChartData.size.filter(itm => {
            return itm.size_category === this.selectedProductVariant.size
          })
          selectVarientSizeData && selectVarientSizeData[0] && Object.keys(selectVarientSizeData[0]).length && Object.keys(selectVarientSizeData[0]).map((item, index) => {
            let isVisible = this.productWiseSizeChartData && this.productWiseSizeChartData.headers_meta && this.productWiseSizeChartData.headers_meta[item] && this.productWiseSizeChartData.headers_meta[item].is_visible
            if ((isVisible === 1) && (!sizeDetailDataExcept.includes(item))) {
              let sortOrder = this.productWiseSizeChartData && this.productWiseSizeChartData.headers_meta && this.productWiseSizeChartData.headers_meta[item] && this.productWiseSizeChartData.headers_meta[item].sort_order
              let sizeTitle = this.productWiseSizeChartData && this.productWiseSizeChartData.headers && this.productWiseSizeChartData.headers[item]
              let sizeDataInches = selectVarientSizeData && selectVarientSizeData[0] && selectVarientSizeData[0][item].split('::')[1]
              let particularSizeHTML = `${sizeTitle}: <span style="color: black;">${sizeDataInches}</span>`
              htmlArray.push([sortOrder, particularSizeHTML])
            }
          })
          htmlArray.sort((firstSubArray, SecondSubArray) => firstSubArray[0] - SecondSubArray[0])
          let renderedHtml = ''
          htmlArray.map((subArray, index) => {
            renderedHtml += subArray[1]
            if ((htmlArray.length - 1) !== index) {
              renderedHtml += ' | '
            }
            return renderedHtml
          })
          return renderedHtml
        }
      },
      productSchema () {
        return {
          '@context': 'https://schema.org',
          '@type': 'Product',
          'name': `${this.product && this.product.product} ${this.product.category} By ${this.product.firstname && this.product.firstname.replace('\u0099', '')}`,
          'image': `https://prod-img.thesouledstore.com/public/theSoul/uploads/catalog/product/${this.product && this.product.images && this.product.images.length && this.product.images[0]}`,
          'sku': `${this.product.id}`,
          'mpn': `${this.product.id}`,
          'description': `${this.product && this.product.meta_desc && this.product.meta_desc.replace(/"/g, '')}`,
          'offers': {
            '@type': 'Offer',
            'priceCurrency': 'INR',
            'availability': `${this.isSouledOut ? 'OutOfStock' : 'InStock'}`,
            'price': `${
              this.isExclusive && this.product.exclusive_price ? parseInt(this.product.exclusive_price).toString()
              : this.product.spl_price ? parseInt(this.product.spl_price).toString() : parseInt(this.product.price).toString()}`,
            'url': `${this.currentUrl}`
          },
          'brand': {
            '@type': 'Thing',
            'name': `${this.product && this.product.firstname && this.product.firstname.replace('\u0099', '')}`
          },
          'age_group': 'adult'
        }
      },
      listItemSchema () {
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Home',
              'item': 'https://www.thesouledstore.com'
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': `${this.product && this.product.cat_breadcrum_name}`,
              'item': `https://www.thesouledstore.com/explore/${this.product.category_slug}`
            },
            {
              '@type': 'ListItem',
              'position': 3,
              'name': `${this.product && this.product.firstname}`,
              'item': `https://www.thesouledstore.com/artists/${this.product.artist_slug}`
            },
            {
              '@type': 'ListItem',
              'position': 4,
              'name': `${this.product && this.product.product}`,
              'item': `${this.currentUrl}`
            }
          ]
        }
      },
      getWishistPrmData () {
        return {
          'id': this.product.id,
          'product': this.product.product,
          'category': {
            'name': this.product.category
          },
          'price': this.product.price,
          'genderType': this.product.gender_type && this.product.gender_type.toString(),
          'prodQty': this.product.prod_qty,
          'prodType': this.product.prod_type,
          'splPrice': this.product.spl_price,
          'exclusivePrice': this.product.exclusive_price,
          'images': this.product.images,
          'product_slug': this.product.product_slug,
          'product_artist': this.product.firstname.replace('\u0099', ''),
          'is_mystery_product': this.product.is_mystery_product,
          'platform': this.product.platform
        }
      },
      customisableProductText () {
        let productCategoryText = 'T-Shirt'
        if (this.product.category === 'Jerseys') {
          productCategoryText = 'Jersey'
        }
        return productCategoryText
      },
      crossSellingPdpDetails: function () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_CROSS_SELLING_PDP_WEB'.toLowerCase())
      },
      showFrequentlyBoughtListing () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_FREQUENTLY_BOUGHT_PDP_WEB')
      },
      bannerPlaceHolderForPdpTicker () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PDP_TICKER_WEB')
      },
      showSimilarProductDetails () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_SIMILAR_PRODUCT_PDP_WEB')
      },
      showPersonalizedWidgetListing () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_PERSONALIZED_WIDGET_WEB')
      },
      bannerPlaceHolderForVideoAutoplay: function () {
        const isVideoAutoPlay = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'ENABLE_VIDEO_AUTOPLAY_PDP_WEB'.toLowerCase())
        if (isVideoAutoPlay) {
          return true
        }
        return false
      },
      isNewDesign: function () {
        const newDesign = this.product.active_new_design_platform
        return newDesign === 'WEB' || newDesign === 'BOTH'
      },
      bannerPlaceHolderForCODMessage () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PDP_COD_MESSAGE_WEB')
      },
      bannerPlaceHolderReviewSection () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_RATINGS_REVIEWS_PDP_WEB')
      },
      getMerchantPrice () {
        if (this.product.price) {
          if ((Math.round(this.product.spl_price) || (this.isExclusive && Math.round(this.product.exclusive_price)))) {
            return this.isExclusive
              ? this.product.exclusive_price && parseInt(this.product.exclusive_price)
              : this.product.spl_price && parseInt(this.product.spl_price)
          } else if (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(this.productSlug)) {
            return this.$parent.currencyFormate(parseInt(this.product.price))
          } else {
            return parseInt(this.product.price)
          }
        }
      },
      bannerPlaceHolderSnapmintSection () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Payment Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_SNAPMINT_WEB')
      },
      pincodeLength () {
        const pincode = this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData =>
        bannerData.is_active === true && bannerData.config_key === 'pincode_length_validation')
        if (this.isSelectedCountryUK) {
          return 8
        } else if (pincode) {
          return pincode.value
        } else {
          return 6
        }
      },
      enableTotalStockLeft () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'TOTAL_STOCK_LEFT_PDP_WEB')
      },
      getCurrentColor () {
        for (let item of this.colorOptions) {
          if (item.product_slug === this.currentRouteName) {
            return item.product_color
          }
        }
        return ''
      },
      isSelectedCountryUK () {
        return this.countryId ? parseInt(this.countryId) === 222 : false
      },
      isSelectedCountryUAE () {
        return this.countryId ? parseInt(this.countryId) === 221 : false
      }
    }
  }

  function panimate () {
    $(document).ready(function () {
      var topcart = $('.headercart')
      var pimg = $('#pview')
      var pclone = pimg.clone()
        .offset({top: pimg.offset().top, left: pimg.offset().left})
        .css({'opacity': '0.5', 'position': 'absolute', 'height': '478px', 'width': '451px', 'z-index': '100'})
        .appendTo($('body'))
        .animate({
          'top': topcart.offset().top + 10,
          'left': topcart.offset().left + 10,
          'width': 75,
          'height': 75
        }, 'easeInOutExpo')
      pclone.animate({'width': 0, 'height': 0}, function () {
        $(this).detach()
      })
    })
  }
</script>

<style lang="css" scoped>
.qtyOption:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

  .ticker-point{
    background: linear-gradient(to right,#CEE4E4,#D4E7E8,#A2D2D3,#73BEBFCC,#97CDCE,#D4E7E8);
    padding: 8px 32px;
  }
  .pdp-ticker {
    position: absolute;
    margin-top: -37px;
    width: 100%;
    max-width: 410px;
    min-height: 37px;
    background: rgba(0, 0, 0, 0.60);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .pdp-ticker span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    height: 15px;
    flex-shrink: 0;
    color: #FFF;
    text-align: center;
    font-family: "Open Sans";
    font-size: 13.152px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
  .blink {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
  .info-icon{
    width: 15px;
    height: 15px;
    top: 0.5px;
    left: 0.5px;
    gap: 0px;
  }
  .membership-nonmember-info{
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: -0.02em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }
  .ticker-text{
    font-size: 14px;
    color: #121212;
    font-weight: 500;
    font-family: 'Lato', sans-serif;
  }
  .widget-heading {
    border-bottom: 1px #eee solid;
    padding-bottom: 30px;
    margin: 30px 0;
    font-size: 15px;
  }
  .starRating {
    width: 13px;
    height: 13px;
  }
  .pdpr {
    font-weight: 400;
    color: #535766;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
  .pipPDP {
    margin-top: -2px;
    color: #d4d5d9;
    width: 1px;
  }
  .ratingPDP {
    column-gap: 8px;
    margin-bottom: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    height: 29px;
    padding: 8px;
    border: 1px solid #eaeaec;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 700;
    color: #282c3f;
}
.size-data-details {
  background: #ededed;
  -webkit-text-stroke: 0.35px #ededed;
  -webkit-font-smoothing: antialiased;
  width: fit-content;
  padding: 1px 3px;
  margin: 10px 0px 0px 0px;
}
.cusrev{
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.16px;
  text-align: left;
}
.cusrev img{
  margin-right: 6px;
}
.scrolldiv{
  overflow: hidden;
  overflow-y: scroll;
  max-height: 522px;
}
.scrolldiv::-webkit-scrollbar-track {
    background-color: darkgrey;
}
.scrolldiv::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.cus-review{
  border-bottom: solid 1px #ebebeb;
  padding: 7px 0 9px 16px;
  object-fit: contain;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #535353;
}
.name-age{
  object-fit: contain;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  padding-top: 6px;
  text-align: left;
  color: #7b7b7b;
}
.pg-block{
  background-color: #f9f9f9;
  font-size: 14px !important;
}
.pg-col{
  padding-bottom: 5px;
}
.prg-text{
  width: 38%;
}
.progress{
  border: solid 1px #dbdbdb;
    line-height: 1rem;
    text-align: center;
    background-color: #dbdbdb;
    border-radius: .25rem;
    width:60%;
}
.bar{
  background-color: #348f92 !important;
  padding: 5px 0 0 0.5px;
}
.prg-text{
  margin-top: -18px;
}
.prod-cat{
  font-size: 15px;
}
.group-header {
  margin-bottom: 0;
}
@media screen and (max-width: 991px) {
  .cus-review{
    font-size: 14px;
  }
  .pg-block{
    padding: 0 0 20px 20px!important;
  }
  .progress{
     width:41%;
  }
  .prg-text{
    width: 55%;
  }
  .pg-block{
  font-size: 13px !important;
}
}
  .margin-unset{
    margin: unset;
  }
  .combo-products-wrapper{
    margin-top: -13px;
    margin-bottom: -10px
  }
  .bundleProName{
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: #58595b;
  }
  .bundle-dropdown{
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
    height: 34px;
  }
  .bundle-dropdown:focus{
    outline: none;
  }
  .combo-prod-name-wrapper{
    gap: 1rem;
  }
  .combo-prod-name-wrapper p{
    margin-bottom: unset;
  }
  .combo-product-wrapper{
    padding-top: .8rem;
    padding-bottom: .8rem;
  }
  .combo-border-b{
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  .customization-wrapper .customized-input{
    gap: 5px;
  }
  .customization-wrapper .customise-heading {
    color: #148c8d;
    font-weight: bold;
  }
  .customization-wrapper .customise-price {
    font-size: 13px
  }
  .customization-wrapper .customcheckbox [type="checkbox"]:not(:checked) + label:before,
  .customization-wrapper .customcheckbox [type="checkbox"]:checked + label:before {
    border: 2px solid#9d9d9d;
    width: 17px;
    height: 17px;
  }
  .customization-wrapper .customcheckbox [type="checkbox"]:not(:checked) + label:after,
  .customization-wrapper .customcheckbox [type="checkbox"]:checked + label:after {
    border: 1px solid #5eaba8;
    width: 17px;
    height: 17px;
    font-size: 0.9em;
    padding: 2px 2px;
  }
  .wishlistIcon{
    text-align: center;
    top: 0;
    right: 19px;
  }
  .wishlistIcon.wishlist{
    box-shadow: none;
    background-color: transparent;
  }
  .wishlistIcon:before{
    font: normal normal normal 20px/40px FontAwesome;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    content: "\f08a";
    color: #000;
  }
  .wishlistIcon:hover,
  .wishlistIcon.wishlistActive{
    background-color: #ffffff;
    background: transparent;
    box-shadow: none;
  }
  .wishlistIcon:hover:before,
  .wishlistIcon.wishlistActive:before{
    content: '\f004';
    color: #117a7a;
  }
  .wishlistIcon.wishlist:before{
    content: "\f08a";
    color: #000;
  }
  .wishlistAnimation {
    animation: mymove 1s;
  }
  @keyframes mymove {
    100% {transform: rotateY(360deg);}
  }
  video::-webkit-media-controls { /* Works only on Chrome-based browsers */
    display: none;
  }
  .fullWidth {
    width:100%;
  }

  .displayflex {
    display: flex;
  }

  .checksize {
    text-decoration: underline;
    font-size: 12px;
  }

  .previewBtn {
    margin: 10px 0px;
    width: 65%;
    border-radius: 10px;
  }
  .label-container {
    color: black;
  }
  .label-container span {
    font-size: 11px;
    background-color: #f2de2b;
    padding: 1px 7px 1px 10px;
    border-radius: 3px;
  }
  .label-container i {
    font-size: 12px;
    color: black;
    border-width: 2px;
    border-style: solid;
    padding: 1px 4px;
    border-radius: 50%;
    background-color: #ffffff;
    left: -10px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance:textfield;
  }

  .tax-info {
    color: #a7a9ac;
    font-size: 14px;
  }

  .btn-price {
    text-transform: none;
    line-height: 20px;
  }


  .pimg {
    padding-right: 0;
  }

  video {
    outline: none;
  }

  @keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

  .green-dot {
    position: absolute;
    width: 30px;
    height: 30px;
    background: radial-gradient(circle, darkgreen 30%, lightgreen 70%);
    border-radius: 50%;
    pointer-events: auto;
    animation: blink 2s infinite;
    cursor: pointer;
  }

  .green-dot:hover {
    width: 35px;
    height: 35px;
  }
  .green-dot-link {
    position: absolute;
    width: 30px;
    height: 30px;
  }

  .tax-info {
    color: #a7a9ac;
    font-size: 14px;
  }
  .title-size {
    font-size: 1.8em;
  }
  .bx1 {
    float: none;
    border-bottom: 0;
  }
  .exclusive-link {
    color: #58595b;
    text-decoration: underline;
    white-space: nowrap;
    cursor: pointer;
  }
  .fa-info-circle {
    color: #58595b;
  }
  .error.sizevalid {
    display: inline-block;
  }

  .fltdiv.lh28 {
    line-height: 28px;
  }

  .detailpage {
    margin-top: 0px;
  }
  .notification-message {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 16.34px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
      border: 1px solid  #d3d3d3;
      border-radius: 4px;
      background-color: #d3d3d3;
      padding: 10px;
      color: black;
      text-align: center;
      max-width: 400px;
      margin: 10px auto;
  }

  .mtop20 {
    margin-top: 30px;
  }

  #detailproduct .carousel-item {
    height: 32em;
  }

  .sharebtns.f22 {
    font-size: 22px;
    cursor: pointer;
  }

  .ebsDiscountMsg {
    border-radius: 4px;
    color: #58595b;
    font-size: 16px;
    float: right;
    display: block;
    width: 100%;
  }
  .ebsDiscountMsg:hover {
    text-decoration: underline;
  }
  .ebsDiscountMsg .exclusive-price {
    color: #3498db;
  }

  .psquarebox {
    width: 100%;
    height: 0;
    padding-top: 100%;
    background: #ccc;
    position: relative;
  }

  .outstock .disableclick {
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    height: 100%;
    z-index: 999;
    font-size: 28px;
    color: #999696;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 300;
  }

  .strikethrough {
    position: relative;
  }
  .strikethrough:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;

    -webkit-transform:rotate(-25deg);
    -moz-transform:rotate(-25deg);
    -ms-transform:rotate(-25deg);
    -o-transform:rotate(-25deg);
    transform:rotate(-25deg);
  }

  .outstock label {
    opacity: 0.5;
  }

  .productinfo {
    float: initial;
  }

  .type-name-input{
    width: 100%;
    position: relative;
  }

  .greentTick {
    width: 30px;
    position: absolute;
    right: 13px;
    top: 4px;
  }

  .numberInput {
    position: relative;
  }

  .greentTickForNumber {
    width: 30px;
    position: absolute;
    right: 4px;
    top: 5px;
  }

  .additional-charge {
    font-size: 12px;
    margin-bottom: 0px;
    color:#a7a9ac;
  }
  .preview-sample {
    color: #346fb1;
    text-decoration: underline;
    font-size: 12px;
    white-space: nowrap;
  }
  .cartSetPrintName {
    margin-top: 5px;
  }
  .customize-text {
    width: 78%;
  }
  .customize-text .customize-text-content {
    background: #f5f5f5;
    border-radius: 5px;
  }
  .customize-details {
    display: inline-grid;
  }
  .cartSetPrintName .form-control {
    border-radius: 7px;
  }
  .cartSetPrintName .form-control::placeholder {
    font-style: italic;
    font-size: 14px;
  }
  .customize-text {
    border: 1px solid lightgray;
    border-radius: 5px;
  }
  .customize-text .customcheckbox label {
    margin-bottom: 0px;
  }
  .customize-text .customcheckbox [type="checkbox"]:checked + label:before {
    background: #117a7a;
  }
  .customize-text .customcheckbox [type="checkbox"]:checked + label:after {
    color: #fff;
    content: '\f14a';
  }

  .price-box-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .customcheckbox [type="checkbox"]:not(:checked) + label,
  .customcheckbox [type="checkbox"]:checked + label,
  .customradio [type="radio"]:not(:checked) + label,
  .customradio [type="radio"]:checked + label {
    position: relative;
    padding-left: 1.25em;
    cursor: pointer;
  }

  .customize-text .customcheckbox [type="checkbox"]:checked + label:after{
    content: '';
    display: block;
    left: 6px;
    width: 7px;
    height: 13px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(50deg);
  }
  .print-error {
    margin-top: 10px;
  }
  .newbread {
    margin-top: 0;
    padding: 15px 0;
  }

  .total-stock {
    color: #282d3f;
    font-weight: 700;
    font-size: 15px;
  }

  .total-size-based-stock {
    color: #282d3f;
    border-radius: 4px;
    background-color: #ededed;
    position: absolute;
    margin: 0px;
    line-height: 18px;
    z-index: 999;
  }

  .sizelist li {
    margin: 10px 8px 8px 0px !important;
  }
  .color-list-container-old {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    max-width: 100%; 
    scrollbar-width: thin;
  }
  .color-list-container {
    display: flex;
    flex-wrap: wrap;
    /* overflow-x: auto;
    white-space: nowrap; */
    /* max-width: 100%;  */
    /* scrollbar-width: thin; */
  }
  /* .view-more-data {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Lato', sans-serif;
    color: #000000;
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    text-align: center;
  } */
  .sold-out-text {
    min-height: 90px;
    position: absolute;
    color: #D61914;
    font-family: "Source Sans Pro";
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 10px */
    letter-spacing: 0.5px;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 5px;
  }
  .color-list-container .color-parent {
    flex-shrink: 0;
    display: inline-flex;
    margin: 10px 8px 8px 0px;
    width: 76px;
    min-height: 90px;
    height: auto;
    border-radius: 5px;
  }

   .color-list-container .color-parent img{
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 5px;
   }
  .color-list-container .color-parent.active {
    border: 1px solid #000000;
    padding: 1.5px;
  }

  .color-list-container .new-img-pallet.active {
    border: 2px solid #05595A !important;
  }

  .additional-note {
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    line-height: 13px;
    color: #292b2c;
  }
  .color-list-container .color-child {
    width: 100%;
    height: 100%;
    border: 0.3px solid #c8c9cf;
    border-radius: 5px;
    cursor: pointer;
  }
  .image-wrapper {
    position: relative;
    overflow: hidden;
  }

  .color-list-container-old .color-parent {
    flex-shrink: 0;
    display: inline-flex;
    margin: 10px 8px 8px 0px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    border: 2px solid transparent;
  }

  .color-list-container-pld .color-parent.active {
    border-color:#53545b;
  }
  .color-list-container-old .color-child {
    width: 100%;
    height: 100%;
    border: 1px solid #a2a3ab;
    border-radius: 5px;
    cursor: pointer;
  }

  .hover-color-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    opacity: 0;
    transition: height 0.4s ease, opacity 0.4s ease;
    pointer-events: none;
    z-index: 2;
  }

  /* On hover: show color from bottom fading up */
  .image-wrapper:hover .hover-color-overlay {
    height: 20%;
    opacity: 1;
  }

  .oval {
    min-width: 50px;
    width: auto;
    height: 35px;
    padding: 0 10px;
    border-radius: 5px;
    /* Tranform Oval To Square */
  }
  .sizelist li input[type="radio"] + label {
    line-height:  32px;
  }

  .unselectedSize {
    border: 2px #b3b3b3 solid;
  }

  .selectedSize {
    border: 2px #117a7a solid;
  }

  .autoHeight {
    height: auto;
  }

  .voteNowStyles {
    color: #e76a52;
    text-decoration: underline;
  }

  .colorsListMob {
    margin: 0px;
    height: auto;
    padding: 5px 0px;
    white-space: nowrap;
    overflow: scroll;
  }

  .colorsListMob li {
    margin-bottom: 0px;
    display: inline-block;
    padding: 0px 0px;
    width: 35px;
    height: 35px;
    text-align: center;
    margin-right: 8px;
    border-radius: 50%;
    cursor: pointer;
  }

  .colorsList {
    margin: 0px;
    overflow: hidden;
    position: relative;
  }

  .colorsList li {
    margin-bottom: 0px;
    display: inline-block;
    padding: 0px 0px;
    overflow: hidden;
    text-align: center;
    margin-right: 8px;
    border-radius: 50%;
    cursor: pointer;
  }

  .color-size-wrapper {
    position: absolute;
  }

  .CartsetQty input {
    height: 30px;
  }

  .exclusive-bar {
    background-color: #3498db;
    color: #fff;
    padding: 10px;
  }

  .exclusive-bar.red-bg {
    background-color: #ed2d2f;
  }

  .exclusive-bar .customcheckbox [type="checkbox"]:not(:checked) + label:before,
  .exclusive-bar .customcheckbox [type="checkbox"]:checked + label:before {
    height: 1em;
    width: 1em;
  }

  .exclusive-bar .customcheckbox {
    line-height: 1.2;
  }

  .offers {
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
    border-left: 2px solid #117a7a;
    color: #333333;
    background: #f7f7f7;
    padding: 16px;
    margin: 32px 0px;
  }
  .offers__header {
    display: inline;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 600;
    font-size: 18px;
    margin: 24px 0;
    text-transform: uppercase;
  }
  .offers__icon {
    vertical-align: text-bottom;
    margin-left: 4px;
  }
  .offers__icon > img {
    width: 14px;
  }
  .offer-message {
    list-style: none;
    margin: 24px 0;
  }
  .membership-product-price-nonmember{
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: -0.02em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  .accordiontabs .card-header {
    padding: 0;
  }

  .accordiontabs .card-header a {
    padding: 15px;
  }

  .accordiontabs h5 a[aria-expanded="false"]:before, .accordiontabs h5 a[aria-expanded="true"]:before {
    right: 12px;
    top: 12px;
  }

  .accordiontabs h5 a[aria-expanded="true"]:before {
  }

  #iswishlist.fa-heart:before {
    color: #ed2d2f !important;
  }

  .select-color-header {
    margin: 5px 0px;
  }

  .productAdded {
    position: fixed;
    top: 50px;
    background: #ed2d2f;
    width: 240px;
    padding: 10px;
    z-index: 99;
    right: 10px;
    visibility: hidden;
    opacity: 0;
    transition: all 1s ease-out;
    color: #fff;
  }

  .productAdded.active {
    visibility: visible;
    opacity: 1;
    top: 85px;
    transition: all .5s ease-in
  }

  .addText {
    font-size: 15px;
  }
  .addCharges {
    font-size: 12px;
    color:#cb9b10;
    font-style: italic;
    font-weight: 600;
  }
  .addBtn {
    text-transform: uppercase;
    line-height: 10px;
    padding: 0px;
    width: 60px;
    height: 30px;
  }

  .mdproduct {
    margin-bottom: 20px;
  }

  .video-slider {
    background: black;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .delivery-details-txt {
    font-size: 16px;
    color: #282d3f;
    font-weight: 600;
    text-transform: capitalize;
  }
  .pincode-btn-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding: .3rem;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pincode-input-wrapper {
    position: relative;
    font-size: 16px;
  }
  .pincode-input-wrapper input:focus {
    outline: none;
    border-color: lightgray;
  }
  .pincode-input-wrapper input {
    border-radius: 6px;
  }
  .btn-pincode{
    background-color: transparent;
    border: unset;
    color: #148c8d;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 15px;
    outline: none;
}
.error-message{
  color: red
}
.delivery-details-content {
  color: black;
  font-size: 15px;
}
.cod-message-text-wrapper {
      display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0px;
    gap: 10px;
    font-size: 14px;
}
.cod-message-text-wrapper p{
  margin-bottom: unset;
}
  .expand {
    position: absolute;
    bottom: 10px;
    right: 10px;
    border-radius: 50%;
    width: 30px;
    padding: 0px 0px 2px 0px;
    height: 30px;
    z-index: 100;
    border: none;
    background: white;
  }

  .expand:focus {
    outline: none;
  }

  .return-and-tss-message-box {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
    padding: 0px 10px;
  }
  .return-msg-pdp {
    padding: 8px 5px;
    border: 1px solid #0d000000;
    font-size: 13px;
  }
  .customised-faqs .custaccordian .card-header a{
    color: #282d3f !important;
    font-size: 13px;
  }
  .tss-points-message-pdp {
    gap: 10px;
    font-size: 15px;
  }
  .tss-vote-icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  .tss-points-icon {
    width: 30px;
    height: 30px;
  }
  .tss-points-message-pdp p {
    margin-bottom: unset;
  }
  .tss-points-message-pdp .tss-points {
    color: #148c8d;
  }

  .return-icon-pdp {
    margin-right: 5px;
  }

  .selectcolor {
    text-decoration: underline;
  }

  .image-wrapper {
    position: relative;
  }

  .image-wrapper__product-status {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 700;
    font-size: 18px;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .image-wrapper__product-status p {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    color: #ffffff;
    margin: 0;
    padding: 0;
  }
  .image-wrapper__product-status p:first-child {
    text-transform: uppercase;
  }

  .imgLink {
    position: relative;
    display: block;
  }
  .imgLink::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: rgba(0,0,0, .65);
    top: 0;
  }

  .btnRow{
    display: flex;
  }

  .btnRow .btnWidth{
    width: 229px;
    margin-right: 10px;
  }
  .btnRow .mr0{
    margin-right: 0px;
  }

  .wishList_Btn{
    width: 147px;
    height: 38px;
    object-fit: contain;
    border-radius: 2px;
    border: solid 1px #148c8d;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #148c8d;
    text-transform: uppercase;
    padding: 0;
  }
  .membership_Btn {
    height: 30px;
    object-fit: contain;
    border-radius: 5px;
    border: solid 1px #148c8d;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #148c8d;
    text-transform: uppercase;
    padding: 0;
  }
  .membership_Btn_text {
    padding: 10px;
  }

  .outOfStockBox {
    position: relative;
  }
  .stockButton {
    border-radius: 0;
    background-color: #a5a5a5 !important;
    color: #ffffff;
    text-transform: uppercase;
  }
  .snapmint-wrapper {
    margin: -15px 0 20px;
  }
  /* for desktop view only */
  @media only screen and (min-width: 768px) {
    .forDesktop {
      display: flex;
    }
    .forTabAndMobile {
      display: none;
    }
    .fullWidth {
      padding: 0px 40px;
    }
    .new-design-btn {
      position: static;
    }
    .new-design-btn .mbstickyfooter {
      position: absolute;
      right: 40px;
      top: -5px;
    }
    .new-design-title {
      padding-right: 400px;
    }
    .new-design-delivery {
      display: flex;
      align-items: center;
    }
    .new-design-delivery .delivery-details-txt {
      margin-bottom: 0;
    }
    .new-design-delivery .pincode-input-wrapper {
      width: 220px;
      margin: 0 15px;
    }
    .new-design-delivery .delivery-details-content {
      display: flex;
      margin: 0;
    }
    .new-design-delivery .delivery-details-content .cod-message-text-wrapper {
      margin-left: 15px;
      padding: 0;
    }
    .new-design-size-error {
      width: 368px;
    }
  }
  @media only screen and (min-width: 400px) {
    .sizetext {
      font-size: 15px;
    }
    .total-size-based-stock {
      top: 33px;
      font-size: 12px;
      right: 0px;
    }
  }
  @media screen and (min-width: 1024px){
    .minProd {
      min-width: 281px;
    }
  }
  @media screen and (min-width: 1080px){
    .minProd {
      min-width: 318.13px;
    }
  }
 @media screen and (min-width: 1170px){
    .minProd {
      min-width: 345.5px;
    }
  }
  @media screen and (min-width: 1390px){
    .minProd {
      min-width: 410px;
    }
  }
  @media only screen and (max-width: 400px) {
    .shareIcon {
      font-size: 0.8rem;
    }
    .sizelist li {
      width: auto;
      height: fit-content;
      margin: 12px 10px 5px 0px !important;
      text-align: center;
    }
    .sizetext {
      font-size: 13px;
    }
    .total-size-based-stock {
      font-size: 9px;
      top: 30px;
      right: 0px;
    }
    .sizelist li input[type="radio"] + label {
      line-height: 28px;
    }
    .membership_action_Btn {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .membership_Btn {
      height: 42px !important;
      width: 300px;
      /* margin-left: 10%; */
    }
  }
  /* for mobile view only */
  @media only screen and (max-width: 768px) {
    .pdp-ticker {
      position: absolute;
      top: 92.5%;
      width: 100%;
      max-width: 768px;
      min-width: 360px;
      margin-top: 0px;
      height: 34px;
      background: rgba(0, 0, 0, 0.60);
      backdrop-filter: blur(2px);
    }

    .color-list-container {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      white-space: nowrap;
      max-width: 100%; 
      scrollbar-width: thin;
    }

    .pdp-ticker span {
      height: 15px;
      flex-shrink: 0;
      color: #FFF;
      text-align: center;
      font-family: "Open Sans";
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
    }
    .sizelist {
      overflow-x: hidden;
      padding-top: 0px;
    }
    .size-data-details {
      background: #ededed;
      -webkit-text-stroke: 0.35px #ededed;
      -webkit-font-smoothing: antialiased;
      width: fit-content;
      padding: 1px 3px;
      margin: 10px 0px 0px 0px;
    }
    .productlist {
      box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
      -webkit-box-shadow: 0 1.5px 2px rgb(0 0 0 / 20%);
    }
    .widget-heading {
      border-bottom: none;
      padding-bottom: 0 !important;
    }
    .wishlistBtnMobile {
      border: 1px solid rgba(0,0,0,.125);
      border-radius: 3px;
      background-color: transparent;
      appearance: none !important;
    }
    .shareIcon {
      text-decoration: underline;
      padding-left: 0 !important;
      padding-right: 0 !important;
      text-underline-offset: 3px;
    }
    .seperator {
      background: #f2f2f2;
      height: 1rem;
      margin-left: -10px;
      margin-right: -10px;
    }
    .seperatorExtra {
      margin-left: -26px !important;
      margin-right: -26px !important;
    }
    .bx1 {
      margin-bottom: 0;
    }
    .prod-cat{
      font-size: 13px;
    }
    .title-size {
      font-size: 1rem;
      -webkit-text-stroke: 0.3px #FFF;
      -webkit-font-smoothing: antialiased;
    }
    .combo-prod-name-wrapper{
      justify-content: space-between;
    }
    .wishList_Btn{
      display: none;
    }
    .btnRow .btnWidth.stockButton{
      background: #3c3c3c !important;
      margin-right: 0;
    }
    .btnRow .btnWidth{
      margin-right: 0;
    }
    .forDesktop {
      display: none;
    }
    .forTabAndMobile {
      min-height: 505px;
      display: block;
    }
    .video-slider {
      width:100%;
    }
    .select-size {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      color: #212121;
    }
    .wishList_Btn{
      width: 165px;
    }
    .membership_action_Btn {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .membership_Btn {
      height: 42px !important;
      width: 300px;
      /* margin-left: 10%; */
    }
    .btnRow .btnWidth{
      width: 100%;
    }
    .customization-wrapper .customise-heading {
      color: #282d3f;
      font-weight: normal;
    }
    .customization-wrapper .customise-price {
      font-size: 12px;
    }
    .customization-wrapper .customcheckbox [type="checkbox"]:not(:checked) + label:before,
    .customization-wrapper .customcheckbox [type="checkbox"]:checked + label:before {
      border: 1px solid #5eaba8;
        border-radius: 2px;
    }
    .customization-wrapper .customcheckbox [type="checkbox"]:not(:checked) + label:after,
    .customization-wrapper .customcheckbox [type="checkbox"]:checked + label:after {
      border: 1px solid #5eaba8;
    }
    .new-design-banner .round-share-icon {
      top: 24px;
      right: 20px;
    }
    .new-design-banner .round-back-icon {
      left: 20px;
    }
    .detailpage .seperator {
      height: auto;
      padding-bottom: 0 !important;
    }
    .newdesign-pricebox-fixed {
      position: fixed;
      bottom: 58px;
      left: 0;
      width: 100%;
      padding: 15px 10px 20px;
      z-index: 999;
      background-color: #fff;
    }
    .newdesign-pricebox-fixed .price-box-wrapper {
      margin-bottom: 0;
    }
    .newdesign-pricebox-fixed .price-box-wrapper + .snapmint-wrapper {
      margin-top: 5px;
    }
    .newdesign-pricebox {
      padding: 15px 0 20px;
      position: static;
    }
  }

  .inclusive-text {
    margin-top: 5px;
    font-size: 15px;
  }
  .offer {
    color: #212121;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 700;
  }
  .doodleban {
    padding: 0;
  }
  .countdown-timer {
    background: #d99b00;
    padding: 2px 0;
  }
  .live-text {
    text-align: center;
    font-size: 18px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    padding: 5px;
  }
  .countdown-timer.blue-eyes {
    background-color: #346fb1;
  }
  .souled-out {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.1);
  }
  .souled-out .text {
    background: rgba(237,46,48, 0.4);
    padding: 5px;
    width: 100%;
    display: block;
    position: absolute;
    top: 100px;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    height: 38px;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    font-size: 18px;
  }
  .tax-info {
    color: #a7a9ac;
    font-size: 14px;
  }
  .show-views {
    position: relative;
  }
  .show-blur {
    filter: blur(4px)
  }
  .viewer-count {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 16px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .coming-soon {
    background: green;
    color: #fff;
    position: absolute;
    text-transform: uppercase;
    top: 10px;
    padding: 5px 20px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .mockup-tag {
    position: absolute;
    text-transform: uppercase;
    top: 36px;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    width: 7.6rem;
    text-align: center;
  }
  .mockup-tag span {
    padding: 0px 6px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 100%;
  }
  .mockup-tag-top-left {
    top: 36px;
  }
  .mockup-tag-top-right {
    top: 36px;
    right: 0;
  }
  .mockup-tag-top-right span {
    border-radius: unset;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .mockup-tag-bottom-left {
    top: unset;
    bottom: 36px;
  }
  .mockup-tag-bottom-right {
    top: unset;
    bottom: 36px;
    right: 0;
  }
  .mockup-tag-bottom-right span {
    border-radius: unset;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .exclusivePrice{
    background-color: rgb(204 204 204 / 32%);
    padding: 5px 8px;
    width: 100%;
    display: inline-block;
  }

  .exclusivePrice p{
    margin: 0;
  }

  .exclusivePrice .knowLink{
    cursor: pointer;
    color: #148c8d;
    text-decoration: underline;
    font-weight: 600;
    float: right;
  }
  @media screen and (max-width: 991px) {
      .price-box-wrapper {
        align-items: flex-start;
      }
      .mbstickyfooter .btn {
        height: 100%;
      }
      .mbstickyfooter {
        z-index: 9999;
      }
      .customize-text {
        width:100%;
      }
      .exclusive-bar label {
        font-size: 14px;
      }
  }
  @media screen and (min-width: 768px) {
    .prod-attr-wrapper-mobile {
      display: none;
    }
  }

  @media screen and (min-width: 767px) {
    .fixedHeight {
      height: 40px;
    }

    .colorsList li {
      margin-top: 5px;
      width: 30px;
      height: 30px;
    }

    .less {
      right: 32.5px;
      bottom: 11px;
    }

    .more {
      right: 30px;
      top: 34px;
    }
  }

  @media screen and (min-width: 841px) {
    .fixedHeight {
      height: 45px;
    }

    .colorsList li {
      margin-top: 5px;
      width: 35px;
      height: 35px;
    }

    .less {
      right: 30px;
      bottom: 13px;
    }

    .more {
      right: 30px;
      top: 37px;
    }
  }


  @media screen and (min-width: 934px) {
    .fixedHeight {
      height: 50px;
    }

    .colorsList li {
      width: 40px;
      height: 40px;
    }

    .less {
      right: 35px;
      bottom: 16.5px;
    }

    .more {
      right: 35px;
      top: 38.5px;
    }
  }

  @media screen and (min-width: 991px) {
    .pr0 {
      padding-right: 0;
    }
    .ebsDiscountMsg {
      position: absolute;
      top: 32px;
      right: 0;
      text-align: right;
    }

    .less {
      right: 55px;
    }

    .more {
      right: 55px;
    }
  }
  @media screen and (max-width: 1100px) {
    .pdp-ticker span {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 950px) {
    .pdp-ticker span {
      font-size: 10px;
    }
  }
  @media screen and (max-width: 768px) {
    .pdp-ticker span {
      font-size: 12px;
    }
  }
  @media screen and (max-width: 380px) {
    .wishlistText {
      padding-right: 1.2rem;
      float: right;
      color: #000 !important;
      appearance: none !important;
    }
    .progress{
      width:42%;
    }
    .prg-text{
      width: 55%;
      display: inline-block;
      float: right;
    }
    .pdp-ticker {
      top: 93%;
    }
  }
  @media screen and (min-width: 1200px) {
    .less {
      right: 140px;
    }

    .more {
      right: 140px;
    }
  }
  @media screen and (min-width: 2560px) {
    .customize-text {
      width: 49%;
    }
  }
  @media screen and (max-width: 1024px) {
    .customize-text {
      width: 96%;
    }
  }
  @media screen and (max-width: 768px) {
    .detailpage .forTabAndMobile .slider-1 .loaded{
        min-height:450px !important;
        max-width: 580px !important;

    }
    .customize-details {
        font-size: 10px
      }
    .customize-text {
      width:100%;
    }
    .wishlistIcon{
      text-align: center;
      top: 0;
      left: 18%;
    }
  }
  @media screen and (max-width: 767px) {
    .prod-attr-wrapper-desktop {
      display: none;
    }

    .prod-attr-wrapper-mobile {
      margin: 0px;
    }
  }

  @media screen and (max-width: 991px) {
    .leftPrice {
      float: left;
    }
    .error.sizevalid {
      display: block;
    }

    .productAdded.active {
      top: 50px;
    }

    #detailproduct .carousel-item {
      height: 26.5em;
    }

    .detailpage {
      padding-bottom: 0px;
    }

    .conbottom {
      margin-bottom: 0px;
    }

    .mb_mbo, .mb_mbo.mb15 {
      margin-bottom: 0;
    }

    .widget-heading {
      padding-bottom: 15px;
      margin: 15px 0;
    }

    #alsoavailable,
    #relatedProducts {
      padding: 0 10px;
    }
    .inclusive-text {
      margin: 0;
      font-size: 14px;
    }
    .live-text {
      font-size: 12px;
    }
    .souled-out .text {
      font-size: 14px;
      height: 32px;
    }
    .ebsDiscountMsg {
      width: 100%;
      display: block;
    }
    .ebsDiscountMsg.col-md,
    .tax-info.col-md {
      padding: 0 !important;
    }
    .tax-info {
      display: block;
      width: 100%;
      position: unset;
    }
    .viewer-count {
      top: 2px;
      right: 5px;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 767px) {
    .color-size-wrapper {
      display: none;
    }
    .mockup-tag {
      top: 39px;
    }
    .mockup-tag-top-left {
    top: 39px;
    }
    .mockup-tag-top-right {
      top: 39px;
      right: 0;
    }
    .mockup-tag-bottom-left {
      top: unset;
      bottom: 39px;
    }
    .mockup-tag-bottom-right {
      top: unset;
      bottom: 39px;
      right: 0;
    }
    .productdetails {
      box-sizing: border-box !important;
      overflow-x: hidden;
    }
    .ticker-point{
      padding: 10px 16px;
    }
    .ticker-text{
      font-size: 12px;
  }
  }

  @media screen and (max-width: 576px) {
    .customize-details {
      font-size: 14px
    }
    .pdp-ticker {
      max-width: 576px;
    }
    .image-wrapper__product-status {
      font-size: 14px;
    }
    .customization-wrapper .customized-input{
      padding: 10px 10px;
      background-color: #bee2df;
    }
    .movePopup-wrapper{
      left: 0;
      width: 100%;
      position: fixed;
      z-index: 9999;
      bottom: 59px;
      background: #fff;
      transition: 0.3s;
      max-height: 435px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .movePopupModalOverlay {
      background-color: rgba(0, 0, 0, 0.6);
      height: 100%;
      width: 100%;
      position: fixed;
      z-index: 9999;
      top: 0;
      right: 0;
      transition: 0.5s;
      overflow-x: hidden;
      overflow-y: hidden;
    }
  }
  @media screen and (max-width: 420px) {
    .label-container {
      position: absolute;
      bottom: 10px;
      right: 0;
    }
    .label-container span {
      font-size: 9px;
      border-radius: unset;
    }
    .label-container i {
      font-size: 10px;
    }
  }
  @media screen and (max-width: 374px) {
    .customize-details {
      font-size: 13px
    }
  }

  @media screen and (max-width: 355px) {
    .customize-details {
      font-size: 11px
    }
    .exclusivePrice .knowLink{
      font-size: 11px;
    }
    .progress{
      width:41%;
    }
    .prg-text{
      width: 56%;
    }
  }

  .product-image-container {
    position: relative;
    text-align: center;
  }

  .product-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .fade-in-out {
    animation: fadeInOut ease 3s infinite;
    -webkit-animation: fadeInOut ease 3s infinite;
    -moz-animation: fadeInOut ease 3s infinite;
    -o-animation: fadeInOut ease 3s infinite;
    -ms-animation: fadeInOut ease 3s infinite;
  }

  @keyframes fadeInOut{
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-o-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-ms-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
.new-design-banner {
  position: relative;
}
.round-share-icon {
  position: absolute;
  top: 40px;
  right: 38px;
  z-index: 9;
}
.round-share-icon img {
  width: 48px;
  height: 48px;
  cursor: pointer;
}
.round-back-icon {
  right: auto;
  left: 38px;
}
.new-design-share {
  position: absolute;
  right: 75px;
  top: 46px;
  z-index: 9;
}
.new-design-share.sharebtns {
  font-size: 34px;
}
.new-design-share.sharebtns a {
  font-size: 34px;
}
.new-design-tabs {
  background: #f9f9f9;
  margin-top: 22px;
}
.new-design-tabs .nav-pills {
  display: flex;
  padding: 0 22px;
}
.new-design-tabs .nav-item {
  text-align: center;
  flex: 1;
  position: relative;
}
.new-design-tabs .nav-item:after {
 height: 24px;
 width: 1px;
 display: inline-block;
 content: '';
 background: #AFB0B7;
 position: absolute;
 right: 0;
 top: 7px;
}
.new-design-tabs .nav-item:last-child:after {
  width: 0;
}
.new-design-tabs .nav-links {
  width: 100%;
  display: block;
  font-size: 16px;
  padding: 7px 0;
  border-bottom: 1px solid #AFB0B7;
  color: #282d3f;
}
.new-design-tabs .nav-links.active {
  border-color: transparent;
}
.new-design-tabs .tab-content .card-block {
  padding-left: 36px;
  padding-right: 36px;
}
.combo-select-size {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}
.mrp-slogan {
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  line-height: 13px;
  color: #888;
  padding-bottom: 10px;
}
.membership-product-price{
  background: linear-gradient(to right, #F4E9FD, #D8C0E9, #D6F1FE, #F2F1FE, #D9C1EA, #F8DEF4);
  padding: 4px;
  margin-right: 4px;
}
.non-membership-product-price{
  background: linear-gradient(to right, #F4E9FD, #D8C0E9, #D6F1FE, #F2F1FE, #D9C1EA, #F8DEF4);
  padding: 4px;
  margin-bottom: 40px;
}
.no-wrap {
  white-space: nowrap;
 }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .color-web-carousel button.VueCarousel-navigation-next, .color-web-carousel button.VueCarousel-navigation-prev {
    width: 35px;
    height: 35px;
    outline: none;
  }

  .color-web-carousel button.VueCarousel-navigation-next:before {
    right: 11px !important;
    top: 1px;
    color: #58595b;
    font-size: 30px;
  }

  .color-web-carousel button.VueCarousel-navigation-prev:before {
    left: 10px !important;
    top: 1px;
    color: #58595b;
    font-size: 30px;
  }


  .color-web-carousel button.VueCarousel-navigation-next:focus, .color-web-carousel button.VueCarousel-navigation-prev:focus {
    outline: none;
  }

  .color-web-carousel button.VueCarousel-navigation-next:hover, .color-web-carousel button.VueCarousel-navigation-prev:hover {
    /* background-color: #e6e6e6; */
  }
</style>



// WEBPACK FOOTER //
// productdetails.vue?d4928b20